import { __decorate, __metadata, __param } from 'tslib';
import { Component, ɵɵdefineInjectable, Injectable, InjectionToken, ɵɵinject, Inject, PLATFORM_ID, Renderer2, ViewChild, ElementRef, EventEmitter, Output, Input, ViewEncapsulation, HostListener, Directive, NgModule } from '@angular/core';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute, RouterModule, DefaultUrlSerializer } from '@angular/router';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { throwError, BehaviorSubject, Subject, Subscription, combineLatest, empty, ReplaySubject, of } from 'rxjs';
import { HttpHeaders, HttpErrorResponse, HttpParams, HttpClient, HttpClientModule, HTTP_INTERCEPTORS, HttpUrlEncodingCodec } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { catchError, filter, map, tap, takeUntil, shareReplay, finalize, switchMap, take } from 'rxjs/operators';
import { CookieService, CookieModule } from 'ngx-cookie';
import { ToastrService, ToastrModule } from 'ngx-toastr';
import { StoreModule, createAction } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from 'ngx-toastr';
import * as ɵngcc3 from '@angular/common/http';
import * as ɵngcc4 from 'ngx-cookie';
import * as ɵngcc5 from '@angular/router';
import * as ɵngcc6 from '@angular/forms';
import * as ɵngcc7 from '@ngx-translate/core';
import * as ɵngcc8 from 'ngx-bootstrap/accordion';
import * as ɵngcc9 from 'ngx-bootstrap/pagination';
import * as ɵngcc10 from 'ngx-bootstrap/tooltip';
import * as ɵngcc11 from 'ngx-bootstrap/datepicker';
import * as ɵngcc12 from 'ngx-bootstrap/dropdown';
import * as ɵngcc13 from 'ngx-bootstrap/tabs';
import * as ɵngcc14 from 'ngx-bootstrap/carousel';
import * as ɵngcc15 from 'ngx-bootstrap/collapse';
import * as ɵngcc16 from 'ngx-bootstrap/modal';
import * as ɵngcc17 from 'ngx-bootstrap/alert';
import * as ɵngcc18 from 'ngx-bootstrap/typeahead';
import * as ɵngcc19 from '@ngrx/store';
import * as ɵngcc20 from '@ngrx/effects';
import * as ɵngcc21 from '@ngrx/store-devtools';

function FooterComponent_address_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "address", 7);
    ɵngcc0.ɵɵelementStart(1, "strong", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "abbr", 9);
    ɵngcc0.ɵɵtext(4, "e:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelement(6, "br");
    ɵngcc0.ɵɵelementStart(7, "abbr", 10);
    ɵngcc0.ɵɵtext(8, "p:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tenantCountry_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(tenantCountry_r1.country);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", tenantCountry_r1.supportEmail, " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", tenantCountry_r1.supportPhoneNumber, " ");
} }
function LoginComponent_div_20_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 37);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate("Email/Username is required");
} }
function LoginComponent_div_20_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 38);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate("Email/Username is required");
} }
function LoginComponent_div_20_span_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 39);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate("Password is required");
} }
function LoginComponent_div_20_span_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 38);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate("Password is required");
} }
function LoginComponent_div_20_div_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 40);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r9.error);
} }
function LoginComponent_div_20_button_32_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 41);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "shell.login.submit"));
} }
function LoginComponent_div_20_button_33_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 41);
    ɵngcc0.ɵɵelement(1, "i", 42);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0", ɵngcc0.ɵɵpipeBind1(3, 1, "shell.login.wait"), "... ");
} }
const _c0 = function (a0) { return { "has-error": a0 }; };
function LoginComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "label", 15);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 16);
    ɵngcc0.ɵɵelementStart(6, "span", 17);
    ɵngcc0.ɵɵelement(7, "i", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "input", 19, 20);
    ɵngcc0.ɵɵlistener("ngModelChange", function LoginComponent_div_20_Template_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.loginCredentials.username = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, LoginComponent_div_20_span_10_Template, 2, 1, "span", 21);
    ɵngcc0.ɵɵtemplate(11, LoginComponent_div_20_span_11_Template, 2, 1, "span", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 14);
    ɵngcc0.ɵɵelementStart(13, "label", 23);
    ɵngcc0.ɵɵtext(14);
    ɵngcc0.ɵɵpipe(15, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 16);
    ɵngcc0.ɵɵelementStart(17, "span", 17);
    ɵngcc0.ɵɵelement(18, "i", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "input", 25, 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function LoginComponent_div_20_Template_input_ngModelChange_19_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.loginCredentials.password = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(21, LoginComponent_div_20_span_21_Template, 2, 1, "span", 27);
    ɵngcc0.ɵɵtemplate(22, LoginComponent_div_20_span_22_Template, 2, 1, "span", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 28);
    ɵngcc0.ɵɵtemplate(24, LoginComponent_div_20_div_24_Template, 2, 1, "div", 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "div", 30);
    ɵngcc0.ɵɵelementStart(26, "label", 31);
    ɵngcc0.ɵɵtext(27);
    ɵngcc0.ɵɵpipe(28, "translate");
    ɵngcc0.ɵɵelement(29, "input", 32);
    ɵngcc0.ɵɵelement(30, "span", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(31, "div", 30);
    ɵngcc0.ɵɵtemplate(32, LoginComponent_div_20_button_32_Template, 3, 3, "button", 34);
    ɵngcc0.ɵɵtemplate(33, LoginComponent_div_20_button_33_Template, 4, 3, "button", 34);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(34, "div", 35);
    ɵngcc0.ɵɵelementStart(35, "small");
    ɵngcc0.ɵɵelement(36, "a", 36);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r3 = ɵngcc0.ɵɵreference(9);
    const _r6 = ɵngcc0.ɵɵreference(20);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(19);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(21, _c0, _r0.submitted && !_r3.valid));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 15, "shell.login.username"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.loginCredentials.username);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", _r0.submitted && !_r3.valid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", _r0.submitted && !_r3.valid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(23, _c0, _r0.submitted && !_r6.valid));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(15, 17, "shell.login.password"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.loginCredentials.password);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", _r0.submitted && !_r6.valid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", _r0.submitted && !_r6.valid);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.error);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(28, 19, "shell.login.rememberMe"), " ");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.loading);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("innerHTML", "Terms and conditions", ɵngcc0.ɵɵsanitizeHtml);
} }
const _c1 = function (a0) { return { "message-confirm": a0 }; };
function LoginComponent_div_21_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 49);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c1, ctx_r16.codeSent));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(": ", ctx_r16.codeSent ? " Sent!" : " ...Sending", "");
} }
function LoginComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 30);
    ɵngcc0.ɵɵelementStart(2, "label", 43);
    ɵngcc0.ɵɵtext(3, "Please enter the authentication code");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 16);
    ɵngcc0.ɵɵelementStart(5, "span", 17);
    ɵngcc0.ɵɵelement(6, "i", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "input", 44, 45);
    ɵngcc0.ɵɵlistener("ngModelChange", function LoginComponent_div_21_Template_input_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.loginCredentials.code = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "a", 46);
    ɵngcc0.ɵɵlistener("click", function LoginComponent_div_21_Template_a_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.resendCode(); });
    ɵngcc0.ɵɵtext(10, "Resend authentication code ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, LoginComponent_div_21_span_11_Template, 2, 4, "span", 47);
    ɵngcc0.ɵɵelementStart(12, "div", 30);
    ɵngcc0.ɵɵelementStart(13, "button", 48);
    ɵngcc0.ɵɵtext(14, "Log in");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.loginCredentials.code);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.codeSent !== null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r2.loginCredentials.code);
} }
const _c2 = ["headerLogoAnchor"];
function HeaderComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 4, 5);
    ɵngcc0.ɵɵtext(2, "Seamless");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("href", ctx_r0.logoLinkPath, ɵngcc0.ɵɵsanitizeUrl);
} }
function HeaderComponent_button_5_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 8);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ctx_r3.customer == null ? null : ctx_r3.customer.userDto == null ? null : ctx_r3.customer.userDto.imageUrl, ɵngcc0.ɵɵsanitizeUrl)("alt", (ctx_r3.customer == null ? null : ctx_r3.customer.userDto == null ? null : ctx_r3.customer.userDto.firstName) + " " + (ctx_r3.customer == null ? null : ctx_r3.customer.userDto == null ? null : ctx_r3.customer.userDto.lastName));
} }
const _c3 = function (a0, a1) { return { "active": a0, "showIcon": a1 }; };
function HeaderComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.toggle(ctx_r4.Layout.ACCOUNTS_DRAWER); });
    ɵngcc0.ɵɵtemplate(1, HeaderComponent_button_5_img_1_Template, 1, 2, "img", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(2, _c3, ctx_r1.accountDrawerIsActive, !(ctx_r1.customer == null ? null : ctx_r1.customer.userDto == null ? null : ctx_r1.customer.userDto.imageUrl)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.customer == null ? null : ctx_r1.customer.userDto == null ? null : ctx_r1.customer.userDto.imageUrl);
} }
const _c4 = function (a0, a1) { return { "active": a0, "notActive": a1 }; };
const _c5 = ["*"];
const _c6 = ["searchInput"];
const _c7 = function (a0) { return { "show": a0 }; };
function SidebarComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelement(1, "div", 6);
    ɵngcc0.ɵɵelementEnd();
} }
const _c8 = function (a0) { return { "open": a0 }; };
function SidebarComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵtemplate(2, SidebarComponent_div_0_div_2_Template, 2, 0, "div", 4);
    ɵngcc0.ɵɵprojection(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c8, ctx_r0.showSideNav));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isLoading);
} }
const _c9 = function (a0) { return { "visible": a0 }; };
function SidebarMenuComponent_accordion_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "seamless-sidebar-menu-item", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("sidebarItem", item_r5);
} }
function SidebarMenuComponent_accordion_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "accordion", 4);
    ɵngcc0.ɵɵtemplate(1, SidebarMenuComponent_accordion_1_ng_container_1_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("isAnimated", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.sidebarItems);
} }
function SidebarMenuComponent_accordion_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "seamless-sidebar-menu-item", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("sidebarItem", item_r7);
} }
function SidebarMenuComponent_accordion_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "accordion", 4);
    ɵngcc0.ɵɵtemplate(1, SidebarMenuComponent_accordion_3_ng_container_1_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("isAnimated", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.bottomItems);
} }
function SidebarMenuComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelement(1, "div", 8);
    ɵngcc0.ɵɵelementEnd();
} }
function PaginationSeamlessComponent_nav_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "nav", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "pagination", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function PaginationSeamlessComponent_nav_0_Template_pagination_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.currentPage = $event; })("pageChanged", function PaginationSeamlessComponent_nav_0_Template_pagination_pageChanged_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.changePage($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5, "Show");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "select", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function PaginationSeamlessComponent_nav_0_Template_select_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.pageSize = $event; })("change", function PaginationSeamlessComponent_nav_0_Template_select_change_6_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.changePageSize(); });
    ɵngcc0.ɵɵelementStart(7, "option");
    ɵngcc0.ɵɵtext(8, "12");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "option");
    ɵngcc0.ɵɵtext(10, "20");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "option");
    ɵngcc0.ɵɵtext(12, "50");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "option");
    ɵngcc0.ɵɵtext(14, "100");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "span");
    ɵngcc0.ɵɵtext(16, "per page");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("totalItems", ctx_r0.totalRecords)("itemsPerPage", ctx_r0.pageSize)("ngModel", ctx_r0.currentPage)("boundaryLinks", ctx_r0.showBoundaryLinks)("directionLinks", ctx_r0.showDirectionLinks)("maxSize", ctx_r0.maxSize)("rotate", ctx_r0.rotate)("previousText", ctx_r0.previousText)("nextText", ctx_r0.nextText)("firstText", ctx_r0.firstText)("lastText", ctx_r0.lastText);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.pageSize);
} }
function AccountDrawerComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelement(1, "img", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r0.profileImage, ɵngcc0.ɵɵsanitizeUrl)("alt", (ctx_r0.customer == null ? null : ctx_r0.customer.userDto == null ? null : ctx_r0.customer.userDto.firstName) + " " + (ctx_r0.customer == null ? null : ctx_r0.customer.userDto == null ? null : ctx_r0.customer.userDto.lastName));
} }
function AccountDrawerComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 12);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 13);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.customer == null ? null : ctx_r1.customer.userDto == null ? null : ctx_r1.customer.userDto.firstName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.customer == null ? null : ctx_r1.customer.userDto == null ? null : ctx_r1.customer.userDto.lastName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.customer == null ? null : ctx_r1.customer.userDto == null ? null : ctx_r1.customer.userDto.position);
} }
function PagerSeamlessComponent_nav_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "nav", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "pager", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function PagerSeamlessComponent_nav_0_Template_pager_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.currentPage = $event; })("pageChanged", function PagerSeamlessComponent_nav_0_Template_pager_pageChanged_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.changePage($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("totalItems", ctx_r0.totalItems)("itemsPerPage", ctx_r0.itemsPerPage)("ngModel", ctx_r0.currentPage)("boundaryLinks", ctx_r0.boundaryLinks)("directionLinks", ctx_r0.directionLinks)("maxSize", ctx_r0.maxSize)("rotate", ctx_r0.rotate)("previousText", ctx_r0.previousText)("nextText", ctx_r0.nextText)("firstText", ctx_r0.firstText)("lastText", ctx_r0.lastText)("pageBtnClass", ctx_r0.pageBtnClass);
} }
function BreadcrumbsComponent_ng_container_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", item_r1.label, " / ");
} }
const _c10 = function (a0) { return [a0]; };
function BreadcrumbsComponent_ng_container_2_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(2, _c10, item_r1.link));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", item_r1.label, " / ");
} }
function BreadcrumbsComponent_ng_container_2_ng_template_3_a_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("href", item_r1.link, ɵngcc0.ɵɵsanitizeUrl)("target", (item_r1 == null ? null : item_r1.newWindow) ? "_blank" : "_self");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", item_r1.label, " / ");
} }
function BreadcrumbsComponent_ng_container_2_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, BreadcrumbsComponent_ng_container_2_ng_template_3_a_0_Template, 2, 3, "a", 9);
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngIf", item_r1.link);
} }
function BreadcrumbsComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BreadcrumbsComponent_ng_container_2_span_1_Template, 2, 1, "span", 4);
    ɵngcc0.ɵɵtemplate(2, BreadcrumbsComponent_ng_container_2_a_2_Template, 2, 4, "a", 5);
    ɵngcc0.ɵɵtemplate(3, BreadcrumbsComponent_ng_container_2_ng_template_3_Template, 1, 1, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const _r4 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r1.link);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.link && item_r1.internal)("ngIfElse", _r4);
} }
function SidebarMenuItemComponent_a_0_i_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 5);
} }
const _c11 = function (a1, a2, a3) { return { "seamless": true, "unavailable": a1, "unclickable": a2, "selected": a3 }; };
function SidebarMenuItemComponent_a_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 2);
    ɵngcc0.ɵɵlistener("click", function SidebarMenuItemComponent_a_0_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.navigate(); });
    ɵngcc0.ɵɵelement(1, "i", 3);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "uppercase");
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵtemplate(6, SidebarMenuItemComponent_a_0_i_6_Template, 1, 0, "i", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r0.elementId)("ngClass", ɵngcc0.ɵɵpureFunction3(13, _c11, ctx_r0.sidebarItem.isUnavailable, ctx_r0.sidebarItem.isUnreachable, ctx_r0.menuItemSelected))("tooltip", ctx_r0.unreachableMessage)("isDisabled", !ctx_r0.sidebarItem.isUnreachable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.sidebarItem.iconName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.sidebarItem.parentName === null ? ɵngcc0.ɵɵpipeBind1(3, 7, ɵngcc0.ɵɵpipeBind1(4, 9, ctx_r0.sidebarItem.translationKey)) : ɵngcc0.ɵɵpipeBind1(5, 11, ctx_r0.sidebarItem.translationKey), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.sidebarItem.isLocked);
} }
function SidebarMenuItemComponent_ng_template_1_seamless_sidebar_menu_item_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "seamless-sidebar-menu-item", 9);
} if (rf & 2) {
    const childItem_r7 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("sidebarItem", childItem_r7);
} }
function SidebarMenuItemComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "accordion-group", 6);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelement(2, "i", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "uppercase");
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, SidebarMenuItemComponent_ng_template_1_seamless_sidebar_menu_item_7_Template, 1, 1, "seamless-sidebar-menu-item", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r2.elementId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.sidebarItem.iconName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.sidebarItem.parentName === null ? ɵngcc0.ɵɵpipeBind1(4, 4, ɵngcc0.ɵɵpipeBind1(5, 6, ctx_r2.sidebarItem.translationKey)) : ɵngcc0.ɵɵpipeBind1(6, 8, ctx_r2.sidebarItem.translationKey), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.sidebarItem.children);
} }
let FooterComponent = class FooterComponent {
    constructor() {
        this.tenantCountries = new Array();
        this.tenantCountries.push({
            country: 'Australia',
            supportPhoneNumber: '1300 728 800',
            supportEmail: 'support@carsales.net.au'
        });
        this.tenantCountries.push({
            country: 'New Zealand',
            supportPhoneNumber: '0800 366 848',
            supportEmail: 'support@carsales.net.au'
        });
    }
    ngOnInit() { }
};
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(); };
FooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FooterComponent, selectors: [["seamless-footer"]], decls: 12, vars: 1, consts: [[1, "container-fluid", "footer"], [1, "footer__support"], [1, "footer__title"], ["class", "footer__address", 4, "ngFor", "ngForOf"], [1, "footer_links"], ["href", "https://portal.datamotive.com.au/privacy", "target", "_blank", 1, "footer__link"], ["href", "https://portal.datamotive.com.au/static/terms-and-conditions-25-09-15-rev.pdf", "target", "_blank", 1, "footer__link"], [1, "footer__address"], [1, "footer__country"], ["title", "email", 1, "footer__abbr"], ["title", "phone", 1, "footer__abbr"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "footer", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "strong", 2);
        ɵngcc0.ɵɵtext(3, "Support");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, FooterComponent_address_4_Template, 10, 3, "address", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "strong", 2);
        ɵngcc0.ɵɵtext(7, "Legal");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "a", 5);
        ɵngcc0.ɵɵtext(9, "Privacy policy");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "a", 6);
        ɵngcc0.ɵɵtext(11, "Terms & conditions");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tenantCountries);
    } }, directives: [ɵngcc1.NgForOf], styles: ["[_nghost-%COMP%]{text-align:center;display:block;width:100%;margin-top:30px;padding-top:15px;padding-bottom:150px;transition:.3s cubic-bezier(.77,0,.175,1);border-top:1px solid #dbdbdb;overflow:hidden;position:relative;background-color:#f2f2f2}.max[_nghost-%COMP%]{padding-left:0;z-index:1051}.footer__title[_ngcontent-%COMP%]{color:#5d5d5d;font-size:12px;display:block}.footer__country[_ngcontent-%COMP%]{display:block;font-weight:600}.footer__address[_ngcontent-%COMP%]{text-align:center;font-size:12px;margin-bottom:0}.footer__link[_ngcontent-%COMP%]{font-size:12px;display:block}@media (min-width:992px){[_nghost-%COMP%]{text-align:left;padding-left:250px;padding-bottom:15px}.footer__links[_ngcontent-%COMP%], .footer__support[_ngcontent-%COMP%]{float:left}.footer__address[_ngcontent-%COMP%]{text-align:left;float:left;margin-right:15px}}"] });
FooterComponent = __decorate([ __metadata("design:paramtypes", [])
], FooterComponent);

class LoginCredentials {
    /**
     *
     */
    constructor(username, password, code, ipAddress) {
        this.username = username;
        this.password = password;
        this.code = code;
        this.ipAddress = ipAddress;
    }
}

var MemberType;
(function (MemberType) {
    MemberType[MemberType["Membership"] = 1] = "Membership";
    MemberType[MemberType["ActiveDirectory"] = 2] = "ActiveDirectory";
    MemberType[MemberType["Portal"] = 3] = "Portal";
    MemberType[MemberType["AppraisalSolutions"] = 4] = "AppraisalSolutions";
    MemberType[MemberType["Saml"] = 5] = "Saml";
})(MemberType || (MemberType = {}));

let LocalStorageService = class LocalStorageService {
    constructor() {
        this.lsSupport = false;
        if (localStorage) {
            this.lsSupport = true;
        }
    }
    set(key, val) {
        if (typeof val !== 'undefined' && val !== null) {
            if (typeof val === 'object') {
                val = JSON.stringify(val);
            }
            if (this.lsSupport) {
                localStorage.setItem(key, val);
            }
            else {
                this.createCookie(key, val, 30);
            }
        }
        else {
            this.delete(key);
        }
    }
    get(key) {
        let data;
        if (typeof key !== 'undefined') {
            if (this.lsSupport) {
                data = localStorage.getItem(key);
            }
            else {
                data = this.readCookie(key);
            }
            try {
                data = JSON.parse(data);
            }
            catch (e) {
                data = data;
            }
            return data;
        }
    }
    delete(key) {
        if (this.lsSupport) {
            localStorage.removeItem(key);
        }
        else {
            this.createCookie(key, '', -1);
        }
    }
    readCookie(key) {
        const nameEQ = key + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }
    createCookie(key, value, exp) {
        const date = new Date();
        date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
        const expires = '; expires=' + Date.toString;
        document.cookie = key + '=' + value + expires + '; path=/';
    }
    clearAllBut(excludeList) {
        Object.keys(localStorage).forEach((key) => {
            if (!excludeList.find((item) => {
                return item === key;
            })) {
                this.delete(key);
            }
        });
    }
};
LocalStorageService.ɵfac = function LocalStorageService_Factory(t) { return new (t || LocalStorageService)(); };
LocalStorageService.ɵprov = ɵɵdefineInjectable({ factory: function LocalStorageService_Factory() { return new LocalStorageService(); }, token: LocalStorageService, providedIn: "root" });
LocalStorageService = __decorate([ __metadata("design:paramtypes", [])
], LocalStorageService);

// TODO
// The following code is temporary and needs to be fleshed out with all seamless guys
let GlobalHttpService = class GlobalHttpService {
    constructor() {
        this.headers = new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json');
    }
    getHeaders() {
        return this.headers;
    }
    deleteHeaders() {
        this.headers = null;
    }
    appendHeader(name, value) {
        this.headers = new HttpHeaders()
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .set(name, value);
    }
};
GlobalHttpService.ɵfac = function GlobalHttpService_Factory(t) { return new (t || GlobalHttpService)(); };
GlobalHttpService.ɵprov = ɵɵdefineInjectable({ factory: function GlobalHttpService_Factory() { return new GlobalHttpService(); }, token: GlobalHttpService, providedIn: "root" });
GlobalHttpService = __decorate([ __metadata("design:paramtypes", [])
], GlobalHttpService);

const SEAMLESS_ENVIRONMENT = new InjectionToken('seamlessEnvironment');
const DEALER_DROPDOWN_SERVICE = new InjectionToken('DealerDropdownService token for DI');

class Environment {
    constructor() {
        this.seamless = new Seamless();
    }
}
class Seamless {
    constructor() {
        this.cookieOptions = {
            // domain: window.location.hostname,
            path: '/'
        };
        this.logoutRedirect = '/login';
        this.logoutRedirectUrlByRouter = false;
        this.experimental = new Experimental();
        this.api = new Api();
        this.logoPath = '/';
    }
}
var Environments;
(function (Environments) {
    Environments["Production"] = "production";
    Environments["Development"] = "development";
    Environments["UAT"] = "uat";
})(Environments || (Environments = {}));
var AppAvailabilityLevel;
(function (AppAvailabilityLevel) {
    AppAvailabilityLevel[AppAvailabilityLevel["All"] = 0] = "All";
    AppAvailabilityLevel[AppAvailabilityLevel["SingleDealers"] = 1] = "SingleDealers";
})(AppAvailabilityLevel || (AppAvailabilityLevel = {}));
var ApplicationType;
(function (ApplicationType) {
    ApplicationType[ApplicationType["Private"] = 0] = "Private";
    ApplicationType[ApplicationType["Public"] = 1] = "Public";
    ApplicationType[ApplicationType["Portal"] = 2] = "Portal";
})(ApplicationType || (ApplicationType = {}));
/**
 * Experimental Features
 */
class Experimental {
}
class Api {
    constructor() {
        this.base = undefined;
        this.auth = new AuthApi();
        this.image = 'https://carsales.pxcrush.net/carsales';
        this.customer = undefined;
        this.experience = undefined;
        this.subscriptionApiGateway = undefined;
        this.menu = undefined;
    }
}
class AuthApi {
}

class Mapper {
    static map(mapTo, mapFrom) {
        // map properties that match
        for (const key in mapTo) {
            if (mapTo.hasOwnProperty(key) && mapFrom) {
                if (mapFrom.hasOwnProperty(key)) {
                    mapTo[key] = mapFrom[key];
                }
            }
        }
        return mapTo;
    }
    static nullToUndefined(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                obj[key] = obj[key] === null ? undefined : obj[key];
            }
        }
        return obj;
    }
    static convertEmptyStringToNull(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                obj[key] = obj[key] === '' ? undefined : obj[key];
            }
        }
        return obj;
    }
}

const stripTrailingSlash = (str) => {
    if (!str) {
        return '';
    }
    // Prevent "/" from being stripped when it's the only char
    return str.length > 1 && str.endsWith('/') ? str.slice(0, -1) : str;
};

const stripLeadingSlash = (str) => {
    if (!str) {
        return '';
    }
    // Prevent "/" from being stripped when it's the only char
    return str.length > 1 && str.startsWith('/') ? str.slice(1) : str;
};

const convertRoutesToRegex = str => {
    const paths = str.split('/');
    let result = '';
    paths.forEach(element => {
        if (element.startsWith(':')) {
            result += '/' + '.+';
        }
        else {
            result += '/' + element;
        }
    });
    return result;
};

class Utilities {
}
Utilities.mapper = Mapper;
Utilities.stripTrailingSlash = stripTrailingSlash;
Utilities.stripLeadingSlash = stripLeadingSlash;
Utilities.convertRoutesToRegex = convertRoutesToRegex;

class NotificationType {
}
NotificationType.SUCCESS = 'success';
NotificationType.FAIL = 'fail';
NotificationType.WARNING = 'warning';
NotificationType.INFO = 'info';
class Notification {
    constructor(title, message, isRead = false) {
        this.title = title;
        this.message = message;
        this.isRead = isRead;
        this.type = NotificationType.INFO;
    }
}
class SuccessNotification extends Notification {
    constructor(title, message, isRead = false) {
        super(title, message, isRead);
        this.type = NotificationType.SUCCESS;
    }
}
class WarningNotification extends Notification {
    constructor(title, message, isRead = false) {
        super(title, message, isRead);
        this.type = NotificationType.WARNING;
    }
}
class FailedNotification extends Notification {
    constructor(title, message, isRead = false) {
        super(title, message, isRead);
        this.type = NotificationType.FAIL;
    }
}
class InfoNotification extends Notification {
    constructor(title, message, isRead = false) {
        super(title, message, isRead);
        this.type = NotificationType.INFO;
    }
}

let NotificationService = class NotificationService {
    constructor(_toastrService) {
        this._toastrService = _toastrService;
        this.newNotification = 0;
        this.notifications = new Array();
    }
    get() {
        return this.notifications.reverse();
    }
    getByIndex(index) {
        return this.notifications[index];
    }
    /** add notification to list and display with toast message */
    add(notification) {
        notification.isRead = false;
        this.notifications.unshift(notification);
        this.display(notification);
    }
    display(notification) {
        switch (notification.type) {
            case NotificationType.SUCCESS:
                this._toastrService.success(notification.message, notification.title);
                break;
            case NotificationType.WARNING:
                this._toastrService.warning(notification.message, notification.title);
                break;
            case NotificationType.FAIL:
                this._toastrService.error(notification.message, notification.title);
                break;
            case NotificationType.INFO:
                this._toastrService.info(notification.message, notification.title);
                break;
            default:
                this._toastrService.info(notification.message, notification.title);
                break;
        }
    }
    removeByIndex(index) {
        this.notifications.splice(index, 1);
    }
    setNotificationsAsRead() {
        for (const notification of this.notifications) {
            notification.isRead = true;
        }
    }
    getUnreadNotifications() {
        for (const notification of this.notifications) {
            if (!notification.isRead) {
                this.newNotification++;
            }
        }
        return this.newNotification;
    }
};
NotificationService.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(ɵngcc0.ɵɵinject(ɵngcc2.ToastrService)); };
NotificationService.ctorParameters = () => [
    { type: ToastrService }
];
NotificationService.ɵprov = ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(ɵɵinject(ToastrService)); }, token: NotificationService, providedIn: "root" });
NotificationService = __decorate([ __metadata("design:paramtypes", [ToastrService])
], NotificationService);

let ErrorHandlerService = class ErrorHandlerService {
    constructor(notificationService) {
        this.notificationService = notificationService;
    }
    handleError(error, message) {
        if (error instanceof HttpErrorResponse) {
            if (error.status === 500) {
                this.notificationService.display({
                    title: 'Error',
                    message: message || 'Service down, please try again later',
                    type: NotificationType.FAIL,
                    isRead: false
                });
            }
            if (error.status === 400) {
                this.notificationService.display({
                    title: 'Error',
                    message: message || 'Bad Request',
                    type: NotificationType.FAIL,
                    isRead: false
                });
            }
            if (error.status === 404) {
                this.notificationService.display({
                    title: 'Error',
                    message: message || 'Resource not found',
                    type: NotificationType.FAIL,
                    isRead: false
                });
            }
        }
        else {
            this.notificationService.display({
                title: 'Error',
                message: message || 'An error has occured',
                type: NotificationType.FAIL,
                isRead: false
            });
        }
        return throwError(error);
    }
};
ErrorHandlerService.ɵfac = function ErrorHandlerService_Factory(t) { return new (t || ErrorHandlerService)(ɵngcc0.ɵɵinject(NotificationService)); };
ErrorHandlerService.ctorParameters = () => [
    { type: NotificationService }
];
ErrorHandlerService.ɵprov = ɵɵdefineInjectable({ factory: function ErrorHandlerService_Factory() { return new ErrorHandlerService(ɵɵinject(NotificationService)); }, token: ErrorHandlerService, providedIn: "root" });
ErrorHandlerService = __decorate([ __metadata("design:paramtypes", [NotificationService])
], ErrorHandlerService);

let TradeAuthService = class TradeAuthService {
    constructor(http, errorHandlerService, environment) {
        this.http = http;
        this.errorHandlerService = errorHandlerService;
        this.environment = environment;
    }
    // Active Directory
    activeDirectory(request) {
        const apiPath = Utilities.stripTrailingSlash(this.environment.seamless.api.auth.private) + `/api/v2/ActiveDirectory`;
        return this.http
            .post(apiPath, request)
            .pipe(catchError(error => this.errorHandlerService.handleError(error)));
    }
    activeDirectoryRefresh(request) {
        const apiPath = Utilities.stripTrailingSlash(this.environment.seamless.api.auth.private) + `/api/v2/ActiveDirectory/refresh`;
        return this.http
            .post(apiPath, request)
            .pipe(catchError(error => this.errorHandlerService.handleError(error)));
    }
    // SAML
    samlRequest(samlInput) {
        const apiPath = Utilities.stripTrailingSlash(this.environment.seamless.api.auth.private) + `/api/v2/Saml/authnRequest`;
        return this.http.post(apiPath, samlInput);
    }
    getTokenBySsoReferenceGuid(referenceGuid) {
        const apiPath = Utilities.stripTrailingSlash(this.environment.seamless.api.auth.private) + `/api/v2/Token/sso/${referenceGuid}`;
        return this.http.get(apiPath).pipe(catchError(error => this.errorHandlerService.handleError(error)));
    }
    // Token
    token(request) {
        const apiPath = Utilities.stripTrailingSlash(this.environment.seamless.api.auth.public) + `/api/v2/Token`; // NOTE
        return this.http
            .post(apiPath, request)
            .pipe(catchError(error => this.errorHandlerService.handleError(error)));
    }
    tokenRefresh(request) {
        const apiPath = Utilities.stripTrailingSlash(this.environment.seamless.api.auth.public) + `/api/v2/Token/refresh`;
        return this.http
            .post(apiPath, request)
            .pipe(catchError(error => this.errorHandlerService.handleError(error)));
    }
    tokenRefreshV2(request) {
        const apiPath = Utilities.stripTrailingSlash(this.environment.seamless.api.base) + `/au/v2/token/refresh`; // NOTE
        return this.http
            .post(apiPath, request)
            .pipe(catchError(error => this.errorHandlerService.handleError(error)));
    }
    resendCode(membershipId) {
        const apiPath = Utilities.stripTrailingSlash(this.environment.seamless.api.auth.public) + `/api/v2/Token/resendcode/` + membershipId; // NOTE
        return this.http.get(apiPath).pipe(catchError(error => this.errorHandlerService.handleError(error)));
    }
    /**
     * Refresh token for users navigating from portal
     * Needs to be sent with AUTH header
     */
    statelessRefresh(product) {
        const apiPath = Utilities.stripTrailingSlash(this.environment.seamless.api.auth.portal) + `/${this.environment.seamless.tenant}/v1/tokens/refresh`;
        let params = new HttpParams();
        if (product) {
            params = params.set('product', product);
        }
        return this.http
            .get(apiPath, { params })
            .pipe(catchError(error => this.errorHandlerService.handleError(error)));
    }
    ssotokenRefresh(ssoReferenceGuid) {
        const apiPath = Utilities.stripTrailingSlash(this.environment.seamless.api.base) + `/au/v2/Token/sso/${ssoReferenceGuid}`;
        return this.http.get(apiPath).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
    }
    changeDealer(sellerGuid) {
        const apiPath = `${Utilities.stripTrailingSlash(this.environment.seamless.api.auth.portal)}/AU/v1/sellers/change`;
        const reqOptions = {
            params: { newSellerGuid: sellerGuid },
        };
        return this.http.get(apiPath, reqOptions);
    }
};
TradeAuthService.ɵfac = function TradeAuthService_Factory(t) { return new (t || TradeAuthService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(ErrorHandlerService), ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT)); };
TradeAuthService.ctorParameters = () => [
    { type: HttpClient },
    { type: ErrorHandlerService },
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] }
];
TradeAuthService.ɵprov = ɵɵdefineInjectable({ factory: function TradeAuthService_Factory() { return new TradeAuthService(ɵɵinject(HttpClient), ɵɵinject(ErrorHandlerService), ɵɵinject(SEAMLESS_ENVIRONMENT)); }, token: TradeAuthService, providedIn: "root" });
TradeAuthService = __decorate([ __param(2, Inject(SEAMLESS_ENVIRONMENT)),
    __metadata("design:paramtypes", [HttpClient,
        ErrorHandlerService,
        Environment])
], TradeAuthService);

// https://brianflove.com/2018/01/11/angular-window-provider/
/* Create a new injection token for injecting the window into a component. */
const WINDOW = new InjectionToken('WindowToken');
/* Define abstract class for obtaining reference to the global window object. */
class WindowRef {
    get nativeWindow() {
        throw new Error('Not implemented.');
    }
}
/* Define class that implements the abstract class and returns the native window object. */
let BrowserWindowRef = class BrowserWindowRef extends WindowRef {
    constructor() {
        super();
    }
    get nativeWindow() {
        return window;
    }
};
BrowserWindowRef.ɵfac = function BrowserWindowRef_Factory(t) { return new (t || BrowserWindowRef)(); };
BrowserWindowRef.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BrowserWindowRef, factory: BrowserWindowRef.ɵfac });
BrowserWindowRef = __decorate([ __metadata("design:paramtypes", [])
], BrowserWindowRef);
/* Create an factory function that returns the native window object. */
function windowFactory(browserWindowRef, platformId) {
    if (isPlatformBrowser(platformId)) {
        return browserWindowRef.nativeWindow;
    }
    return new Object();
}
/* Create a injectable provider for the WindowRef token that uses the BrowserWindowRef class. */
const browserWindowProvider = {
    provide: WindowRef,
    useClass: BrowserWindowRef
};
/* Create an injectable provider that uses the windowFactory function for returning the native window object. */
const windowProvider = {
    provide: WINDOW,
    useFactory: windowFactory,
    deps: [WindowRef, PLATFORM_ID]
};
/* Create an array of providers. */
const WINDOW_PROVIDERS = [browserWindowProvider, windowProvider];

var Layout;
(function (Layout) {
    Layout["MENU_DRAWER"] = "MENU_DRAWER";
    Layout["NOTIFICATION_DRAWER"] = "NOTIFICATION_DRAWER";
    Layout["ACCOUNTS_DRAWER"] = "ACCOUNTS_DRAWER";
    Layout["OTHER_DRAWER"] = "OTHER_DRAWER";
})(Layout || (Layout = {}));
let LayoutService = class LayoutService {
    constructor() {
        this.component = {
            [Layout.MENU_DRAWER]: new BehaviorSubject(false),
            [Layout.NOTIFICATION_DRAWER]: new BehaviorSubject(false),
            [Layout.ACCOUNTS_DRAWER]: new BehaviorSubject(false),
            [Layout.OTHER_DRAWER]: new BehaviorSubject(false)
        };
    }
    toggleState(component, state = null) {
        this.component[component].next(state !== null ? state : !this.component[component].value);
        this.closeAllBut(component);
    }
    getState(component) {
        return this.component[component].asObservable();
    }
    closeAllBut(componentToSkip = null) {
        for (const layout in this.component) {
            if (componentToSkip === layout) {
                continue;
            }
            this.component[layout].next(false);
        }
    }
};
LayoutService.ɵfac = function LayoutService_Factory(t) { return new (t || LayoutService)(); };
LayoutService.ɵprov = ɵɵdefineInjectable({ factory: function LayoutService_Factory() { return new LayoutService(); }, token: LayoutService, providedIn: "root" });
LayoutService = __decorate([ __metadata("design:paramtypes", [])
], LayoutService);

let StorageKeyService = class StorageKeyService {
    constructor(environment) {
        this.environment = environment;
        this.SIDEBAR_MENU = 'SIDEBAR_MENU';
        this.USER_DISPLAY_NAME = 'USER_DISPLAY_NAME';
        this.CURRENT_TRANSLATION = 'CURRENT_TRANSLATION';
        this.APP_VERSION = 'APP_VERSION';
        this.REFRESH_TOKEN = 'REFRESH_TOKEN';
        this.DEALER_SETTINGS = 'DEALER_SETTINGS';
        this.PRODUCT_PERMISSIONS = 'PRODUCT_PERMISSIONS';
        this.SELLER_GUID = 'SELLER_GUID';
        this.VISIBLE_DEALERS = 'VISIBLE_DEALERS';
        this.USER_IDENTIFIER = 'USER_IDENTIFIER';
        this.REDIRECT_URL = 'REDIRECT_URL';
        this.NETWORK_ID = 'NETWORK_ID';
        this.JWT_TOKEN = this.environment.seamless.applicationType === ApplicationType.Private ? 'ADMIN_TOKEN' : 'token';
    }
};
StorageKeyService.ɵfac = function StorageKeyService_Factory(t) { return new (t || StorageKeyService)(ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT)); };
StorageKeyService.ctorParameters = () => [
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] }
];
StorageKeyService.ɵprov = ɵɵdefineInjectable({ factory: function StorageKeyService_Factory() { return new StorageKeyService(ɵɵinject(SEAMLESS_ENVIRONMENT)); }, token: StorageKeyService, providedIn: "root" });
StorageKeyService = __decorate([ __param(0, Inject(SEAMLESS_ENVIRONMENT)),
    __metadata("design:paramtypes", [Environment])
], StorageKeyService);

let AuthenticationService = class AuthenticationService {
    constructor(cookieService, storageService, http, globalHttpService, router, tradeAuthService, route, layoutService, storageKeyService, localStorageService, environment, window) {
        this.cookieService = cookieService;
        this.storageService = storageService;
        this.http = http;
        this.globalHttpService = globalHttpService;
        this.router = router;
        this.tradeAuthService = tradeAuthService;
        this.route = route;
        this.layoutService = layoutService;
        this.storageKeyService = storageKeyService;
        this.localStorageService = localStorageService;
        this.environment = environment;
        this.window = window;
        this.route.queryParams.pipe(filter(params => params.token)).subscribe(params => {
            console.log(params);
            this.jwtTokenFromQueryString = params.token;
            console.log(this.jwtTokenFromQueryString);
            // fetch service
        });
        this.isLoggedIn = new BehaviorSubject(false);
        this.isLoggedIn.next(!!this.getToken());
        this.jwtHelper = new JwtHelperService();
        this.cookieOptions = this.environment.seamless.cookieOptions;
        this.window = window;
    }
    /**
     * return the decoded token
     */
    decodeToken(token) {
        const tk = token ? token : this.getToken();
        const decodedToken = this.jwtHelper.decodeToken(tk);
        return decodedToken;
    }
    /**
     * return the token from storage or cookie depends on the latest expiry date
     */
    getToken() {
        const jwtTokenFromCookie = this.cookieService.get(this.storageKeyService.JWT_TOKEN);
        const jwtTokenFromStorage = this.storageService.get(this.storageKeyService.JWT_TOKEN);
        if (!jwtTokenFromCookie && !jwtTokenFromStorage) {
            return null;
        }
        if (jwtTokenFromCookie !== undefined && jwtTokenFromCookie !== null) {
            return jwtTokenFromCookie;
        }
        if (jwtTokenFromStorage !== undefined && jwtTokenFromStorage !== null) {
            return jwtTokenFromStorage;
        }
    }
    samlRequest(samlInput) {
        return this.tradeAuthService.samlRequest(samlInput);
    }
    login(loginCredentials) {
        switch (this.environment.seamless.applicationType) {
            case ApplicationType.Private:
                return this.tradeAuthService.activeDirectory(loginCredentials);
            case ApplicationType.Public:
                return this.tradeAuthService.token(loginCredentials);
            default:
                return throwError('Application type not set');
        }
    }
    logout(clearAutogateToken = false) {
        // clear token remove user from local storage to log user out
        this.localStorageService.clearAllBut([this.storageKeyService.REDIRECT_URL]);
        this.removeAllCookiesExcept([{ key: 'deviceId', expiresUtc: new Date(new Date().setFullYear(new Date().getFullYear() + 10)) }]);
        this.globalHttpService.deleteHeaders();
        this.layoutService.closeAllBut();
        const currentUrl = this.window.location.href.split('?ssoReferenceGuid')[0];
        if (this.environment.seamless.logoutRedirectUrlByRouter === true) {
            this.isLoggedIn.next(false);
            this.router.navigate([this.environment.seamless.logoutRedirect], { queryParams: { ssoTarget: currentUrl } });
        }
        else if (this.environment.seamless.logoutRedirectUrlByRouter === false) {
            this.isLoggedIn.complete();
            if (clearAutogateToken) {
                this.window.location.href = `${this.environment.seamless.logoutRedirectWithTokenReset}`;
            }
            else {
                this.window.location.href = `${this.environment.seamless.logoutRedirect}?ssoTarget=${currentUrl}`;
            }
        }
        else {
            console.error('redirect not provided');
        }
    }
    removeAllCookiesExcept(excludedCookiesEntry) {
        const tempCookies = [];
        // extract existing cookie to be excluded
        if (excludedCookiesEntry && excludedCookiesEntry.length > 0) {
            for (let cookieKey of excludedCookiesEntry) {
                tempCookies.push({ cooKey: cookieKey.key, value: this.cookieService.get(cookieKey.key), expires: cookieKey.expiresUtc });
            }
        }
        let a = new Date().setFullYear(new Date().getFullYear() + 10);
        this.cookieService.removeAll(this.cookieOptions);
        // put back the cookie
        if (tempCookies && tempCookies.length > 0) {
            for (let cookieEntry of tempCookies) {
                const opt = Object.assign(Object.assign({}, this.cookieOptions), { expires: cookieEntry.expires });
                this.cookieService.put(cookieEntry.cooKey, cookieEntry.value, opt);
            }
        }
    }
    refreshToken() {
        // Check if the user type (AD, Public, Portal)
        // Check the MemberType when impersonating a user, ie, in public as private user
        if (this.environment.seamless.applicationType === ApplicationType.Private || this.MemberOfSystemId === MemberType.ActiveDirectory) {
            return this.tradeAuthService.activeDirectoryRefresh(JSON.parse(JSON.stringify({
                userIdentifier: this.decodeToken().UserIdentifier,
                refreshToken: this.decodeToken().RefreshToken,
                sellerGuid: this.decodeToken().SellerGuid
            })));
        }
        else if (this.MemberOfSystemId === MemberType.Saml) {
            console.log('private, SAML');
            const refreshToken = this.decodeToken().RefreshToken;
            const sellerGuid = this.localStorageService.get(this.storageKeyService.SELLER_GUID);
            const product = this.environment.seamless.product;
            const userIdentifier = this.decodeToken().UserIdentifier;
            const request = {
                userIdentifier,
                refreshToken,
                sellerGuid,
                product,
                isSamlLogin: true
            };
            return this.tradeAuthService.tokenRefresh(request);
        }
        else if (this.MemberOfSystemId === MemberType.Membership) {
            const sellerGuid = this.localStorageService.get(this.storageKeyService.SELLER_GUID);
            const request = {
                sellerGuid: sellerGuid,
                includeSsoReference: false
            };
            return this.tradeAuthService.tokenRefreshV2(request);
        }
        else if (this.MemberOfSystemId === MemberType.Portal) {
            const product = this.environment.seamless.product;
            return this.tradeAuthService.statelessRefresh(product);
        }
    }
    hasToken() {
        if (!this.getToken()) {
            return false;
        }
        return true;
    }
    tokenExpired() {
        if (this.hasToken() && this.decodeToken().Exp < Date.now() / 1000) {
            return true;
        } // JWT exp is in seconds not milliseconds, hence the / 1000
        return false;
    }
    getClientIp() {
        let apiPath;
        switch (this.environment.seamless.applicationType) {
            case ApplicationType.Private:
                apiPath = Utilities.stripTrailingSlash(this.environment.seamless.api.auth.private);
                break;
            case ApplicationType.Public:
                apiPath = Utilities.stripTrailingSlash(this.environment.seamless.api.auth.public);
                break;
            default:
                console.error('Application type not set');
        }
        return this.http.get(apiPath + '/api/v1/auth/ipaddress').pipe(map((response) => response.ipAddress));
    }
    // TODO: depcricate
    get MemberOfSystemId() {
        // Check if there is a JWT
        if (this.getToken()) {
            return Number(this.decodeToken().MemberOfSystemId);
        }
        else {
            return undefined;
        }
    }
    /**
     * This function is meant to replace 'changeDealer'. As well has hitting
     * /v1/sellers/change endpoint, it updates the users auth session storage (cookie etc)
     * @param sellerGuid string of what seller/dealer to change to
     * @returns Observable<IStatelessAuthenticationResponse>
     */
    changeCurrentDealer(args) {
        return this.tradeAuthService.changeDealer(args.sellerGuid).pipe(tap((res) => {
            this.updateSessionStorage(res.token);
        }));
    }
    reloadWindow(delayInMilliseconds = 0) {
        setTimeout(() => {
            this.window.location.reload();
        }, delayInMilliseconds);
    }
    updateSessionStorage(jwt) {
        this.cookieService.put(this.storageKeyService.JWT_TOKEN, jwt, this.cookieOptions);
        this.storageService.set(this.storageKeyService.JWT_TOKEN, jwt);
    }
};
AuthenticationService.ɵfac = function AuthenticationService_Factory(t) { return new (t || AuthenticationService)(ɵngcc0.ɵɵinject(ɵngcc4.CookieService), ɵngcc0.ɵɵinject(LocalStorageService), ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(GlobalHttpService), ɵngcc0.ɵɵinject(ɵngcc5.Router), ɵngcc0.ɵɵinject(TradeAuthService), ɵngcc0.ɵɵinject(ɵngcc5.ActivatedRoute), ɵngcc0.ɵɵinject(LayoutService), ɵngcc0.ɵɵinject(StorageKeyService), ɵngcc0.ɵɵinject(LocalStorageService), ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT), ɵngcc0.ɵɵinject(WINDOW)); };
AuthenticationService.ctorParameters = () => [
    { type: CookieService },
    { type: LocalStorageService },
    { type: HttpClient },
    { type: GlobalHttpService },
    { type: Router },
    { type: TradeAuthService },
    { type: ActivatedRoute },
    { type: LayoutService },
    { type: StorageKeyService },
    { type: LocalStorageService },
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [WINDOW,] }] }
];
AuthenticationService.ɵprov = ɵɵdefineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(ɵɵinject(CookieService), ɵɵinject(LocalStorageService), ɵɵinject(HttpClient), ɵɵinject(GlobalHttpService), ɵɵinject(Router), ɵɵinject(TradeAuthService), ɵɵinject(ActivatedRoute), ɵɵinject(LayoutService), ɵɵinject(StorageKeyService), ɵɵinject(LocalStorageService), ɵɵinject(SEAMLESS_ENVIRONMENT), ɵɵinject(WINDOW)); }, token: AuthenticationService, providedIn: "root" });
AuthenticationService = __decorate([ __param(10, Inject(SEAMLESS_ENVIRONMENT)),
    __param(11, Inject(WINDOW)),
    __metadata("design:paramtypes", [CookieService,
        LocalStorageService,
        HttpClient,
        GlobalHttpService,
        Router,
        TradeAuthService,
        ActivatedRoute,
        LayoutService,
        StorageKeyService,
        LocalStorageService,
        Environment, Object])
], AuthenticationService);

let LoginService = class LoginService {
    constructor(_authenticationService, environment, cookieService, _storageService, storageKeyService) {
        this._authenticationService = _authenticationService;
        this.environment = environment;
        this.cookieService = cookieService;
        this._storageService = _storageService;
        this.storageKeyService = storageKeyService;
        this.isLoading = new BehaviorSubject(false);
        this.loginScaffolding = (result) => {
            if (result) {
                this.cleanseStorage();
                this.updateLocalStorage(result.tokenSummary.token);
                this.cookieService.put(this.storageKeyService.JWT_TOKEN, result.tokenSummary.token, this.cookieOptions);
                this._authenticationService.isLoggedIn.next(true);
            }
            else {
                console.error('internal error, please try again');
                this._authenticationService.isLoggedIn.next(false);
            }
            // tslint:disable-next-line:semicolon
        };
        this.error = error => {
            console.error(error);
            this.isLoading.next(false);
            this._authenticationService.isLoggedIn.next(false);
            // tslint:disable-next-line:semicolon
        };
        this.loginCredentials = new LoginCredentials(null, null, null, null);
        this.cookieOptions = this.environment.seamless.cookieOptions;
        this.jwtHelper = new JwtHelperService();
    }
    samlRequest(samlInput) {
        let response = this._authenticationService.samlRequest(samlInput);
        return response;
    }
    login(loginCredentials = this.loginCredentials, next = this.loginScaffolding, error = this.error, complete = () => { }) {
        this.isLoading.next(true);
        this.loginCredentials = loginCredentials;
        this._authenticationService.getClientIp().subscribe((ipAddress) => {
            this.loginCredentials.ipAddress = ipAddress;
            this._authenticationService.login(this.loginCredentials).subscribe(next, error, complete);
        });
    }
    cleanseStorage() {
        // Ensure there is not a cookie with the same key but different domain
        const cookies = this.cookieService.getAll();
        Object.keys(cookies).forEach(key => {
            if (key === this.storageKeyService.JWT_TOKEN) {
                this.cookieService.remove(key, this.cookieOptions);
            }
        });
    }
    updateLocalStorage(token) {
        this._storageService.set(this.storageKeyService.JWT_TOKEN, token);
        this._storageService.set(this.storageKeyService.USER_IDENTIFIER, this.jwtHelper.decodeToken(token).UserIdentifier);
        this._storageService.set(this.storageKeyService.SELLER_GUID, this.jwtHelper.decodeToken(token).SellerGuid);
    }
};
LoginService.ɵfac = function LoginService_Factory(t) { return new (t || LoginService)(ɵngcc0.ɵɵinject(AuthenticationService), ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT), ɵngcc0.ɵɵinject(ɵngcc4.CookieService), ɵngcc0.ɵɵinject(LocalStorageService), ɵngcc0.ɵɵinject(StorageKeyService)); };
LoginService.ctorParameters = () => [
    { type: AuthenticationService },
    { type: undefined, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] },
    { type: CookieService },
    { type: LocalStorageService },
    { type: StorageKeyService }
];
LoginService.ɵprov = ɵɵdefineInjectable({ factory: function LoginService_Factory() { return new LoginService(ɵɵinject(AuthenticationService), ɵɵinject(SEAMLESS_ENVIRONMENT), ɵɵinject(CookieService), ɵɵinject(LocalStorageService), ɵɵinject(StorageKeyService)); }, token: LoginService, providedIn: "root" });
LoginService = __decorate([ __param(1, Inject(SEAMLESS_ENVIRONMENT)),
    __metadata("design:paramtypes", [AuthenticationService, Object, CookieService,
        LocalStorageService,
        StorageKeyService])
], LoginService);

let LoginComponent = class LoginComponent {
    constructor(_authenticationService, _router, loginService, tradeAuthService, localStorageService, environment, window, storageKeyService) {
        this._authenticationService = _authenticationService;
        this._router = _router;
        this.loginService = loginService;
        this.tradeAuthService = tradeAuthService;
        this.localStorageService = localStorageService;
        this.environment = environment;
        this.window = window;
        this.storageKeyService = storageKeyService;
        this.error = '';
        this.tfaRequired = false;
        this.codeSent = null;
        this.ngDestroy$ = new Subject();
        this.loginCredentials = new LoginCredentials(null, null, null, null);
        this.window = window;
    }
    ngOnInit() {
        // reset login status
        this._authenticationService.isLoggedIn.pipe(takeUntil(this.ngDestroy$)).subscribe(val => {
            console.log('val from log in status', val);
            if (val) {
                if (this.localStorageService.get(this.storageKeyService.REDIRECT_URL)) {
                    const redirectUrl = this.localStorageService.get(this.storageKeyService.REDIRECT_URL);
                    this.localStorageService.delete(this.storageKeyService.REDIRECT_URL);
                    this._router.navigate([redirectUrl]);
                }
            }
            else {
                this.window.location.href = `${this.environment.seamless.logoutRedirect}?ssoTarget=${this.window.location.href.replace('/login', '')}`;
            }
        });
        this.loginService.isLoading.pipe(takeUntil(this.ngDestroy$)).subscribe(loading => {
            this.loading = loading;
        });
    }
    ngOnDestroy() {
        this.ngDestroy$.next();
        this.ngDestroy$.complete();
    }
    login() {
        this.loginService.isLoading.next(true);
        this.error = '';
        this.loginService.login(this.loginCredentials, undefined, error => {
            this.loginService.isLoading.next(false);
            if (error.status === 401) {
                if (ApplicationType.Public && error.error) {
                    if (
                    // Check for Two Factor Authentication
                    error.error.membershipTokenResponse &&
                        error.error.membershipTokenResponse.message === '2FA code required') {
                        this.tfaRequired = true;
                    }
                    else if (
                    // Check if Account is disabled
                    error.error.error === 'Attempted to perform an unauthorized operation.') {
                        this.tfaRequired = false;
                        this.error = 'Account disabled';
                    }
                }
                else {
                    this.error = 'The username or password entered is incorrect';
                }
            }
            if (error.status === 403) {
                const patt = new RegExp('Account locked out');
                if (patt.test(error.error.membershipTokenResponse.message)) {
                    this.error = 'Account locked';
                }
                else {
                    this.error = 'The username or password entered is incorrect';
                }
            }
        }, () => {
            this.loginService.isLoading.next(false);
        });
    }
    resendCode() {
        this.codeSent = false;
        this.tradeAuthService
            .resendCode(this.localStorageService.get(this.storageKeyService.USER_IDENTIFIER))
            .subscribe(() => (this.codeSent = true));
    }
};
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(ɵngcc0.ɵɵdirectiveInject(AuthenticationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.Router), ɵngcc0.ɵɵdirectiveInject(LoginService), ɵngcc0.ɵɵdirectiveInject(TradeAuthService), ɵngcc0.ɵɵdirectiveInject(LocalStorageService), ɵngcc0.ɵɵdirectiveInject(SEAMLESS_ENVIRONMENT), ɵngcc0.ɵɵdirectiveInject(WINDOW), ɵngcc0.ɵɵdirectiveInject(StorageKeyService)); };
LoginComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LoginComponent, selectors: [["seamless-login"]], decls: 22, vars: 2, consts: [[1, "login"], [1, "login__panel"], [1, "container-fluid"], [1, "login__marketing"], [1, "login__logos"], ["src", "https://trade.csnstatic.com/OAG@3x.png", "alt", "", 1, "login__logo"], ["src", "https://trade.csnstatic.com/LM@3x.png", "alt", "", 1, "login__logo"], ["src", "https://trade.csnstatic.com/redbookIQ@3x@3x.png", "alt", "", 1, "login__logo"], [1, "login__blurb"], ["src", "https://trade.csnstatic.com/cscomltd@3x.png", "alt", ""], [1, "login__container"], ["name", "form", "novalidate", "", 1, "form", 3, "ngSubmit"], ["f", "ngForm"], [4, "ngIf"], [1, "form-group", 3, "ngClass"], ["for", "username", 1, "control-label", "sr-only"], [1, "input-group"], [1, "input-group-addon"], [1, "icon-person-lg"], ["type", "text", "id", "username", "name", "username", "placeholder", "username", "aria-describedby", "usernameStatus", "autofocus", "", "required", "", "autocomplete", "username", 1, "form-control", 3, "ngModel", "ngModelChange"], ["username", "ngModel"], ["class", "sr-only", 4, "ngIf"], ["class", "help-block", 4, "ngIf"], ["for", "password", 1, "control-label", "sr-only"], [1, "icon-lock-lg"], ["type", "password", "id", "password", "name", "password", "placeholder", "password", "aria-describedby", "passwordStatus", "required", "", "autocomplete", "current-password", 1, "form-control", 3, "ngModel", "ngModelChange"], ["password", "ngModel"], ["id", "passwordStatus", "class", "sr-only", 4, "ngIf"], [1, "text-center"], ["class", "login__error", 4, "ngIf"], [1, "form-group"], [1, "checkbox", "login__remember"], ["type", "checkbox", "checked", "checked", "value", "remember-me"], [1, "checkmark"], ["class", "btn btn-default", "type", "submit", 4, "ngIf"], [1, "form-group", "login__bottom"], ["href", "https://www.carsales.com.au/info/terms-conditions/", "target", "_blank", 1, "login__tandc", 3, "innerHTML"], [1, "sr-only"], [1, "help-block"], ["id", "passwordStatus", 1, "sr-only"], [1, "login__error"], ["type", "submit", 1, "btn", "btn-default"], [1, "fa", "fa-circle-o-notch", "fa-spin", "fa-fw"], ["for", "code", 1, "control-label"], ["type", "text", "id", "code", "name", "code", "placeholder", "", "aria-describedby", "", "required", "", "autocomplete", "one-time-code", 1, "form-control", 3, "ngModel", "ngModelChange"], ["tfaCode", "ngModel"], [1, "help-block", 3, "click"], ["class", "help-block", 3, "ngClass", 4, "ngIf"], ["type", "submit", 1, "btn", "btn-default", 3, "disabled"], [1, "help-block", 3, "ngClass"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        const _r20 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "ul", 4);
        ɵngcc0.ɵɵelementStart(5, "li");
        ɵngcc0.ɵɵelement(6, "img", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "li");
        ɵngcc0.ɵɵelement(8, "img", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "li");
        ɵngcc0.ɵɵelement(10, "img", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵelementStart(12, "span");
        ɵngcc0.ɵɵtext(13, "Software and insights for dealers, OEM and advertisers by");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(14, "img", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 10);
        ɵngcc0.ɵɵelementStart(16, "h1");
        ɵngcc0.ɵɵtext(17, "Sign In");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "form", 11, 12);
        ɵngcc0.ɵɵlistener("ngSubmit", function LoginComponent_Template_form_ngSubmit_18_listener() { ɵngcc0.ɵɵrestoreView(_r20); const _r0 = ɵngcc0.ɵɵreference(19); return _r0.form.valid && ctx.login(); });
        ɵngcc0.ɵɵtemplate(20, LoginComponent_div_20_Template, 37, 25, "div", 13);
        ɵngcc0.ɵɵtemplate(21, LoginComponent_div_21_Template, 15, 3, "div", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(20);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.tfaRequired);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tfaRequired);
    } }, directives: [ɵngcc6.ɵangular_packages_forms_forms_y, ɵngcc6.NgControlStatusGroup, ɵngcc6.NgForm, ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc6.DefaultValueAccessor, ɵngcc6.RequiredValidator, ɵngcc6.NgControlStatus, ɵngcc6.NgModel], pipes: [ɵngcc7.TranslatePipe], styles: [".login[_ngcontent-%COMP%]{overflow:hidden;padding:15px 0}.login[_ngcontent-%COMP%]   .container-fluid[_ngcontent-%COMP%]{max-width:1140px}.login[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{margin:0}.login[_ngcontent-%COMP%]   [class*=col-][_ngcontent-%COMP%]{padding:0}.login[_ngcontent-%COMP%]::before{content:\"\";background:linear-gradient(to right,#272e62 0,#007cc2 50%,#63cbe8 100%);position:absolute;top:0;left:0;right:0;bottom:0;z-index:1050}.login__panel[_ngcontent-%COMP%]{position:relative;z-index:1051;margin:0 auto}.login__marketing[_ngcontent-%COMP%]{position:relative;padding:30px;background-color:#f1f1f1}.login__logos[_ngcontent-%COMP%]{overflow:hidden;text-align:center;margin:0;padding:0}.login__logos[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{width:30%;display:inline-block;vertical-align:middle}.login__logo[_ngcontent-%COMP%]{display:block;float:left;width:80%}.login__blurb[_ngcontent-%COMP%]{margin-top:15px;text-align:center;width:100%}.login__blurb[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:block}.login__blurb[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:180px;margin:0 15px}.login__container[_ngcontent-%COMP%]{display:block;width:100%;padding:30px;margin:0 auto;background-color:#fff}.login__container[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:20px;line-height:28px;color:#4a4a4a;text-align:center;margin-top:0}.login__container[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]{margin:0 auto}.login__help-block[_ngcontent-%COMP%]{margin-top:0;margin-bottom:.5rem;color:#a94442}.login__remember[_ngcontent-%COMP%]{width:130px;margin:15px auto}.login__forgot[_ngcontent-%COMP%]{display:block;width:130px;margin:15px auto;text-align:center}.login__bottom[_ngcontent-%COMP%]{margin:30px 0 0}.login__sign-up[_ngcontent-%COMP%]{max-width:130px;font-size:15px;color:#ff7217;margin:0 auto;transition:.3s ease-out;display:block;width:100%;height:auto;line-height:24px;padding:0;font-weight:700;white-space:unset}.login__tandc[_ngcontent-%COMP%]{display:block;text-align:center;padding:10px 0}.login[_ngcontent-%COMP%]   button[type=submit][_ngcontent-%COMP%]{display:block;min-width:180px;margin:24px auto 0}.login__error[_ngcontent-%COMP%]{font-size:13px;color:#d0021b}@media (min-width:768px){.login[_ngcontent-%COMP%]{padding:60px}.login__container[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]{width:unset;max-width:320px}}@media (min-width:992px){.login[_ngcontent-%COMP%]{margin:0 auto}.login__marketing[_ngcontent-%COMP%]{float:left;min-height:510px;width:60%;padding:60px 30px}.login__logos[_ngcontent-%COMP%]{position:absolute;top:50%;transform:translateY(-50%)}.login__blurb[_ngcontent-%COMP%]{position:absolute;bottom:60px;left:50%;transform:translateX(-50%);margin-top:30px}.login__container[_ngcontent-%COMP%]{width:40%;min-height:510px;float:right;margin:0}.login__container[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]{width:unset;max-width:320px}}a.help-block[_ngcontent-%COMP%]{cursor:pointer}.help-block[_ngcontent-%COMP%]{display:inline-block}.message-confirm[_ngcontent-%COMP%]{color:#61b136}"] });
LoginComponent.ctorParameters = () => [
    { type: AuthenticationService },
    { type: Router },
    { type: LoginService },
    { type: TradeAuthService },
    { type: LocalStorageService },
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [WINDOW,] }] },
    { type: StorageKeyService }
];
LoginComponent = __decorate([ __param(5, Inject(SEAMLESS_ENVIRONMENT)),
    __param(6, Inject(WINDOW)),
    __metadata("design:paramtypes", [AuthenticationService,
        Router,
        LoginService,
        TradeAuthService,
        LocalStorageService,
        Environment, Object, StorageKeyService])
], LoginComponent);

let ForgotPasswordComponent = class ForgotPasswordComponent {
    constructor() { }
    ngOnInit() { }
};
ForgotPasswordComponent.ɵfac = function ForgotPasswordComponent_Factory(t) { return new (t || ForgotPasswordComponent)(); };
ForgotPasswordComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ForgotPasswordComponent, selectors: [["seamless-forgot-password"]], decls: 21, vars: 0, consts: [[1, "forgot-password"], [1, "forgot-password__panel"], [1, "container-fluid"], [1, "forgot-password__marketing"], [1, "forgot-password__logos"], ["src", "https://trade.csnstatic.com/OAG@3x.png", "alt", "", 1, "forgot-password__logo"], ["src", "https://trade.csnstatic.com/LM@3x.png", "alt", "", 1, "forgot-password__logo"], ["src", "https://trade.csnstatic.com/redbookIQ@3x@3x.png", "alt", "", 1, "forgot-password__logo"], [1, "forgot-password__blurb"], ["src", "https://trade.csnstatic.com/cscomltd@3x.png", "alt", ""], [1, "forgot-password__container"], ["name", "form", "novalidate", "", 1, "form"], [1, "form-group"]], template: function ForgotPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "ul", 4);
        ɵngcc0.ɵɵelementStart(5, "li");
        ɵngcc0.ɵɵelement(6, "img", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "li");
        ɵngcc0.ɵɵelement(8, "img", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "li");
        ɵngcc0.ɵɵelement(10, "img", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵelementStart(12, "span");
        ɵngcc0.ɵɵtext(13, "Software and insights for dealers, OEM and advertisers by");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(14, "img", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 10);
        ɵngcc0.ɵɵelementStart(16, "h1");
        ɵngcc0.ɵɵtext(17, "Forgot Password");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "form", 11);
        ɵngcc0.ɵɵelementStart(19, "div");
        ɵngcc0.ɵɵelement(20, "div", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, directives: [ɵngcc6.ɵangular_packages_forms_forms_y, ɵngcc6.NgControlStatusGroup, ɵngcc6.NgForm], styles: [".forgot-password[_ngcontent-%COMP%]{overflow:hidden;background:linear-gradient(to right,#272e62 0,#007cc2 50%,#63cbe8 100%);padding:15px 0}.forgot-password[_ngcontent-%COMP%]   .container-fluid[_ngcontent-%COMP%]{max-width:1140px}.forgot-password[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{margin:0}.forgot-password[_ngcontent-%COMP%]   [class*=col-][_ngcontent-%COMP%]{padding:0}.forgot-password__panel[_ngcontent-%COMP%]{position:relative;margin:0 auto}.forgot-password__marketing[_ngcontent-%COMP%]{position:relative;padding:30px;background-color:#f1f1f1}.forgot-password__logos[_ngcontent-%COMP%]{overflow:hidden;text-align:center;margin:0;padding:0}.forgot-password__logos[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{width:30%;display:inline-block}.forgot-password__logos[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:nth-child(2){position:relative;top:-9px}.forgot-password__logos[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:nth-child(3){position:relative;top:-16px}.forgot-password__logo[_ngcontent-%COMP%]{display:block;float:left;width:80%}.forgot-password__blurb[_ngcontent-%COMP%]{margin-top:15px;text-align:center;width:100%}.forgot-password__blurb[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:block}.forgot-password__blurb[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:180px;margin:0 15px}.forgot-password__container[_ngcontent-%COMP%]{display:block;width:100%;padding:30px;margin:0 auto;background-color:#fff}.forgot-password__container[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:20px;line-height:28px;color:#4a4a4a;text-align:center;margin-top:0}.forgot-password__container[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]{margin:0 auto}.forgot-password__help-block[_ngcontent-%COMP%]{margin-top:0;margin-bottom:.5rem;color:#a94442}.forgot-password__remember[_ngcontent-%COMP%]{width:130px;margin:15px auto}.forgot-password__forgot[_ngcontent-%COMP%]{display:block;width:130px;margin:15px auto;text-align:center}.forgot-password__bottom[_ngcontent-%COMP%]{margin:30px 0 0}.forgot-password__sign-up[_ngcontent-%COMP%]{max-width:130px;font-size:15px;color:#ff7217;margin:0 auto;transition:.3s ease-out;display:block;width:100%;height:auto;line-height:24px;padding:0;font-weight:700;white-space:unset}.forgot-password__tandc[_ngcontent-%COMP%]{display:block;text-align:center;padding:10px 0}.forgot-password[_ngcontent-%COMP%]   button[type=submit][_ngcontent-%COMP%]{display:block;min-width:180px;margin:24px auto 0}.forgot-password__error[_ngcontent-%COMP%]{font-size:13px;color:#d0021b}@media (min-width:768px){.forgot-password[_ngcontent-%COMP%]{padding:60px}.forgot-password__container[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]{width:unset;max-width:320px}}@media (min-width:992px){.forgot-password[_ngcontent-%COMP%]{margin:0 auto}.forgot-password__marketing[_ngcontent-%COMP%]{float:left;min-height:510px;width:60%;padding:60px 30px}.forgot-password__logos[_ngcontent-%COMP%]{position:absolute;top:50%;transform:translateY(-50%)}.forgot-password__blurb[_ngcontent-%COMP%]{position:absolute;bottom:60px;left:50%;transform:translateX(-50%);margin-top:30px}.forgot-password__container[_ngcontent-%COMP%]{width:40%;min-height:510px;float:right;margin:0}.forgot-password__container[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]{width:unset;max-width:320px}}"] });
ForgotPasswordComponent = __decorate([ __metadata("design:paramtypes", [])
], ForgotPasswordComponent);

let CustomerService = class CustomerService {
    constructor(http, errorHandlerService, environment) {
        this.http = http;
        this.errorHandlerService = errorHandlerService;
        this.environment = environment;
        this.customer$ = new BehaviorSubject(null);
    }
    getCustomer() {
        const apiPath = Utilities.stripTrailingSlash(this.environment.seamless.api.customer) + `/customer`;
        return this.http.get(apiPath).pipe(catchError(error => this.errorHandlerService.handleError(error)));
    }
};
CustomerService.ɵfac = function CustomerService_Factory(t) { return new (t || CustomerService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(ErrorHandlerService), ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT)); };
CustomerService.ctorParameters = () => [
    { type: HttpClient },
    { type: ErrorHandlerService },
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] }
];
CustomerService.ɵprov = ɵɵdefineInjectable({ factory: function CustomerService_Factory() { return new CustomerService(ɵɵinject(HttpClient), ɵɵinject(ErrorHandlerService), ɵɵinject(SEAMLESS_ENVIRONMENT)); }, token: CustomerService, providedIn: "root" });
CustomerService = __decorate([ __param(2, Inject(SEAMLESS_ENVIRONMENT)),
    __metadata("design:paramtypes", [HttpClient,
        ErrorHandlerService,
        Environment])
], CustomerService);

let HeaderService = class HeaderService {
    constructor(environment) {
        this.environment = environment;
        this._logoAssetPathOverride = new BehaviorSubject(null);
    }
    get logoAssetPathOverride() {
        return this._logoAssetPathOverride.asObservable();
    }
    updateLogoAssetPath(assetPath) {
        this._logoAssetPathOverride.next(assetPath);
    }
};
HeaderService.ɵfac = function HeaderService_Factory(t) { return new (t || HeaderService)(ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT)); };
HeaderService.ctorParameters = () => [
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] }
];
HeaderService.ɵprov = ɵɵdefineInjectable({ factory: function HeaderService_Factory() { return new HeaderService(ɵɵinject(SEAMLESS_ENVIRONMENT)); }, token: HeaderService, providedIn: "root" });
HeaderService = __decorate([ __param(0, Inject(SEAMLESS_ENVIRONMENT)),
    __metadata("design:paramtypes", [Environment])
], HeaderService);

let HeaderComponent = class HeaderComponent {
    constructor(authenticationService, layoutService, customerService, headerService, renderer, environment) {
        this.authenticationService = authenticationService;
        this.layoutService = layoutService;
        this.customerService = customerService;
        this.headerService = headerService;
        this.renderer = renderer;
        this.environment = environment;
        this.showSideNav = false;
        this.Layout = Layout;
        this.subscribers = {};
        this.logoLinkPath = this.environment.seamless.logoPath;
    }
    ngOnInit() {
        this.subscribers.isLoggedIn = this.authenticationService.isLoggedIn.subscribe(val => {
            this.isLoggedIn = val;
            // NOTE: Customer Service doesn't exist in private
            if (this.isLoggedIn && this.authenticationService.MemberOfSystemId !== MemberType.ActiveDirectory) {
                this.subscribers.customer = this.customerService.customer$.subscribe(customer => (this.customer = customer));
            }
        });
        this.subscribers.layoutSubject = this.layoutService.getState(Layout.MENU_DRAWER).subscribe(isActive => {
            this.naviconActive = isActive;
        });
        this.subscribers.layoutSubject = this.layoutService.getState(Layout.ACCOUNTS_DRAWER).subscribe(isActive => {
            this.accountDrawerIsActive = isActive;
        });
    }
    ngAfterViewInit() {
        this.headerService.logoAssetPathOverride.subscribe(assetPath => {
            if (assetPath && this.headerLogoAnchor) {
                this.renderer.setStyle(this.headerLogoAnchor.nativeElement, 'backgroundImage', `url(${assetPath})`);
            }
        });
    }
    ngOnDestroy() {
        for (const key in this.subscribers) {
            if (this.subscribers.hasOwnProperty(key)) {
                const subscriber = this.subscribers[key];
                if (subscriber instanceof Subscription) {
                    subscriber.unsubscribe();
                }
            }
        }
    }
    toggle(layout) {
        this.layoutService.toggleState(layout);
    }
};
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵngcc0.ɵɵdirectiveInject(AuthenticationService), ɵngcc0.ɵɵdirectiveInject(LayoutService), ɵngcc0.ɵɵdirectiveInject(CustomerService), ɵngcc0.ɵɵdirectiveInject(HeaderService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(SEAMLESS_ENVIRONMENT)); };
HeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["seamless-header"]], viewQuery: function HeaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerLogoAnchor = _t.first);
    } }, ngContentSelectors: _c5, decls: 6, vars: 6, consts: [[1, "header", "navbar-fixed-top"], [1, "header__navicon", "hidden-md", "hidden-lg", 3, "ngClass", "click"], ["class", "header__brand", 3, "href", 4, "ngIf"], ["class", "header__account account", 3, "ngClass", "click", 4, "ngIf"], [1, "header__brand", 3, "href"], ["headerLogoAnchor", ""], [1, "header__account", "account", 3, "ngClass", "click"], ["class", "account__image", 3, "src", "alt", 4, "ngIf"], [1, "account__image", 3, "src", "alt"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "header", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function HeaderComponent_Template_button_click_1_listener() { return ctx.toggle(ctx.Layout.MENU_DRAWER); });
        ɵngcc0.ɵɵtext(2, " Menu ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, HeaderComponent_a_3_Template, 3, 1, "a", 2);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵtemplate(5, HeaderComponent_button_5_Template, 2, 5, "button", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c4, ctx.naviconActive, !ctx.naviconActive));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isLoggedIn);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isLoggedIn);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf], styles: ["@charset \"UTF-8\";.header[_ngcontent-%COMP%]{height:50px;background-color:#fff;border-bottom:1px solid #e3e3e3}.header__brand[_ngcontent-%COMP%]{display:block;width:140px;height:50px;line-height:50px;font-size:24px;text-align:center;margin:0 auto;overflow:hidden;color:#fff;background-image:url(assets/seamless/images/OAG.png);background-repeat:no-repeat;background-position:center center;background-size:80% auto;text-indent:100%}.header__account[_ngcontent-%COMP%], .header__navicon[_ngcontent-%COMP%]{position:absolute;top:50%;transform:translateY(-50%);z-index:1;height:30px;width:46px;padding:0;line-height:30px;border:0;color:rgba(0,0,0,.3);background-color:transparent;outline:0;text-indent:100%;overflow:hidden}.header__navicon[_ngcontent-%COMP%]{left:15px}.header__navicon[_ngcontent-%COMP%]:before{display:block;text-indent:0;font-family:csnicons;font-size:44px;content:\"\uE964\"}.header__navicon.active[_ngcontent-%COMP%]:before{content:\"\uE94D\";font-size:32px}.header__account[_ngcontent-%COMP%]{right:15px;height:35px}.header__account.active[_ngcontent-%COMP%]   .account__image[_ngcontent-%COMP%]{border:1px solid #007cc2}.header__account.notActive[_ngcontent-%COMP%]   .account__image[_ngcontent-%COMP%]{filter:url(\"data:image/svg+xml;utf8,&lt;svg xmlns='http://www.w3.org/2000/svg'&gt;&lt\u202633 0.3333 0.3333 0 0 0 0 0 1 0'/&gt;&lt;/filter&gt;&lt;/svg&gt;#grayscale\");filter:gray;-webkit-filter:grayscale(100%)}.header__account.showIcon[_ngcontent-%COMP%]:before{display:block;text-indent:0;font-family:csnicons;font-size:28px;content:\"\uE9A0\"}.header__account.showIcon.active[_ngcontent-%COMP%]{border:none}.header__account.showIcon.active[_ngcontent-%COMP%]:before{color:#007cc2}.account__image[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;width:25px;height:25px;border-radius:9999px;transform:translate(-50%,-50%)}@media (min-width:992px){.header[_ngcontent-%COMP%]{height:80px;border-bottom:1px solid #dbdbdb}.header__brand[_ngcontent-%COMP%]{border-right:1px solid #dbdbdb;width:250px;height:80px;line-height:80px;float:left;background-size:60% auto;z-index:1;position:relative}.header__account[_ngcontent-%COMP%]{height:80px}.account__image[_ngcontent-%COMP%]{width:35px;height:35px}}"] });
HeaderComponent.ctorParameters = () => [
    { type: AuthenticationService },
    { type: LayoutService },
    { type: CustomerService },
    { type: HeaderService },
    { type: Renderer2 },
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] }
];
__decorate([
    ViewChild('headerLogoAnchor', { static: false }),
    __metadata("design:type", ElementRef)
], HeaderComponent.prototype, "headerLogoAnchor", void 0);
HeaderComponent = __decorate([ __param(5, Inject(SEAMLESS_ENVIRONMENT)),
    __metadata("design:paramtypes", [AuthenticationService,
        LayoutService,
        CustomerService,
        HeaderService,
        Renderer2,
        Environment])
], HeaderComponent);

let HomeComponent = class HomeComponent {
    constructor() { }
    ngOnInit() { }
};
HomeComponent.ɵfac = function HomeComponent_Factory(t) { return new (t || HomeComponent)(); };
HomeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HomeComponent, selectors: [["seamless-home"]], decls: 11, vars: 0, consts: [[1, "header-area"], [1, "header-area__title-area"], [1, "header-area__title", "hidden-xs", "hidden-sm"], ["routerLink", "/"], [1, "header-area__title", "hidden-md", "hidden-lg"], [1, "container-fluid", "hidden-md", "hidden-lg", "clearfix"], [1, "clearfix"], [1, "section-title", "pull-left"]], template: function HomeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "h1", 2);
        ɵngcc0.ɵɵelementStart(3, "a", 3);
        ɵngcc0.ɵɵtext(4, "Welcome");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "h1", 4);
        ɵngcc0.ɵɵtext(6, "Welcome");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "h2", 7);
        ɵngcc0.ɵɵtext(10, "Welcome");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, directives: [ɵngcc5.RouterLinkWithHref], styles: [""] });
HomeComponent = __decorate([ __metadata("design:paramtypes", [])
], HomeComponent);

let RegisterComponent = class RegisterComponent {
    constructor() { }
    ngOnInit() { }
};
RegisterComponent.ɵfac = function RegisterComponent_Factory(t) { return new (t || RegisterComponent)(); };
RegisterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RegisterComponent, selectors: [["seamless-register"]], decls: 20, vars: 0, consts: [[1, "register"], [1, "register__panel"], [1, "container-fluid"], [1, "register__marketing"], [1, "register__logos"], ["src", "https://trade.csnstatic.com/OAG@3x.png", "alt", "", 1, "register__logo"], ["src", "https://trade.csnstatic.com/LM@3x.png", "alt", "", 1, "register__logo"], ["src", "https://trade.csnstatic.com/redbookIQ@3x@3x.png", "alt", "", 1, "register__logo"], [1, "register__blurb"], ["src", "https://trade.csnstatic.com/cscomltd@3x.png", "alt", ""], [1, "register__container"], ["name", "form", "novalidate", "", 1, "form"]], template: function RegisterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "ul", 4);
        ɵngcc0.ɵɵelementStart(5, "li");
        ɵngcc0.ɵɵelement(6, "img", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "li");
        ɵngcc0.ɵɵelement(8, "img", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "li");
        ɵngcc0.ɵɵelement(10, "img", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵelementStart(12, "span");
        ɵngcc0.ɵɵtext(13, "Software and insights for dealers, OEM and advertisers by");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(14, "img", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 10);
        ɵngcc0.ɵɵelementStart(16, "h1");
        ɵngcc0.ɵɵtext(17, "Register");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "form", 11);
        ɵngcc0.ɵɵelement(19, "div");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, directives: [ɵngcc6.ɵangular_packages_forms_forms_y, ɵngcc6.NgControlStatusGroup, ɵngcc6.NgForm], styles: [".register[_ngcontent-%COMP%]{overflow:hidden;background:linear-gradient(to right,#272e62 0,#007cc2 50%,#63cbe8 100%);padding:15px 0}.register[_ngcontent-%COMP%]   .container-fluid[_ngcontent-%COMP%]{max-width:1140px}.register[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{margin:0}.register[_ngcontent-%COMP%]   [class*=col-][_ngcontent-%COMP%]{padding:0}.register__panel[_ngcontent-%COMP%]{position:relative;margin:0 auto}.register__marketing[_ngcontent-%COMP%]{position:relative;padding:30px;background-color:#f1f1f1}.register__logos[_ngcontent-%COMP%]{overflow:hidden;text-align:center;margin:0;padding:0}.register__logos[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{width:30%;display:inline-block}.register__logos[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:nth-child(2){position:relative;top:-9px}.register__logos[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:nth-child(3){position:relative;top:-16px}.register__logo[_ngcontent-%COMP%]{display:block;float:left;width:80%}.register__blurb[_ngcontent-%COMP%]{margin-top:15px;text-align:center;width:100%}.register__blurb[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:block}.register__blurb[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:180px;margin:0 15px}.register__container[_ngcontent-%COMP%]{display:block;width:100%;padding:30px;margin:0 auto;background-color:#fff}.register__container[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:20px;line-height:28px;color:#4a4a4a;text-align:center;margin-top:0}.register__container[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]{margin:0 auto}.register__help-block[_ngcontent-%COMP%]{margin-top:0;margin-bottom:.5rem;color:#a94442}.register__remember[_ngcontent-%COMP%]{width:130px;margin:15px auto}.register__forgot[_ngcontent-%COMP%]{display:block;width:130px;margin:15px auto;text-align:center}.register__bottom[_ngcontent-%COMP%]{margin:30px 0 0}.register__sign-up[_ngcontent-%COMP%]{max-width:130px;font-size:15px;color:#ff7217;margin:0 auto;transition:.3s ease-out;display:block;width:100%;height:auto;line-height:24px;padding:0;font-weight:700;white-space:unset}.register__tandc[_ngcontent-%COMP%]{display:block;text-align:center;padding:10px 0}.register[_ngcontent-%COMP%]   button[type=submit][_ngcontent-%COMP%]{display:block;min-width:180px;margin:24px auto 0}.register__error[_ngcontent-%COMP%]{font-size:13px;color:#d0021b}@media (min-width:768px){.register[_ngcontent-%COMP%]{padding:60px}.register__container[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]{width:unset;max-width:320px}}@media (min-width:992px){.register[_ngcontent-%COMP%]{margin:0 auto}.register__marketing[_ngcontent-%COMP%]{float:left;min-height:510px;width:60%;padding:60px 30px}.register__logos[_ngcontent-%COMP%]{position:absolute;top:50%;transform:translateY(-50%)}.register__blurb[_ngcontent-%COMP%]{position:absolute;bottom:60px;left:50%;transform:translateX(-50%);margin-top:30px}.register__container[_ngcontent-%COMP%]{width:40%;min-height:510px;float:right;margin:0}.register__container[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]{width:unset;max-width:320px}}"] });
RegisterComponent = __decorate([ __metadata("design:paramtypes", [])
], RegisterComponent);

let SearchComponent = class SearchComponent {
    constructor() {
        this.changeSearchState = new EventEmitter();
    }
    ngOnInit() { }
    ngOnDestroy() { }
    ngOnChanges() {
        if (this.showSearch) {
            this.searchInput.nativeElement.focus();
        }
        else {
            this.searchInput.nativeElement.blur();
        }
    }
    keyPressed(ev) {
        if (ev.key === 'Escape') {
            this.changeSearchState.emit((this.showSearch = !this.showSearch));
        }
    }
    close() {
        this.changeSearchState.emit((this.showSearch = !this.showSearch));
    }
};
SearchComponent.ɵfac = function SearchComponent_Factory(t) { return new (t || SearchComponent)(); };
SearchComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SearchComponent, selectors: [["seamless-search"]], viewQuery: function SearchComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchInput = _t.first);
    } }, inputs: { showSearch: "showSearch" }, outputs: { changeSearchState: "changeSearchState" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 60, vars: 3, consts: [[1, "search", 3, "ngClass"], [1, "container-fluid"], ["type", "button", 1, "search__close", 3, "click"], [1, "row"], [1, "col-xs-12"], [1, "search__form"], ["for", "searchForm", 1, "search__form-label"], ["placeholder", "search organisations, products or people", "id", "searchForm", "type", "text", 1, "search__form-input", 3, "keydown"], ["searchInput", ""], ["type", "submit", 1, "search__form-btn"], [1, "search__results"], [1, "col-xs-12", "col-md-4"], [1, "search__results-title"], [1, "search__results-list", "list-group"], [1, "search__results-item", "list-group-item"], ["href", "#", 1, "search__result-link"]], template: function SearchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function SearchComponent_Template_button_click_2_listener() { return ctx.close(); });
        ɵngcc0.ɵɵtext(3, "close");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "form", 5);
        ɵngcc0.ɵɵelementStart(7, "label", 6);
        ɵngcc0.ɵɵtext(8, "Enter a search term and press enter");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "input", 7, 8);
        ɵngcc0.ɵɵlistener("keydown", function SearchComponent_Template_input_keydown_9_listener($event) { return ctx.keyPressed($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "button", 9);
        ɵngcc0.ɵɵtext(12, "search");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 3);
        ɵngcc0.ɵɵelementStart(14, "div", 10);
        ɵngcc0.ɵɵelementStart(15, "div", 11);
        ɵngcc0.ɵɵelementStart(16, "p", 12);
        ɵngcc0.ɵɵtext(17, " Category ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "ul", 13);
        ɵngcc0.ɵɵelementStart(19, "li", 14);
        ɵngcc0.ɵɵtext(20, "Cras justo odio");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "li", 14);
        ɵngcc0.ɵɵtext(22, "Dapibus ac facilisis in");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "li", 14);
        ɵngcc0.ɵɵtext(24, "Morbi leo risus");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "li", 14);
        ɵngcc0.ɵɵtext(26, "Porta ac consectetur ac");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "li", 14);
        ɵngcc0.ɵɵelementStart(28, "a", 15);
        ɵngcc0.ɵɵtext(29, "result");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "div", 11);
        ɵngcc0.ɵɵelementStart(31, "p", 12);
        ɵngcc0.ɵɵtext(32, " Category ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(33, "ul", 13);
        ɵngcc0.ɵɵelementStart(34, "li", 14);
        ɵngcc0.ɵɵtext(35, "Cras justo odio");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "li", 14);
        ɵngcc0.ɵɵtext(37, "Dapibus ac facilisis in");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(38, "li", 14);
        ɵngcc0.ɵɵtext(39, "Morbi leo risus");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(40, "li", 14);
        ɵngcc0.ɵɵtext(41, "Porta ac consectetur ac");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(42, "li", 14);
        ɵngcc0.ɵɵelementStart(43, "a", 15);
        ɵngcc0.ɵɵtext(44, "result");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(45, "div", 11);
        ɵngcc0.ɵɵelementStart(46, "p", 12);
        ɵngcc0.ɵɵtext(47, " Category ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(48, "ul", 13);
        ɵngcc0.ɵɵelementStart(49, "li", 14);
        ɵngcc0.ɵɵtext(50, "Cras justo odio");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(51, "li", 14);
        ɵngcc0.ɵɵtext(52, "Dapibus ac facilisis in");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(53, "li", 14);
        ɵngcc0.ɵɵtext(54, "Morbi leo risus");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(55, "li", 14);
        ɵngcc0.ɵɵtext(56, "Porta ac consectetur ac");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(57, "li", 14);
        ɵngcc0.ɵɵelementStart(58, "a", 15);
        ɵngcc0.ɵɵtext(59, "result");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c7, ctx.showSearch));
    } }, directives: [ɵngcc1.NgClass, ɵngcc6.ɵangular_packages_forms_forms_y, ɵngcc6.NgControlStatusGroup, ɵngcc6.NgForm], styles: ["@charset \"UTF-8\";.search[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:100%;padding:60px 15px;z-index:-1;background-color:#fff;opacity:0;transform:translateY(-100%);transition:.3s}.search__close[_ngcontent-%COMP%]{position:absolute;right:15px;top:15px;width:30px;height:30px;padding:0;line-height:30px;text-indent:-9999px;overflow:hidden;background-color:transparent;border:0;outline:0;color:grey}.search__close[_ngcontent-%COMP%]:after{position:absolute;left:0;top:0;display:block;width:inherit;height:inherit;line-height:inherit;font-family:csnicons;font-size:30px;font-weight:300;content:\"\uE94D\";text-indent:0}.search__form[_ngcontent-%COMP%]{position:relative;height:60px;line-height:60px;font-size:24px}.search__form-label[_ngcontent-%COMP%]{position:absolute;top:-16px;left:0;margin:0;line-height:16px;display:block;font-weight:600;font-size:12px;color:#393939}.search__form-input[_ngcontent-%COMP%]{display:block;width:100%;height:inherit;padding-left:60px;line-height:inherit;border:0;border-bottom:1px solid #cdcdcd;background-color:transparent;font-size:inherit;font-weight:600;color:#393939;outline:0}.search__form-input[_ngcontent-%COMP%]::-moz-placeholder{color:#cdcdcd}.search__form-input[_ngcontent-%COMP%]:-ms-input-placeholder{color:#cdcdcd}.search__form-input[_ngcontent-%COMP%]::-ms-input-placeholder{color:#cdcdcd}.search__form-input[_ngcontent-%COMP%]::placeholder{color:#cdcdcd}.search__form-btn[_ngcontent-%COMP%]{position:absolute;left:0;top:0;display:block;width:60px;height:inherit;padding:0;line-height:inherit;text-indent:-9999px;overflow:hidden;background-color:transparent;border:0;outline:0;color:grey}.search__form-btn[_ngcontent-%COMP%]:after{position:absolute;left:0;top:0;display:block;width:inherit;height:inherit;line-height:inherit;font-family:csnicons;font-size:inherit;font-weight:300;content:\"\uE98C\";text-indent:0}.search__results[_ngcontent-%COMP%]{padding:30px 0}.search__results-title[_ngcontent-%COMP%]{font-weight:600;font-size:18px;color:grey}.search__results-item[_ngcontent-%COMP%]{margin:0;padding-left:0;padding-right:0;border:0;border-bottom:1px dotted #e1e1e1}.search.show[_ngcontent-%COMP%]{z-index:1050;opacity:1;transform:translateY(0)}@media (min-width:768px){.search[_ngcontent-%COMP%]{padding:60px 45px}}@media (min-width:992px){.search__form[_ngcontent-%COMP%]{height:100px;line-height:100px;font-size:48px}}"] });
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], SearchComponent.prototype, "changeSearchState", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], SearchComponent.prototype, "showSearch", void 0);
__decorate([
    ViewChild('searchInput', { static: false }),
    __metadata("design:type", Object)
], SearchComponent.prototype, "searchInput", void 0);
SearchComponent = __decorate([ __metadata("design:paramtypes", [])
], SearchComponent);

var SidebarItemStatus;
(function (SidebarItemStatus) {
    SidebarItemStatus["Available"] = "available";
    SidebarItemStatus["Unreachable"] = "unreachable";
    SidebarItemStatus["Locked"] = "locked";
})(SidebarItemStatus || (SidebarItemStatus = {}));

class SidebarItem {
    constructor(name, iconName, baseUrl, path, status, translationKey) {
        this.name = '';
        this.iconName = 'icon-circle-right-sm';
        this.baseUrl = '';
        this.path = '';
        this.status = '';
        this.translationKey = '';
        this.children = [];
        this.parentName = null;
        this.linkUrl = null;
        this.iconName = iconName;
        this.name = name;
        this.baseUrl = baseUrl;
        this.path = path;
        this.status = status;
        this.translationKey = translationKey;
    }
    get hasChildren() {
        return this.children.length > 0;
    }
    get destination() {
        return Utilities.stripTrailingSlash(this.baseUrl) + this.path;
    }
    get isAvailable() {
        return this.status.toLowerCase() === SidebarItemStatus.Available;
    }
    get isUnreachable() {
        return this.status.toLowerCase() === SidebarItemStatus.Unreachable;
    }
    get isLocked() {
        return this.status.toLowerCase() === SidebarItemStatus.Locked;
    }
    get isUnavailable() {
        return this.isLocked || this.isUnreachable;
    }
}

var Constants;
(function (Constants) {
    let AuthenticationSystems;
    (function (AuthenticationSystems) {
        AuthenticationSystems["Membership"] = "Membership";
        AuthenticationSystems["ActiveDirectory"] = "ActiveDirectory";
        AuthenticationSystems["Portal"] = "Portal";
    })(AuthenticationSystems = Constants.AuthenticationSystems || (Constants.AuthenticationSystems = {}));
    let ReferentialData;
    (function (ReferentialData) {
        let ClaimTypes;
        (function (ClaimTypes) {
            ClaimTypes["UserIdentifier"] = "UserIdentifier";
            ClaimTypes["Username"] = "Username";
            ClaimTypes["MemberOfSystemId"] = "MemberOfSystemId";
            ClaimTypes["Usersession"] = "UserSession";
            ClaimTypes["GlobalMembershipToken"] = "GlobalMembershipToken";
            ClaimTypes["ProductPermissions"] = "ProductPermissions";
            ClaimTypes["SellerGuid"] = "SellerGuid";
            ClaimTypes["UserAccessibleSellerGuids"] = "UserAccessibleSellerGuids";
            ClaimTypes["IpAddress"] = "IpAddress";
            ClaimTypes["RefreshToken"] = "RefreshToken";
        })(ClaimTypes = ReferentialData.ClaimTypes || (ReferentialData.ClaimTypes = {}));
        let UserStatuses;
        (function (UserStatuses) {
            UserStatuses["Active"] = "Active";
            UserStatuses["Delete"] = "Delete";
            UserStatuses["Inactive"] = "Inactive";
            UserStatuses["Locked"] = "Locked";
            UserStatuses["Pending"] = "Pending";
        })(UserStatuses = ReferentialData.UserStatuses || (ReferentialData.UserStatuses = {}));
        let Salutations;
        (function (Salutations) {
            Salutations["Mr"] = "Mr.";
            Salutations["Miss"] = "Miss";
            Salutations["Mrs"] = "Mrs";
            Salutations["Ms"] = "Ms";
            Salutations["Dr"] = "Dr";
            Salutations["Prof"] = "Prof";
        })(Salutations = ReferentialData.Salutations || (ReferentialData.Salutations = {}));
        let AddressTypes;
        (function (AddressTypes) {
            AddressTypes["Physical"] = "Physical";
            AddressTypes["Postal"] = "Postal";
        })(AddressTypes = ReferentialData.AddressTypes || (ReferentialData.AddressTypes = {}));
        let SalesforceAddressTypes;
        (function (SalesforceAddressTypes) {
            SalesforceAddressTypes["Billing"] = "Billing";
            SalesforceAddressTypes["Shipping"] = "Shipping";
        })(SalesforceAddressTypes = ReferentialData.SalesforceAddressTypes || (ReferentialData.SalesforceAddressTypes = {}));
        let DealerStatuses;
        (function (DealerStatuses) {
            DealerStatuses["Active"] = "Active";
            DealerStatuses["Inactive"] = "Inactive";
            DealerStatuses["Hold"] = "Hold";
            DealerStatuses["Pending"] = "Pending";
            DealerStatuses["Blacklist"] = "Blacklist";
            DealerStatuses["Cancelled"] = "Cancelled";
        })(DealerStatuses = ReferentialData.DealerStatuses || (ReferentialData.DealerStatuses = {}));
        let DealerUserStatuses;
        (function (DealerUserStatuses) {
            DealerUserStatuses["Active"] = "Active";
            DealerUserStatuses["Inactive"] = "Inactive";
        })(DealerUserStatuses = ReferentialData.DealerUserStatuses || (ReferentialData.DealerUserStatuses = {}));
        let Countries;
        (function (Countries) {
            Countries["Australia"] = "Australia";
            Countries["Brazil"] = "Brazil";
            Countries["Chile"] = "Chile";
            Countries["NewZealand"] = "NewZealand";
        })(Countries = ReferentialData.Countries || (ReferentialData.Countries = {}));
        let SalesforceCountries;
        (function (SalesforceCountries) {
            SalesforceCountries["AU"] = "AU";
            SalesforceCountries["NZ"] = "NZ";
        })(SalesforceCountries = ReferentialData.SalesforceCountries || (ReferentialData.SalesforceCountries = {}));
        let Markets;
        (function (Markets) {
            Markets["Cars"] = "Cars";
            Markets["Tyres"] = "Tyres";
            Markets["Bikes"] = "Bikes";
            Markets["Boats"] = "Boats";
            Markets["Trucks"] = "Trucks";
            Markets["Agriculture"] = "Agriculture";
            Markets["Construction"] = "Construction";
            Markets["Equipment"] = "Equipment";
            Markets["Caravans"] = "Caravans";
        })(Markets = ReferentialData.Markets || (ReferentialData.Markets = {}));
        let TenantStatuses;
        (function (TenantStatuses) {
            TenantStatuses["Active"] = "Active";
            TenantStatuses["Deleted"] = "Deleted";
        })(TenantStatuses = ReferentialData.TenantStatuses || (ReferentialData.TenantStatuses = {}));
        // NOTE: used by LM
        let SpecProviders;
        (function (SpecProviders) {
            SpecProviders["Redbook"] = "Redbook";
        })(SpecProviders = ReferentialData.SpecProviders || (ReferentialData.SpecProviders = {}));
        let VerticalReferenceData;
        (function (VerticalReferenceData) {
            VerticalReferenceData["Car"] = "Car";
            VerticalReferenceData["Bike"] = "Bike";
            VerticalReferenceData["Boat"] = "Boat";
            VerticalReferenceData["Truck"] = "Truck";
            VerticalReferenceData["Agriculture"] = "Agriculture";
            VerticalReferenceData["Construction"] = "Construction";
            VerticalReferenceData["Equipment"] = "Equipment";
            VerticalReferenceData["Caravan"] = "Caravan";
        })(VerticalReferenceData = ReferentialData.VerticalReferenceData || (ReferentialData.VerticalReferenceData = {}));
        let LegacyDealerFranchiseStatus;
        (function (LegacyDealerFranchiseStatus) {
            LegacyDealerFranchiseStatus["Inactive"] = "Inactive";
            LegacyDealerFranchiseStatus["Active"] = "Active";
        })(LegacyDealerFranchiseStatus = ReferentialData.LegacyDealerFranchiseStatus || (ReferentialData.LegacyDealerFranchiseStatus = {}));
        let DealerFranchiseStatus;
        (function (DealerFranchiseStatus) {
            DealerFranchiseStatus["Active"] = "Active";
            DealerFranchiseStatus["Inactive"] = "Inactive";
        })(DealerFranchiseStatus = ReferentialData.DealerFranchiseStatus || (ReferentialData.DealerFranchiseStatus = {}));
        let Events;
        (function (Events) {
            Events["Update"] = "Update";
        })(Events = ReferentialData.Events || (ReferentialData.Events = {}));
        let Products;
        (function (Products) {
            Products["LiveMarket"] = "LiveMarket";
            Products["DealerFinance"] = "DealerFinance";
            Products["OAG"] = "OAG";
        })(Products = ReferentialData.Products || (ReferentialData.Products = {}));
    })(ReferentialData = Constants.ReferentialData || (Constants.ReferentialData = {}));
    let Analysis;
    (function (Analysis) {
        let DashboardFilters;
        (function (DashboardFilters) {
            DashboardFilters["ALL"] = "ALL";
            DashboardFilters["ONTARGET"] = "ONTARGET";
            DashboardFilters["OUTSIDETARGET"] = "OUTSIDETARGET";
            DashboardFilters["NOMARKET"] = "NOMARKET";
            DashboardFilters["NORETAIL"] = "NORETAIL";
            DashboardFilters["DAYRANGE1"] = "DAYRANGE1";
            DashboardFilters["DAYRANGE2"] = "DAYRANGE2";
            DashboardFilters["DAYRANGE3"] = "DAYRANGE3";
            DashboardFilters["DAYRANGE4"] = "DAYRANGE4";
            DashboardFilters["PRICEDBELOW"] = "PRICEDBELOW";
            DashboardFilters["PRICEDNEUTRAL"] = "PRICEDNEUTRAL";
            DashboardFilters["PRICEDABOVE"] = "PRICEDABOVE";
            DashboardFilters["BELOWTARGET"] = "BELOWTARGET";
            DashboardFilters["ABOVETARGET"] = "ABOVETARGET";
            DashboardFilters["NOPHOTOS"] = "NOPHOTOS";
            DashboardFilters["MIN1PHOTOS"] = "MIN1PHOTOS";
            DashboardFilters["LESS12PHOTOS"] = "LESS12PHOTOS";
            DashboardFilters["_12ORMOREPHOTOS"] = "_12ORMOREPHOTOS";
            DashboardFilters["NOCOMMENTS"] = "NOCOMMENTS";
            DashboardFilters["COMMENTS"] = "COMMENTS";
            DashboardFilters["LEADS5PLUS"] = "LEADS5PLUS";
            DashboardFilters["LEADSLESS5"] = "LEADSLESS5";
            DashboardFilters["RATIOPLUS"] = "RATIOPLUS";
            DashboardFilters["RATIOLESS"] = "RATIOLESS";
            DashboardFilters["EXEMPT"] = "EXEMPT";
        })(DashboardFilters = Analysis.DashboardFilters || (Analysis.DashboardFilters = {}));
        // NOTE: the Names are what is used in the db (and are case-sensitive)
        let DisplayPrice;
        (function (DisplayPrice) {
            DisplayPrice["LIST"] = "LIST";
            DisplayPrice["EGC"] = "EGC";
            // IGC = 'IGC',
            // CALC_EGC = 'CALC_EGC',
            DisplayPrice["LM_DAP"] = "LM_DAP";
            // CALC_DAP = 'CALC_DAP'
        })(DisplayPrice = Analysis.DisplayPrice || (Analysis.DisplayPrice = {}));
        let SpecCountries;
        (function (SpecCountries) {
            SpecCountries["AU"] = "AU";
        })(SpecCountries = Analysis.SpecCountries || (Analysis.SpecCountries = {}));
        let SortOptions;
        (function (SortOptions) {
            let Appraisal;
            (function (Appraisal) {
                Appraisal["VehicleMake"] = "VehicleMake";
                Appraisal["RegistrationNumber"] = "RegistrationNumber";
                Appraisal["LastUpdated"] = "LastUpdated";
                Appraisal["AppraisedValue"] = "AppraisedValue";
            })(Appraisal = SortOptions.Appraisal || (SortOptions.Appraisal = {}));
            let CompetitiveSet;
            (function (CompetitiveSet) {
                CompetitiveSet["VehicleYear"] = "VehicleYear";
                CompetitiveSet["Price"] = "Price";
                CompetitiveSet["DriveAwayPrice"] = "DriveAwayPrice";
                CompetitiveSet["EGCPrice"] = "EGCPrice";
                CompetitiveSet["Odometer"] = "Odometer";
                CompetitiveSet["DaysOnMarket"] = "DaysOnMarket";
                CompetitiveSet["Watches"] = "Watches";
                CompetitiveSet["LeadConversionRate"] = "LeadConversionRate";
                CompetitiveSet["Colour"] = "Colour";
                CompetitiveSet["SellerType"] = "SellerType";
                CompetitiveSet["Tags"] = "Tags";
                CompetitiveSet["Photos"] = "Photos";
                CompetitiveSet["Views"] = "Views";
                CompetitiveSet["Leads"] = "Leads";
                CompetitiveSet["State"] = "State";
            })(CompetitiveSet = SortOptions.CompetitiveSet || (SortOptions.CompetitiveSet = {}));
            let InventoryVsMarket;
            (function (InventoryVsMarket) {
                InventoryVsMarket["DaysOnMarket"] = "DaysOnMarket";
                InventoryVsMarket["Odometer"] = "Odometer";
                InventoryVsMarket["Price"] = "Price";
                InventoryVsMarket["PriceRank"] = "PriceRank";
                InventoryVsMarket["MarketPercentage"] = "MarketPercentage";
                InventoryVsMarket["Views"] = "Views";
                InventoryVsMarket["Watches"] = "Watches";
                InventoryVsMarket["Leads"] = "Leads";
                InventoryVsMarket["LeadConversionRate"] = "LeadConversionRate";
            })(InventoryVsMarket = SortOptions.InventoryVsMarket || (SortOptions.InventoryVsMarket = {}));
            let Stocking;
            (function (Stocking) {
                Stocking["SupplyAndDemand"] = "SupplyAndDemand";
                Stocking["HighVolume"] = "HighVolume";
                Stocking["FastMoving"] = "FastMoving";
            })(Stocking = SortOptions.Stocking || (SortOptions.Stocking = {}));
            let DelistedVehicleReport;
            (function (DelistedVehicleReport) {
                DelistedVehicleReport["StockNumber"] = "StockNumber";
                DelistedVehicleReport["RegistrationNumber"] = "RegistrationNumber";
                DelistedVehicleReport["VehicleYear"] = "VehicleYear";
                DelistedVehicleReport["VehicleMake"] = "VehicleMake";
                DelistedVehicleReport["MarketPercentage"] = "MarketPercentage";
                DelistedVehicleReport["PriceRank"] = "PriceRank";
                DelistedVehicleReport["DaysOnMarket"] = "DaysOnMarket";
            })(DelistedVehicleReport = SortOptions.DelistedVehicleReport || (SortOptions.DelistedVehicleReport = {}));
            let Direction;
            (function (Direction) {
                Direction["Asc"] = "Asc";
                Direction["Desc"] = "Desc";
            })(Direction = SortOptions.Direction || (SortOptions.Direction = {}));
        })(SortOptions = Analysis.SortOptions || (Analysis.SortOptions = {}));
        let SpecFacets;
        (function (SpecFacets) {
            SpecFacets["VehicleCode"] = "VehicleCode";
            SpecFacets["Year"] = "Year";
            SpecFacets["Make"] = "Make";
            SpecFacets["Model"] = "Model";
            SpecFacets["Badge"] = "Badge";
            SpecFacets["Series"] = "Series";
            SpecFacets["Body"] = "Body";
            SpecFacets["Transmission"] = "Transmission";
            SpecFacets["Gears"] = "Gears";
            SpecFacets["Drive"] = "Drive";
            SpecFacets["Class"] = "Class";
            SpecFacets["Doors"] = "Doors";
            SpecFacets["Seats"] = "Seats";
            SpecFacets["EngineDesc"] = "EngineDesc";
            SpecFacets["Cylinders"] = "Cylinders";
            SpecFacets["Fuel"] = "Fuel";
        })(SpecFacets = Analysis.SpecFacets || (Analysis.SpecFacets = {}));
        let PricingStrategyCalculationOptions;
        (function (PricingStrategyCalculationOptions) {
            PricingStrategyCalculationOptions["Initial"] = "Initial";
            PricingStrategyCalculationOptions["AppraisedValue"] = "AppraisedValue";
            PricingStrategyCalculationOptions["RetailPrice"] = "RetailPrice";
            PricingStrategyCalculationOptions["MarketPercentage"] = "MarketPercentage";
            PricingStrategyCalculationOptions["PriceRank"] = "PriceRank";
        })(PricingStrategyCalculationOptions = Analysis.PricingStrategyCalculationOptions || (Analysis.PricingStrategyCalculationOptions = {}));
        let StateCodes;
        (function (StateCodes) {
            StateCodes["ACT"] = "ACT";
            StateCodes["NSW"] = "NSW";
            StateCodes["NT"] = "NT";
            StateCodes["QLD"] = "QLD";
            StateCodes["SA"] = "SA";
            StateCodes["TAS"] = "TAS";
            StateCodes["VIC"] = "VIC";
            StateCodes["WA"] = "WA";
        })(StateCodes = Analysis.StateCodes || (Analysis.StateCodes = {}));
    })(Analysis = Constants.Analysis || (Constants.Analysis = {}));
    let ProductIds;
    (function (ProductIds) {
        ProductIds["LiveMarket"] = "e90e7ee3-6c18-49f4-8c4d-dadb5ff77068";
        ProductIds["AutogatePro"] = "c9567fba-c04f-4fcc-ac02-2bbe0552d0ad";
        // Autogate = '',
        ProductIds["InventoryDistribution"] = "cd8eb3f7-b76b-47ea-8466-21e3a1ab8ef7";
    })(ProductIds = Constants.ProductIds || (Constants.ProductIds = {}));
    /** used to identify the type of data in a product group - this can be used to open the correct modal type etc.*/
    let ProductGroupType;
    (function (ProductGroupType) {
        ProductGroupType["Single"] = "single";
        ProductGroupType["Group"] = "group";
        ProductGroupType["Numeric"] = "numeric";
    })(ProductGroupType = Constants.ProductGroupType || (Constants.ProductGroupType = {}));
})(Constants || (Constants = {}));

let SidebarService = class SidebarService {
    constructor(layoutService, router, storageService, http, errorHandlerService, environment) {
        this.layoutService = layoutService;
        this.router = router;
        this.storageService = storageService;
        this.http = http;
        this.errorHandlerService = errorHandlerService;
        this.environment = environment;
        this.isLoading = new BehaviorSubject(false);
        this.collapsed = {};
    }
    navigateRoute(route, linkTitle) {
        this.activeLink = linkTitle;
        this.layoutService.toggleState(Layout.MENU_DRAWER);
        this.router.navigateByUrl(route);
    }
    toggleMenuGroup(name) {
        this.collapsed[name] = !this.collapsed[name];
        this.storageService.set('menuState', this.collapsed); // TODO: use proper keys
    }
    /**
     * Get menu items from seamless menu api
     * @param group Menu group (e.g. "sidebar", “bottom”)
     */
    getMenuItems(group, supportMode) {
        const apiPath = Utilities.stripTrailingSlash(`${this.environment.seamless.api.base}`) + `/au/v1/Menus?group=${group}&supportMode=${supportMode}`;
        return this.http.get(apiPath).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
    }
    mapMenuItems(items, vertical) {
        return items.map((item) => {
            const { name, iconName, baseUrl, path, status, children, translationKey } = item;
            let sidebarItem = new SidebarItem(name, iconName, baseUrl, path, status, translationKey);
            sidebarItem.children = this.setMenuItemsParentName(this.mapMenuItems(children, vertical), name);
            sidebarItem.linkUrl = this.getItemLinkUrl(sidebarItem, vertical);
            return sidebarItem;
        });
    }
    setMenuItemsParentName(items, parentName) {
        return items.map((item) => {
            item.parentName = parentName;
            return item;
        });
    }
    getItemLinkUrl(item, vertical) {
        if (item.isLocked) {
            // Car vertical links to store
            if (vertical === Constants.ReferentialData.VerticalReferenceData.Car) {
                return this.environment.seamless.autogateStoreUrl;
            }
            // Other vertical links to autogate pro subscription
            return this.environment.seamless.autogateproSubscriptionUrl;
        }
        if (item.isUnreachable) {
            return null;
        }
        return item.destination;
    }
};
SidebarService.ɵfac = function SidebarService_Factory(t) { return new (t || SidebarService)(ɵngcc0.ɵɵinject(LayoutService), ɵngcc0.ɵɵinject(ɵngcc5.Router), ɵngcc0.ɵɵinject(LocalStorageService), ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(ErrorHandlerService), ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT)); };
SidebarService.ctorParameters = () => [
    { type: LayoutService },
    { type: Router },
    { type: LocalStorageService },
    { type: HttpClient },
    { type: ErrorHandlerService },
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] }
];
SidebarService.ɵprov = ɵɵdefineInjectable({ factory: function SidebarService_Factory() { return new SidebarService(ɵɵinject(LayoutService), ɵɵinject(Router), ɵɵinject(LocalStorageService), ɵɵinject(HttpClient), ɵɵinject(ErrorHandlerService), ɵɵinject(SEAMLESS_ENVIRONMENT)); }, token: SidebarService, providedIn: "root" });
SidebarService = __decorate([ __param(5, Inject(SEAMLESS_ENVIRONMENT)),
    __metadata("design:paramtypes", [LayoutService,
        Router,
        LocalStorageService,
        HttpClient,
        ErrorHandlerService,
        Environment])
], SidebarService);

let SidebarComponent = class SidebarComponent {
    constructor(layoutService, sidebarService, authenticationService) {
        this.layoutService = layoutService;
        this.sidebarService = sidebarService;
        this.authenticationService = authenticationService;
        this.Layout = Layout;
        this.subscribers = {};
    }
    ngOnInit() {
        this.subscribers.isLoading = this.sidebarService.isLoading.subscribe((val) => {
            this.isLoading = val;
        });
        this.subscribers.layoutSubject = this.layoutService.getState(Layout.MENU_DRAWER).subscribe(val => {
            this.showSideNav = val;
        });
        this.subscribers.isLoggedIn = this.authenticationService.isLoggedIn.subscribe(val => {
            this.userIsLoggedIn = val;
        });
    }
    ngOnDestroy() {
        for (const key in this.subscribers) {
            if (this.subscribers.hasOwnProperty(key)) {
                const subscriber = this.subscribers[key];
                if (subscriber instanceof Subscription) {
                    subscriber.unsubscribe();
                }
            }
        }
    }
    toggle(layout) {
        this.layoutService.toggleState(layout);
    }
};
SidebarComponent.ɵfac = function SidebarComponent_Factory(t) { return new (t || SidebarComponent)(ɵngcc0.ɵɵdirectiveInject(LayoutService), ɵngcc0.ɵɵdirectiveInject(SidebarService), ɵngcc0.ɵɵdirectiveInject(AuthenticationService)); };
SidebarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SidebarComponent, selectors: [["seamless-sidebar"]], ngContentSelectors: _c5, decls: 2, vars: 4, consts: [["class", "seamless-sidebar", 3, "ngClass", 4, "ngIf"], [1, "sidebar-cloak", 3, "ngClass", "click"], [1, "seamless-sidebar", 3, "ngClass"], [1, "seamless-sidebar__inner"], ["class", "loading-spinner loading-spinner--dark", 4, "ngIf"], [1, "loading-spinner", "loading-spinner--dark"], [1, "loading-spinner__icon"]], template: function SidebarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, SidebarComponent_div_0_Template, 4, 4, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function SidebarComponent_Template_div_click_1_listener() { return ctx.toggle(ctx.Layout.MENU_DRAWER); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.userIsLoggedIn);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c9, ctx.showSideNav));
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass], styles: ["@charset \"UTF-8\";.seamless-sidebar .panel{margin-bottom:0;background-color:transparent;border:0}.seamless-sidebar .panel-group{margin-bottom:0}.seamless-sidebar .panel-group .panel{border-bottom:.5px solid #3d464d;border-radius:0;margin-top:0}.seamless-sidebar .panel-default .panel-heading{background-color:transparent}.seamless-sidebar .panel-heading{padding:0;border-bottom:0;border-top-right-radius:0;border-top-left-radius:0}.seamless-sidebar .panel-default>.panel-heading+.panel-collapse>.panel-body{border-top:none}.seamless-sidebar .panel-body{padding:0}.seamless-sidebar .card{background-color:transparent;box-shadow:none}.seamless-sidebar{position:fixed;z-index:1032;left:0;top:50px;transform:translateX(-250px);width:250px;height:100%;background-color:#3d464d;padding-bottom:54px;transition:.3s cubic-bezier(.77,0,.175,1)}.seamless-sidebar.open{transform:translateX(0);left:0}.seamless-sidebar a{color:#fff;text-decoration:none}.seamless-sidebar .panel-title .accordion-toggle>div:after{position:absolute;top:50%;right:30px;left:unset;transition:transform .2s;transform:translate(0,-50%) rotate(0);font-family:csnicons;font-size:12px;font-weight:300;content:\"\uE928\";text-indent:0}.seamless-sidebar .panel-body>a,.seamless-sidebar .panel-body>seamless-sidebar-menu-item>a,.seamless-sidebar .panel-group>a,.seamless-sidebar .panel-group>seamless-sidebar-menu-item>a,.seamless-sidebar .panel-title .accordion-toggle>div{display:block;position:relative;height:42px;line-height:42px;margin-top:0;padding:0 0 0 calc(36px + 20px + 4px);font-size:12px;font-weight:600;color:#bec5cb;transition:color .2s;overflow:hidden}.seamless-sidebar .panel-body>a [class*=icon-]:first-child,.seamless-sidebar .panel-body>seamless-sidebar-menu-item>a [class*=icon-]:first-child,.seamless-sidebar .panel-group>a [class*=icon-]:first-child,.seamless-sidebar .panel-group>seamless-sidebar-menu-item>a [class*=icon-]:first-child,.seamless-sidebar .panel-title .accordion-toggle>div [class*=icon-]:first-child{position:absolute;left:0;top:50%;transform:translateY(-50%);display:block;width:36px;height:36px;line-height:36px;font-size:20px;text-align:center;background-size:20px 20px;background-repeat:no-repeat;background-position:center center}.seamless-sidebar .panel-body>a [class*=icon-]:nth-child(2),.seamless-sidebar .panel-body>seamless-sidebar-menu-item>a [class*=icon-]:nth-child(2),.seamless-sidebar .panel-group>a [class*=icon-]:nth-child(2),.seamless-sidebar .panel-group>seamless-sidebar-menu-item>a [class*=icon-]:nth-child(2),.seamless-sidebar .panel-title .accordion-toggle>div [class*=icon-]:nth-child(2){vertical-align:text-bottom;width:36px;height:36px;font-size:20px;text-align:center}.seamless-sidebar .panel-body>a.active,.seamless-sidebar .panel-body>seamless-sidebar-menu-item>a.active,.seamless-sidebar .panel-group>a.active,.seamless-sidebar .panel-group>seamless-sidebar-menu-item>a.active,.seamless-sidebar .panel-title .accordion-toggle>div.active{color:#fff}.seamless-sidebar .panel-body>a:not(.unclickable):not(.selected):hover,.seamless-sidebar .panel-body>seamless-sidebar-menu-item>a:not(.unclickable):not(.selected):hover,.seamless-sidebar .panel-group>a:not(.unclickable):not(.selected):hover,.seamless-sidebar .panel-group>seamless-sidebar-menu-item>a:not(.unclickable):not(.selected):hover,.seamless-sidebar .panel-title .accordion-toggle>div:not(.unclickable):not(.selected):hover{color:#fff;background-color:#21252d}.seamless-sidebar .panel-body>a.unclickable::before,.seamless-sidebar .panel-body>seamless-sidebar-menu-item>a.unclickable::before,.seamless-sidebar .panel-group>a.unclickable::before,.seamless-sidebar .panel-group>seamless-sidebar-menu-item>a.unclickable::before,.seamless-sidebar .panel-title .accordion-toggle>div.unclickable::before{font-family:csnicons;content:\"\uE9EC\";margin-right:2px;display:inline-block;width:15px;vertical-align:top}.seamless-sidebar .bottom-menu .panel-group>a.seamless{color:#fff}.seamless-sidebar .panel-body>a{height:32px;line-height:32px}.seamless-sidebar .panel-open{color:#fff;background-color:#21252d}.seamless-sidebar .panel-open .panel-title .accordion-toggle>div{color:#fff}.seamless-sidebar .panel-open .panel-title .accordion-toggle>div:after{color:#007cc2;font-weight:900;transform:translate(0,-50%) rotate(90deg)}.seamless-sidebar .seamless-sidebar__inner{position:absolute;left:0;top:0;z-index:1;width:250px;height:100%;margin:0;padding:0;opacity:1;transition:left .3s .1s,opacity .3s;overflow-y:auto;-webkit-overflow-scrolling:touch}.seamless-sidebar .seamless-sidebar__inner>div{height:inherit}.seamless-sidebar .icon-livemarket{background-image:url(assets/seamless/images/livemarket-icon.png)}.seamless-sidebar .icon-sourcing{background-image:url(assets/seamless/images/group@3x.png)}.seamless-sidebar .icon-inventory{background-image:url(assets/seamless/images/group-3@3x.png)}.seamless-sidebar .icon-prospects{background-image:url(assets/seamless/images/group-31@3x.png)}.seamless-sidebar .icon-campaigns{background-image:url(assets/seamless/images/noun-535331-cc@3x.png)}.seamless-sidebar .icon-other-modules{background-image:url(assets/seamless/images/other-modules-icon@3x.png)}.seamless-sidebar .icon-settings{background-image:url(assets/seamless/images/cog-md@2x.png)}.sidebar-cloak{position:fixed;top:100%;left:0;bottom:0;right:0;z-index:13;background-color:rgba(0,0,0,0);transition:background-color .3s cubic-bezier(.77,0,.175,1)}.sidebar-cloak.visible{top:0;background-color:rgba(0,0,0,.3)}@media (min-width:992px){.seamless-sidebar{top:80px;height:calc(100% - 80px);transform:translateX(0)}.seamless-sidebar .sidebar{left:0;width:250px}.sidebar-cloak{display:none}}"], encapsulation: 2 });
SidebarComponent.ctorParameters = () => [
    { type: LayoutService },
    { type: SidebarService },
    { type: AuthenticationService }
];
SidebarComponent = __decorate([ __metadata("design:paramtypes", [LayoutService,
        SidebarService,
        AuthenticationService])
], SidebarComponent);

class GaTrackingData {
    constructor() {
        this.memberTrackingId = null;
        this.items = [];
    }
}
class ClickEvent {
}

let GATrackingService = class GATrackingService {
    constructor(http, environment, window) {
        this.http = http;
        this.environment = environment;
        this.window = window;
        this.clickBuffer = [];
        this.trackingScriptLoaded = new BehaviorSubject(false);
        this.window = window;
    }
    init(data = null, itemsToAppend = null, searchResultItemsToAppend = null) {
        if (!this.environment.seamless.gATrackingScriptUrl) {
            return;
        }
        if (!this.window.CsnInsights || !this.window.CsnInsightsEventTracker) {
            console.warn('cannot find CsnInsights');
            return;
        }
        this.window.CsnInsights.metaData = {};
        this.window.CsnInsights.searchResults = {};
        if (data) {
            data.items.forEach((item) => {
                this.window.CsnInsights.metaData[item.key] = item.value;
            });
            if (itemsToAppend) {
                itemsToAppend.forEach((item) => {
                    this.window.CsnInsights.metaData[item.key] = item.value;
                });
            }
            if (searchResultItemsToAppend) {
                searchResultItemsToAppend.forEach((item) => {
                    this.window.CsnInsights.searchResults[item.key] = item.value;
                });
            }
            if (data.memberTrackingId && data.memberTrackingId !== '<!MEMBER_TRACKING_ID!>') {
                this.window.CsnInsights.memberTrackingId = data.memberTrackingId;
            }
        }
    }
    trackPageView(data = null, itemsToAppend = null, searchResultItemsToAppend = null) {
        if (!this.environment.seamless.gATrackingScriptUrl) {
            return;
        }
        try {
            this.init(data, itemsToAppend, searchResultItemsToAppend);
            this.window.CsnInsightsEventTracker.sendPageView(this.window.CsnInsights.metaData, window.location.pathname);
        }
        catch (ex) {
            console.error('error logging to ga: ' + ex);
        }
    }
    trackClick(eventCategory, eventLabel, eventData, metadataToAppend, data) {
        if (!this.environment.seamless.gATrackingScriptUrl) {
            return;
        }
        this.init(data, metadataToAppend, null);
        try {
            const event = new ClickEvent();
            event.metaData = this.window.CsnInsights.metaData;
            event.eventCategory = eventCategory;
            event.eventLabel = eventLabel;
            event.eventData = eventData;
            event.pathname = window.location.pathname;
            this.clickBuffer.push(event);
            this.clickBuffer.forEach((e) => {
                this.window.CsnInsightsEventTracker.sendClick(e.metaData, e.eventCategory, e.eventLabel, e.eventData, e.pathname, undefined);
            });
            this.clickBuffer = [];
        }
        catch (ex) {
            console.error('error logging to ga: ' + ex);
        }
    }
    convertToKeyValuePairs(object) {
        const keyValuePairArray = [];
        for (const key in object) {
            if (object.hasOwnProperty(key)) {
                keyValuePairArray.push({ key, value: object[key] });
            }
        }
        return keyValuePairArray;
    }
    /**
     * Load trackign script provided by BI
     * This should be used in stead of initGoogleAnalytics method
     */
    loadTrackingScript(url, elementId) {
        this.http.get(url, { observe: 'response' }).subscribe((r) => {
            if (r.status === 200) {
                const $el = document.getElementById(elementId);
                const fragment = document.createRange().createContextualFragment(`<script>
                        window.CsnInsights = window.CsnInsights || {};
                        CsnInsights.fireOnLoad = false;
                        CsnInsights.disableAttributeClickTracking = true;
                    </script>` + r.body.trackingScript);
                $el.appendChild(fragment);
                this.trackingScriptLoaded.next(true);
            }
        });
    }
    initGoogleAnalytics() {
        try {
            const script = document.createElement('script');
            script.innerHTML = `

        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

        ga('create', '${this.environment.seamless.googleAnalyticsKey}', 'auto');
        ga('send', 'pageview');

        `;
            document.head.appendChild(script);
        }
        catch (ex) {
            console.error('Error appending google analytics');
            console.error(ex);
        }
    }
};
GATrackingService.ɵfac = function GATrackingService_Factory(t) { return new (t || GATrackingService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT), ɵngcc0.ɵɵinject(WINDOW)); };
GATrackingService.ctorParameters = () => [
    { type: HttpClient },
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [WINDOW,] }] }
];
GATrackingService.ɵprov = ɵɵdefineInjectable({ factory: function GATrackingService_Factory() { return new GATrackingService(ɵɵinject(HttpClient), ɵɵinject(SEAMLESS_ENVIRONMENT), ɵɵinject(WINDOW)); }, token: GATrackingService, providedIn: "root" });
GATrackingService = __decorate([ __param(1, Inject(SEAMLESS_ENVIRONMENT)),
    __param(2, Inject(WINDOW)),
    __metadata("design:paramtypes", [HttpClient,
        Environment, Object])
], GATrackingService);

let GAClickDirective = class GAClickDirective {
    constructor(gaTrackingService) {
        this.gaTrackingService = gaTrackingService;
    }
    handleClick() {
        // [0] eventCategory
        // [1] eventLabel
        // [2] eventData - can be undefined
        if (this.csnGaClick && this.csnGaClick[0].length !== 0 && this.csnGaClick[1].length !== 0) {
            this.gaTrackingService.trackClick(this.csnGaClick[0], this.csnGaClick[1], this.csnGaClick[2]);
        }
        else {
            console.warn('Please provide string values to [0] eventCategory & [1] eventLabel');
        }
    }
};
GAClickDirective.ɵfac = function GAClickDirective_Factory(t) { return new (t || GAClickDirective)(ɵngcc0.ɵɵdirectiveInject(GATrackingService)); };
GAClickDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: GAClickDirective, selectors: [["", "seamlessGaClick", ""]], hostBindings: function GAClickDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function GAClickDirective_click_HostBindingHandler() { return ctx.handleClick(); });
    } }, inputs: { csnGaClick: ["seamlessGaClick", "csnGaClick"] } });
GAClickDirective.ctorParameters = () => [
    { type: GATrackingService }
];
__decorate([
    Input('seamlessGaClick'),
    __metadata("design:type", Array)
], GAClickDirective.prototype, "csnGaClick", void 0);
__decorate([
    HostListener('click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GAClickDirective.prototype, "handleClick", null);
GAClickDirective = __decorate([ __metadata("design:paramtypes", [GATrackingService])
], GAClickDirective);

let GATrackingComponent = class GATrackingComponent {
    constructor(gATrackingService, environment) {
        this.gATrackingService = gATrackingService;
        this.environment = environment;
    }
    ngOnInit() {
        if (this.environment.seamless.gATrackingScriptUrl) {
            this.gATrackingService.loadTrackingScript(this.environment.seamless.gATrackingScriptUrl, this.id);
        }
        else if (this.environment.seamless.googleAnalyticsKey) {
            this.gATrackingService.initGoogleAnalytics();
        }
    }
};
GATrackingComponent.ɵfac = function GATrackingComponent_Factory(t) { return new (t || GATrackingComponent)(ɵngcc0.ɵɵdirectiveInject(GATrackingService), ɵngcc0.ɵɵdirectiveInject(SEAMLESS_ENVIRONMENT)); };
GATrackingComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: GATrackingComponent, selectors: [["seamless-ga-tracking"]], inputs: { id: "id" }, decls: 1, vars: 1, consts: [[2, "display", "none", 3, "id"]], template: function GATrackingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id);
    } }, encapsulation: 2 });
GATrackingComponent.ctorParameters = () => [
    { type: GATrackingService },
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] }
];
__decorate([
    Input(),
    __metadata("design:type", String)
], GATrackingComponent.prototype, "id", void 0);
GATrackingComponent = __decorate([ __param(1, Inject(SEAMLESS_ENVIRONMENT)),
    __metadata("design:paramtypes", [GATrackingService, Environment])
], GATrackingComponent);

let HeaderAddOnsComponent = class HeaderAddOnsComponent {
    constructor() { }
};
HeaderAddOnsComponent.ɵfac = function HeaderAddOnsComponent_Factory(t) { return new (t || HeaderAddOnsComponent)(); };
HeaderAddOnsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HeaderAddOnsComponent, selectors: [["seamless-header-add-ons"]], ngContentSelectors: _c5, decls: 1, vars: 0, template: function HeaderAddOnsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [""] });
HeaderAddOnsComponent = __decorate([ __metadata("design:paramtypes", [])
], HeaderAddOnsComponent);

let SellerService = class SellerService {
    constructor(http, errorHandlerService, environment) {
        this.http = http;
        this.errorHandlerService = errorHandlerService;
        this.environment = environment;
        this.sellerSettings$ = new BehaviorSubject(null);
    }
    getSellerSettings() {
        const tenant = this.environment.seamless.tenant;
        const version = this.environment.seamless.api.version;
        const apiPath = Utilities.stripTrailingSlash(this.environment.seamless.api.sellers) + `/${tenant}/${version}/sellers/settings`;
        return this.http.get(apiPath).pipe(catchError(error => this.errorHandlerService.handleError(error)));
    }
};
SellerService.ɵfac = function SellerService_Factory(t) { return new (t || SellerService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(ErrorHandlerService), ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT)); };
SellerService.ctorParameters = () => [
    { type: HttpClient },
    { type: ErrorHandlerService },
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] }
];
SellerService.ɵprov = ɵɵdefineInjectable({ factory: function SellerService_Factory() { return new SellerService(ɵɵinject(HttpClient), ɵɵinject(ErrorHandlerService), ɵɵinject(SEAMLESS_ENVIRONMENT)); }, token: SellerService, providedIn: "root" });
SellerService = __decorate([ __param(2, Inject(SEAMLESS_ENVIRONMENT)),
    __metadata("design:paramtypes", [HttpClient,
        ErrorHandlerService,
        Environment])
], SellerService);

let PortalTokenDetailsService = class PortalTokenDetailsService {
    constructor(environment, http) {
        this.environment = environment;
        this.http = http;
    }
    fetchActiveUser() {
        if (this._cachedTokenDetails$) {
            return this._cachedTokenDetails$;
        }
        else {
            const apiPath = this.environment.seamless.autogateSessionDetails;
            this._cachedTokenDetails$ = this.http.get(apiPath).pipe(map(res => res), shareReplay(1));
            return this._cachedTokenDetails$;
        }
    }
};
PortalTokenDetailsService.ɵfac = function PortalTokenDetailsService_Factory(t) { return new (t || PortalTokenDetailsService)(ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT), ɵngcc0.ɵɵinject(ɵngcc3.HttpClient)); };
PortalTokenDetailsService.ctorParameters = () => [
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] },
    { type: HttpClient }
];
PortalTokenDetailsService.ɵprov = ɵɵdefineInjectable({ factory: function PortalTokenDetailsService_Factory() { return new PortalTokenDetailsService(ɵɵinject(SEAMLESS_ENVIRONMENT), ɵɵinject(HttpClient)); }, token: PortalTokenDetailsService, providedIn: "root" });
PortalTokenDetailsService = __decorate([ __param(0, Inject(SEAMLESS_ENVIRONMENT)),
    __metadata("design:paramtypes", [Environment, HttpClient])
], PortalTokenDetailsService);

let SidebarMenuComponent = class SidebarMenuComponent {
    constructor(layoutService, sidebarService, sellerService, portalTokenDetailsService) {
        this.layoutService = layoutService;
        this.sidebarService = sidebarService;
        this.sellerService = sellerService;
        this.portalTokenDetailsService = portalTokenDetailsService;
        this.sidebarItems = [];
        this.bottomItems = [];
    }
    onClick(el) {
        if (el.tagName === 'A') {
            this.layoutService.toggleState(Layout.MENU_DRAWER);
        }
    }
    ngOnInit() {
        this.sellerService.getSellerSettings().subscribe(sellerSettings => {
            this.sellerService.sellerSettings$.next(sellerSettings);
            const vertical = sellerSettings.sellerInfo.primaryMarket;
            this.portalTokenDetailsService.fetchActiveUser().subscribe((token) => {
                const supportMode = token.supportMode == 'GOD' ? true : false;
                this.getSidebarItems(vertical, supportMode);
                this.getBottomItems(vertical, supportMode);
            }, err => {
                this.getSidebarItems(vertical);
                this.getBottomItems(vertical);
                console.error('Failed to get token details ' + err);
            });
        });
    }
    getSidebarItems(vertical, supportMode = false) {
        this.isLoadingSidebarItems = true;
        this.sidebarService
            .getMenuItems('sidebar', supportMode)
            .pipe(map((response) => {
            return response;
        }), finalize(() => (this.isLoadingSidebarItems = false)))
            .subscribe(items => (this.sidebarItems = this.sidebarService.mapMenuItems(items, vertical)));
    }
    getBottomItems(vertical, supportMode = false) {
        this.isLoadingBottomItems = true;
        this.sidebarService
            .getMenuItems('bottom', supportMode)
            .pipe(map((response) => {
            return response;
        }), finalize(() => (this.isLoadingBottomItems = false)))
            .subscribe(items => (this.bottomItems = this.sidebarService.mapMenuItems(items, vertical)));
    }
};
SidebarMenuComponent.ɵfac = function SidebarMenuComponent_Factory(t) { return new (t || SidebarMenuComponent)(ɵngcc0.ɵɵdirectiveInject(LayoutService), ɵngcc0.ɵɵdirectiveInject(SidebarService), ɵngcc0.ɵɵdirectiveInject(SellerService), ɵngcc0.ɵɵdirectiveInject(PortalTokenDetailsService)); };
SidebarMenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SidebarMenuComponent, selectors: [["seamless-sidebar-menu"]], hostBindings: function SidebarMenuComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SidebarMenuComponent_click_HostBindingHandler($event) { return ctx.onClick($event.target); });
    } }, decls: 6, vars: 4, consts: [[1, "top-menu"], [3, "isAnimated", 4, "ngIf", "ngIfElse"], [1, "bottom-menu"], ["loadingSpinner", ""], [3, "isAnimated"], [4, "ngFor", "ngForOf"], [3, "sidebarItem"], [1, "seamless-loading-spinner", "seamless-loading-spinner--dark", "loading-spinner", "loading-spinner--dark"], [1, "seamless-loading-spinner__icon", "loading-spinner__icon"]], template: function SidebarMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, SidebarMenuComponent_accordion_1_Template, 2, 2, "accordion", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, SidebarMenuComponent_accordion_3_Template, 2, 2, "accordion", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, SidebarMenuComponent_ng_template_4_Template, 2, 0, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isLoadingSidebarItems)("ngIfElse", _r2);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isLoadingBottomItems)("ngIfElse", _r2);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc8.AccordionComponent, ɵngcc1.NgForOf, SidebarMenuItemComponent]; }, styles: ["[_nghost-%COMP%]{display:flex;height:100%;flex-direction:column;align-content:space-between}.top-menu[_ngcontent-%COMP%]{margin-bottom:42px}.bottom-menu[_ngcontent-%COMP%]{position:fixed;bottom:0;width:100%;background-color:#6e6e6e}@media (max-width:992px){.bottom-menu[_ngcontent-%COMP%]{margin-bottom:40px}}"] });
SidebarMenuComponent.ctorParameters = () => [
    { type: LayoutService },
    { type: SidebarService },
    { type: SellerService },
    { type: PortalTokenDetailsService }
];
__decorate([
    HostListener('click', ['$event.target']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [HTMLElement]),
    __metadata("design:returntype", void 0)
], SidebarMenuComponent.prototype, "onClick", null);
SidebarMenuComponent = __decorate([ __metadata("design:paramtypes", [LayoutService,
        SidebarService,
        SellerService,
        PortalTokenDetailsService])
], SidebarMenuComponent);

/**
 * The shared pagination component
 * Requires only total posts / limit and offset variables to bootstrap itself
 * it should default to currentPage = 1; pageBy = 12 and offset = 0
 * It should override defaults if query parameters are present
 */
let PaginationSeamlessComponent = class PaginationSeamlessComponent {
    constructor() {
        this.onPageChange = new EventEmitter();
        this.onPageSizeChange = new EventEmitter();
        this.currentPage = 1;
        this.showBoundaryLinks = true;
        this.showDirectionLinks = true;
        this.maxSize = 5;
        this.rotate = true;
        this.previousText = '&lsaquo;';
        this.nextText = '&rsaquo;';
        this.firstText = '&laquo;';
        this.lastText = '&raquo;';
    }
    ngOnChanges(changes) {
        this.currentPage = this.pageNum;
    }
    changePage(event) {
        this.onPageChange.emit(event.page);
    }
    changePageSize() {
        this.currentPage = 1;
        this.onPageSizeChange.emit(this.pageSize);
    }
};
PaginationSeamlessComponent.ɵfac = function PaginationSeamlessComponent_Factory(t) { return new (t || PaginationSeamlessComponent)(); };
PaginationSeamlessComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PaginationSeamlessComponent, selectors: [["seamless-pagination"]], inputs: { showBoundaryLinks: "showBoundaryLinks", showDirectionLinks: "showDirectionLinks", maxSize: "maxSize", rotate: "rotate", previousText: "previousText", nextText: "nextText", firstText: "firstText", lastText: "lastText", totalRecords: "totalRecords", pageSize: "pageSize", pageNum: "pageNum" }, outputs: { onPageChange: "onPageChange", onPageSizeChange: "onPageSizeChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["aria-label", "Page navigation", "class", "clearfix", 4, "ngIf"], ["aria-label", "Page navigation", 1, "clearfix"], [1, "pagination-container"], [3, "totalItems", "itemsPerPage", "ngModel", "boundaryLinks", "directionLinks", "maxSize", "rotate", "previousText", "nextText", "firstText", "lastText", "ngModelChange", "pageChanged"], [1, "page-by"], [1, "form-control", "naked", "input-sm", 3, "ngModel", "ngModelChange", "change"]], template: function PaginationSeamlessComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PaginationSeamlessComponent_nav_0_Template, 17, 12, "nav", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.totalRecords);
    } }, directives: [ɵngcc1.NgIf, ɵngcc9.PaginationComponent, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc6.SelectControlValueAccessor, ɵngcc6.NgSelectOption, ɵngcc6.ɵangular_packages_forms_forms_x], styles: [".pagination[_ngcontent-%COMP%]{width:100%;text-align:center;margin:calc(30px / 2) 0 0}.pagination[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:inline-block}.pagination[_ngcontent-%COMP%]   .first[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .pagination[_ngcontent-%COMP%]   .last[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-left:-12px}.pagination-container[_ngcontent-%COMP%]{float:left}.page-by[_ngcontent-%COMP%]{margin:12px auto;padding:6px 12px;line-height:30px;font-size:14px;text-align:center}.page-by[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{margin:0 4px;width:auto;display:inline-block}@media (min-width:992px){.pagination[_ngcontent-%COMP%]{width:auto;float:left;margin:calc(30px / 2) 0}.page-by[_ngcontent-%COMP%]{float:left;margin:12px 0;padding:6px 12px;line-height:30px;font-size:12px}.page-by[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{margin:0 4px;width:auto;display:inline-block}}"] });
__decorate([
    Input(),
    __metadata("design:type", Number)
], PaginationSeamlessComponent.prototype, "totalRecords", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], PaginationSeamlessComponent.prototype, "pageSize", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], PaginationSeamlessComponent.prototype, "pageNum", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PaginationSeamlessComponent.prototype, "showBoundaryLinks", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PaginationSeamlessComponent.prototype, "showDirectionLinks", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], PaginationSeamlessComponent.prototype, "maxSize", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PaginationSeamlessComponent.prototype, "rotate", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], PaginationSeamlessComponent.prototype, "previousText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], PaginationSeamlessComponent.prototype, "nextText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], PaginationSeamlessComponent.prototype, "firstText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], PaginationSeamlessComponent.prototype, "lastText", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PaginationSeamlessComponent.prototype, "onPageChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PaginationSeamlessComponent.prototype, "onPageSizeChange", void 0);
PaginationSeamlessComponent = __decorate([ __metadata("design:paramtypes", [])
], PaginationSeamlessComponent);

let NotFoundComponent = class NotFoundComponent {
    constructor() { }
    ngOnInit() { }
};
NotFoundComponent.ɵfac = function NotFoundComponent_Factory(t) { return new (t || NotFoundComponent)(); };
NotFoundComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NotFoundComponent, selectors: [["seamless-not-found"]], decls: 5, vars: 0, consts: [[1, "content-msg"]], template: function NotFoundComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h1");
        ɵngcc0.ɵɵtext(2, "404");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "h2");
        ɵngcc0.ɵɵtext(4, "Page Not Found");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".content-msg[_ngcontent-%COMP%]{text-align:center}.content-msg[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{color:#007cc2;font-size:5em;line-height:1em;margin-top:75px}.content-msg[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{margin-top:0}"] });
NotFoundComponent = __decorate([ __metadata("design:paramtypes", [])
], NotFoundComponent);

let AccountDrawerComponent = class AccountDrawerComponent {
    constructor(layoutService, authenticationService, customerService) {
        this.layoutService = layoutService;
        this.authenticationService = authenticationService;
        this.customerService = customerService;
        this.Layout = Layout;
        this.subscribers = {};
    }
    ngOnInit() {
        this.subscribers.layoutSubject = this.layoutService.getState(Layout.ACCOUNTS_DRAWER).subscribe(val => {
            this.isVisible = val;
        });
        // NOTE: Customer Service doesn't exist in private
        if (this.authenticationService.MemberOfSystemId !== MemberType.ActiveDirectory) {
            this.subscribers.isLoggedIn = combineLatest([this.authenticationService.isLoggedIn, this.customerService.customer$]).subscribe(([val, customer]) => {
                this.isLoggedIn = val;
                if (this.isLoggedIn) {
                    this.customer = customer;
                    this.profileImage = customer
                        ? customer.userDto.imageUrl
                            ? customer.userDto.imageUrl
                            : 'assets/seamless/images/avatar.png'
                        : 'assets/seamless/images/avatar.png';
                }
            });
        }
    }
    ngOnDestroy() {
        for (const key in this.subscribers) {
            if (this.subscribers.hasOwnProperty(key)) {
                const subscriber = this.subscribers[key];
                if (subscriber instanceof Subscription) {
                    subscriber.unsubscribe();
                }
            }
        }
    }
    toggle(layout) {
        this.layoutService.toggleState(layout);
    }
    logout() {
        this.authenticationService.logout(true);
        this.customerService.customer$.next(null);
        this.layoutService.toggleState(Layout.ACCOUNTS_DRAWER, false);
    }
};
AccountDrawerComponent.ɵfac = function AccountDrawerComponent_Factory(t) { return new (t || AccountDrawerComponent)(ɵngcc0.ɵɵdirectiveInject(LayoutService), ɵngcc0.ɵɵdirectiveInject(AuthenticationService), ɵngcc0.ɵɵdirectiveInject(CustomerService)); };
AccountDrawerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AccountDrawerComponent, selectors: [["seamless-account-drawer"]], ngContentSelectors: _c5, decls: 10, vars: 8, consts: [[1, "seamless-account-drawer", 3, "ngClass"], [1, "seamless-account-drawer__inner"], [1, "account"], [1, "account__card", "clearfix"], ["class", "account__image-container", 4, "ngIf"], ["class", "account__name name", 4, "ngIf"], [1, "btn", "btn-xs", "btn-secondary", "logout", 3, "click"], [1, "cloak", 3, "ngClass", "click"], [1, "account__image-container"], [1, "account__image", 3, "src", "alt"], [1, "account__name", "name"], [1, "name__firstName"], [1, "name__lastName"], [1, "name__position"]], template: function AccountDrawerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, AccountDrawerComponent_div_4_Template, 2, 2, "div", 4);
        ɵngcc0.ɵɵtemplate(5, AccountDrawerComponent_div_5_Template, 7, 3, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "button", 6);
        ɵngcc0.ɵɵlistener("click", function AccountDrawerComponent_Template_button_click_6_listener() { return ctx.logout(); });
        ɵngcc0.ɵɵtext(7, " Logout ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵlistener("click", function AccountDrawerComponent_Template_div_click_9_listener() { return ctx.toggle(ctx.Layout.ACCOUNTS_DRAWER); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c8, ctx.isVisible));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.customer);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.customer);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c9, ctx.isVisible));
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf], styles: [".seamless-account-drawer[_ngcontent-%COMP%]{position:fixed;z-index:1032;right:0;top:50px;transform:translateX(300px);width:300px;height:100%;background-color:#fff;padding-bottom:54px;transition:.3s cubic-bezier(.77,0,.175,1)}.seamless-account-drawer.open[_ngcontent-%COMP%]{transform:translateX(0);right:0}.seamless-account-drawer[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#fff;text-decoration:none}.seamless-account-drawer__inner[_ngcontent-%COMP%]{position:absolute;right:0;top:0;z-index:1;width:300px;height:100%;margin:0;padding:0 0 100px;opacity:1;transition:right .3s .1s,opacity .3s;overflow-y:auto;-webkit-overflow-scrolling:touch}.cloak[_ngcontent-%COMP%]{position:fixed;top:100%;left:0;bottom:0;right:0;z-index:13;background-color:rgba(0,0,0,0);transition:background-color .3s cubic-bezier(.77,0,.175,1)}.cloak.visible[_ngcontent-%COMP%]{top:0;background-color:rgba(0,0,0,.3)}@media (min-width:992px){.seamless-account-drawer[_ngcontent-%COMP%]{top:80px;height:calc(100% - 80px)}}.account[_ngcontent-%COMP%]{padding:20px 20px 15px 25px}.account__card[_ngcontent-%COMP%]{padding-bottom:15px;border-bottom:1px solid #e3e3e3}.account__image-container[_ngcontent-%COMP%]{float:left}.account__image[_ngcontent-%COMP%]{width:50px;height:50px;border-radius:9999px;margin-right:15px}.name__firstName[_ngcontent-%COMP%], .name__lastName[_ngcontent-%COMP%]{font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#4a4a4a;display:inline}.name__position[_ngcontent-%COMP%]{font-size:14px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:grey}.btn[_ngcontent-%COMP%]{color:#737373;border-color:#737373;float:right;margin-top:15px}"] });
AccountDrawerComponent.ctorParameters = () => [
    { type: LayoutService },
    { type: AuthenticationService },
    { type: CustomerService }
];
AccountDrawerComponent = __decorate([ __metadata("design:paramtypes", [LayoutService,
        AuthenticationService,
        CustomerService])
], AccountDrawerComponent);

let PagerSeamlessComponent = class PagerSeamlessComponent {
    constructor() {
        this.onPageChange = new EventEmitter();
        this.onPageSizeChange = new EventEmitter();
        this.currentPage = 1;
        this.boundaryLinks = true;
        this.directionLinks = true;
        this.maxSize = 5;
        this.rotate = true;
        this.previousText = 'Prev';
        this.nextText = 'Next';
    }
    ngOnChanges(changes) {
        this.currentPage = this.pageNum;
    }
    changePage(event) {
        this.onPageChange.emit(event.page);
    }
    changePageSize() {
        this.currentPage = 1;
        this.onPageSizeChange.emit(this.itemsPerPage);
    }
};
PagerSeamlessComponent.ɵfac = function PagerSeamlessComponent_Factory(t) { return new (t || PagerSeamlessComponent)(); };
PagerSeamlessComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PagerSeamlessComponent, selectors: [["seamless-pager"]], inputs: { boundaryLinks: "boundaryLinks", directionLinks: "directionLinks", maxSize: "maxSize", rotate: "rotate", previousText: "previousText", nextText: "nextText", pageNum: "pageNum", align: "align", disabled: "disabled", firstText: "firstText", itemsPerPage: "itemsPerPage", lastText: "lastText", pageBtnClass: "pageBtnClass", totalItems: "totalItems" }, outputs: { onPageChange: "onPageChange", onPageSizeChange: "onPageSizeChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["aria-label", "pager navigation", "class", "clearfix", 4, "ngIf"], ["aria-label", "pager navigation", 1, "clearfix"], [1, "pager-container"], [3, "totalItems", "itemsPerPage", "ngModel", "boundaryLinks", "directionLinks", "maxSize", "rotate", "previousText", "nextText", "firstText", "lastText", "pageBtnClass", "ngModelChange", "pageChanged"]], template: function PagerSeamlessComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PagerSeamlessComponent_nav_0_Template, 3, 12, "nav", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.totalItems);
    } }, directives: [ɵngcc1.NgIf, ɵngcc9.PagerComponent, ɵngcc6.NgControlStatus, ɵngcc6.NgModel], styles: [".pager-container[_ngcontent-%COMP%]{float:left}"] });
__decorate([
    Input(),
    __metadata("design:type", Number)
], PagerSeamlessComponent.prototype, "pageNum", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PagerSeamlessComponent.prototype, "align", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PagerSeamlessComponent.prototype, "boundaryLinks", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PagerSeamlessComponent.prototype, "directionLinks", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PagerSeamlessComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], PagerSeamlessComponent.prototype, "firstText", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], PagerSeamlessComponent.prototype, "itemsPerPage", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], PagerSeamlessComponent.prototype, "lastText", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], PagerSeamlessComponent.prototype, "maxSize", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], PagerSeamlessComponent.prototype, "nextText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], PagerSeamlessComponent.prototype, "pageBtnClass", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], PagerSeamlessComponent.prototype, "previousText", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PagerSeamlessComponent.prototype, "rotate", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], PagerSeamlessComponent.prototype, "totalItems", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PagerSeamlessComponent.prototype, "onPageChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PagerSeamlessComponent.prototype, "onPageSizeChange", void 0);
PagerSeamlessComponent = __decorate([ __metadata("design:paramtypes", [])
], PagerSeamlessComponent);

let BreadcrumbsComponent = class BreadcrumbsComponent {
    constructor() {
        this.items = [];
    }
    get trail() {
        return this.items.slice(0, this.items.length - 1);
    }
    get active() {
        return this.items[this.items.length - 1];
    }
};
BreadcrumbsComponent.ɵfac = function BreadcrumbsComponent_Factory(t) { return new (t || BreadcrumbsComponent)(); };
BreadcrumbsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbsComponent, selectors: [["seamless-breadcrumbs"]], inputs: { items: "items" }, decls: 5, vars: 2, consts: [[1, "breadcrumb"], [1, "breadcrumb__trail"], [4, "ngFor", "ngForOf"], [1, "breadcrumb__item", "breadcrumb__item--current"], ["class", "breadcrumb__item", 4, "ngIf"], ["class", "breadcrumb__item", 3, "routerLink", 4, "ngIf", "ngIfElse"], ["external", ""], [1, "breadcrumb__item"], [1, "breadcrumb__item", 3, "routerLink"], ["class", "breadcrumb__item", 3, "href", "target", 4, "ngIf"], [1, "breadcrumb__item", 3, "href", "target"]], template: function BreadcrumbsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, BreadcrumbsComponent_ng_container_2_Template, 5, 3, "ng-container", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.trail);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.active.label);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc5.RouterLinkWithHref], styles: [".breadcrumb[_ngcontent-%COMP%]{margin:40px 0 28px;padding:0}.breadcrumb__trail[_ngcontent-%COMP%]{color:#666;font-weight:600}.breadcrumb__item[_ngcontent-%COMP%]{color:#007cc2}.breadcrumb__item--current[_ngcontent-%COMP%]{color:inherit}"] });
__decorate([
    Input(),
    __metadata("design:type", Array)
], BreadcrumbsComponent.prototype, "items", void 0);
BreadcrumbsComponent = __decorate([ __metadata("design:paramtypes", [])
], BreadcrumbsComponent);

let SidebarMenuItemComponent = class SidebarMenuItemComponent {
    constructor(router) {
        this.router = router;
        this.elementId = null;
        this.unreachableMessage = "We're sorry this service is unavailable!";
        this.menuItemSelected = false;
    }
    ngOnInit() {
        this.setElementId();
        this.isSelected();
    }
    setElementId() {
        // Remove space in item name
        const itemName = this.sidebarItem.name.replace(/\s+/g, '');
        if (!this.sidebarItem.parentName) {
            this.elementId = itemName;
        }
        else {
            const parentName = this.sidebarItem.parentName.replace(/\s+/g, '');
            this.elementId = `${parentName}${itemName}`;
        }
    }
    navigate() {
        if (this.sidebarItem.isUnreachable) {
            return;
        }
        const routes = this.getAvailableRoutes();
        const itemPath = Utilities.stripLeadingSlash(Utilities.stripTrailingSlash(this.sidebarItem.path));
        // Check if item path is defined in routes, if exists navigate to the path
        // otherwise redirect to the full url
        if (routes.includes(itemPath)) {
            this.router.navigate([itemPath]);
            return;
        }
        window.location.assign(this.sidebarItem.linkUrl);
    }
    getAvailableRoutes() {
        const routes = this.router.config.map(r => {
            if (r['_loadedConfig']) {
                return r['_loadedConfig'].routes.map(n => Utilities.stripLeadingSlash(Utilities.stripTrailingSlash(Utilities.convertRoutesToRegex(n.path))));
            }
            else {
                return Utilities.stripLeadingSlash(Utilities.stripTrailingSlash(Utilities.convertRoutesToRegex(r.path)));
            }
        });
        return [].concat.apply([], routes);
    }
    isSelected() {
        if (this.sidebarItem.path) {
            this.menuItemSelected = window.location.href.toLowerCase().includes(this.sidebarItem.path.toLowerCase());
        }
    }
};
SidebarMenuItemComponent.ɵfac = function SidebarMenuItemComponent_Factory(t) { return new (t || SidebarMenuItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.Router)); };
SidebarMenuItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SidebarMenuItemComponent, selectors: [["seamless-sidebar-menu-item"]], inputs: { sidebarItem: "sidebarItem" }, decls: 3, vars: 2, consts: [["role", "button", "routerLinkActive", "active", "test-id", "menuItemLink", "accordion-heading", "", "placement", "bottom", "triggers", "mouseenter:mouseleave", 3, "id", "ngClass", "tooltip", "isDisabled", "click", 4, "ngIf", "ngIfElse"], ["childrenGroup", ""], ["role", "button", "routerLinkActive", "active", "test-id", "menuItemLink", "accordion-heading", "", "placement", "bottom", "triggers", "mouseenter:mouseleave", 3, "id", "ngClass", "tooltip", "isDisabled", "click"], [3, "ngClass"], ["class", "icon-lock-lg", 4, "ngIf"], [1, "icon-lock-lg"], [3, "id"], ["accordion-heading", ""], [3, "sidebarItem", 4, "ngFor", "ngForOf"], [3, "sidebarItem"]], template: function SidebarMenuItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SidebarMenuItemComponent_a_0_Template, 7, 17, "a", 0);
        ɵngcc0.ɵɵtemplate(1, SidebarMenuItemComponent_ng_template_1_Template, 8, 10, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.sidebarItem.hasChildren || ctx.sidebarItem.isLocked)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf, ɵngcc5.RouterLinkActive, ɵngcc1.NgClass, ɵngcc10.TooltipDirective, ɵngcc8.AccordionPanelComponent, ɵngcc1.NgForOf, SidebarMenuItemComponent], pipes: [ɵngcc1.UpperCasePipe, ɵngcc7.TranslatePipe], styles: ["a.seamless.unavailable[_ngcontent-%COMP%]{color:#5d5d5d}a.seamless.selected[_ngcontent-%COMP%]{color:#fff;background-color:#007cc2;border-radius:4px;margin:5px;padding-left:calc(36px + 20px - 1px)}[_nghost-%COMP%] .tooltip-inner{background-color:#5d5d5d;color:#fff;font-size:12px}[_nghost-%COMP%] .tooltip.bottom .tooltip-arrow, [_nghost-%COMP%] .tooltip.bottom .tooltip-arrow:before{border-bottom-color:#5d5d5d}[_nghost-%COMP%] .tooltip.top .tooltip-arrow, [_nghost-%COMP%] .tooltip.top .tooltip-arrow:before{border-top-color:#5d5d5d}"] });
SidebarMenuItemComponent.ctorParameters = () => [
    { type: Router }
];
__decorate([
    Input(),
    __metadata("design:type", SidebarItem)
], SidebarMenuItemComponent.prototype, "sidebarItem", void 0);
SidebarMenuItemComponent = __decorate([ __metadata("design:paramtypes", [Router])
], SidebarMenuItemComponent);

let SidebarMenuCustomComponent = class SidebarMenuCustomComponent {
    constructor(layoutService) {
        this.layoutService = layoutService;
    }
    onClick(el) {
        if (el.tagName === 'A') {
            this.layoutService.toggleState(Layout.MENU_DRAWER);
        }
    }
};
SidebarMenuCustomComponent.ɵfac = function SidebarMenuCustomComponent_Factory(t) { return new (t || SidebarMenuCustomComponent)(ɵngcc0.ɵɵdirectiveInject(LayoutService)); };
SidebarMenuCustomComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SidebarMenuCustomComponent, selectors: [["seamless-sidebar-menu-custom"]], hostBindings: function SidebarMenuCustomComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SidebarMenuCustomComponent_click_HostBindingHandler($event) { return ctx.onClick($event.target); });
    } }, ngContentSelectors: _c5, decls: 1, vars: 0, template: function SidebarMenuCustomComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [""] });
SidebarMenuCustomComponent.ctorParameters = () => [
    { type: LayoutService }
];
__decorate([
    HostListener('click', ['$event.target']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [HTMLElement]),
    __metadata("design:returntype", void 0)
], SidebarMenuCustomComponent.prototype, "onClick", null);
SidebarMenuCustomComponent = __decorate([ __metadata("design:paramtypes", [LayoutService])
], SidebarMenuCustomComponent);

let GAMTrackingService = class GAMTrackingService {
    constructor(environment, window) {
        this.environment = environment;
        this.window = window;
        this.window = window;
    }
    initGoogleAdManager() {
        try {
            const script = document.createElement('script');
            script.innerHTML = `
      (function() { var a = String(Math.floor(Math.random() * 10000000000000000));
      new Image().src = 'https://pubads.g.doubleclick.net/activity;dc_iu=/21842759191/DFPAudiencePixel;ord=' + a + ';dc_seg=7745005496?';
      })();
      `;
            document.head.appendChild(script);
            const noscript = document.createElement('noscript');
            var imgElement = document.createElement('img');
            imgElement.setAttribute('src', 'https://pubads.g.doubleclick.net/activity;dc_iu=/21842759191/DFPAudiencePixel;ord=1;dc_seg=7745005496?');
            imgElement.setAttribute('height', '1');
            imgElement.setAttribute('width', '1');
            imgElement.setAttribute('border', '0');
            noscript.appendChild(imgElement);
            document.head.appendChild(noscript);
        }
        catch (ex) {
            console.error('Error appending google ad manager');
            console.error(ex);
        }
    }
};
GAMTrackingService.ɵfac = function GAMTrackingService_Factory(t) { return new (t || GAMTrackingService)(ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT), ɵngcc0.ɵɵinject(WINDOW)); };
GAMTrackingService.ctorParameters = () => [
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [WINDOW,] }] }
];
GAMTrackingService.ɵprov = ɵɵdefineInjectable({ factory: function GAMTrackingService_Factory() { return new GAMTrackingService(ɵɵinject(SEAMLESS_ENVIRONMENT), ɵɵinject(WINDOW)); }, token: GAMTrackingService, providedIn: "root" });
GAMTrackingService = __decorate([ __param(0, Inject(SEAMLESS_ENVIRONMENT)), __param(1, Inject(WINDOW)),
    __metadata("design:paramtypes", [Environment, Object])
], GAMTrackingService);

let GAMTrackingComponent = class GAMTrackingComponent {
    constructor(gamTrackingService, environment) {
        this.gamTrackingService = gamTrackingService;
        this.environment = environment;
    }
    ngOnInit() {
        if (this.environment.seamless.environment === Environments.Production) {
            this.gamTrackingService.initGoogleAdManager();
        }
    }
};
GAMTrackingComponent.ɵfac = function GAMTrackingComponent_Factory(t) { return new (t || GAMTrackingComponent)(ɵngcc0.ɵɵdirectiveInject(GAMTrackingService), ɵngcc0.ɵɵdirectiveInject(SEAMLESS_ENVIRONMENT)); };
GAMTrackingComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: GAMTrackingComponent, selectors: [["seamless-gam-tracking"]], inputs: { id: "id" }, decls: 1, vars: 1, consts: [[2, "display", "none", 3, "id"]], template: function GAMTrackingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id);
    } }, encapsulation: 2 });
GAMTrackingComponent.ctorParameters = () => [
    { type: GAMTrackingService },
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] }
];
__decorate([
    Input(),
    __metadata("design:type", String)
], GAMTrackingComponent.prototype, "id", void 0);
GAMTrackingComponent = __decorate([ __param(1, Inject(SEAMLESS_ENVIRONMENT)),
    __metadata("design:paramtypes", [GAMTrackingService, Environment])
], GAMTrackingComponent);

let SeamlessCoreModule = class SeamlessCoreModule {
};
SeamlessCoreModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SeamlessCoreModule });
SeamlessCoreModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SeamlessCoreModule_Factory(t) { return new (t || SeamlessCoreModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            RouterModule,
            BsDatepickerModule,
            BsDropdownModule,
            TabsModule,
            CarouselModule,
            CollapseModule,
            TooltipModule,
            ModalModule,
            AlertModule,
            AccordionModule,
            TranslateModule,
            PaginationModule,
            TypeaheadModule,
            StoreModule,
            EffectsModule
        ]] });

let AuthInterceptorService = class AuthInterceptorService {
    constructor(storageService, authenticationService, cookieService, storageKeyService, environment) {
        this.storageService = storageService;
        this.authenticationService = authenticationService;
        this.cookieService = cookieService;
        this.storageKeyService = storageKeyService;
        this.environment = environment;
        this.tokenRefreshed = new Subject();
        this.refreshToken = new BehaviorSubject(null);
        this.isRefreshingToken = false;
        this.isLogginOut = false;
        this.cookieOptions = this.environment.seamless.cookieOptions;
    }
    addToken(request, token, isRefreshing = false) {
        // append auth query string for uat/ prod requests within development environment
        if (this.environment.seamless.environment === Environments.Development &&
            typeof this.environment.seamless.appendTokenToDomain !== 'undefined' &&
            request.url.indexOf(this.environment.seamless.appendTokenToDomain) >= 0) {
            const appendedQueryStringSymbol = request.url.indexOf('?') >= 0 ? '&' : '?';
            return request.clone({
                url: `${request.url}${appendedQueryStringSymbol}authorization=${token}`,
            });
        }
        if ((!this.authenticationService.tokenExpired() && this.authenticationService.hasToken()) || isRefreshing) {
            return request.clone({
                setHeaders: { Authorization: `Bearer ${token}` },
            });
        }
        return request;
    }
    handle401Error(error, req, next) {
        if (!this.authenticationService.hasToken()) {
            console.error('no token');
            if (!this.isLogginOut) {
                this.isLogginOut = true;
                this.authenticationService.logout();
            }
            return throwError(error);
        }
        if (error && error.status === 401 && error.error && error.error.error === 'Attempted to perform an unauthorized operation.') {
            // The HTTP Interceptor is capturing the 401 response frpm trade auth
            // before the catch error so we need to mannualy catch it here to  logout
            this.authenticationService.logout();
        }
        if (!this.isRefreshingToken) {
            this.isRefreshingToken = true;
            // Reset here so that the following requests wait until the token
            // comes back from the refreshToken call.
            this.refreshToken.next(null);
            return this.authenticationService.refreshToken().pipe(switchMap((res) => {
                if (res) {
                    if (res.token) {
                        if (this.authenticationService.MemberOfSystemId === MemberType.Portal) {
                            /* set cookie with token key */
                            this.cookieService.put(this.storageKeyService.JWT_TOKEN, res.token, this.cookieOptions);
                            this.storageService.set(this.storageKeyService.JWT_TOKEN, res.token);
                        }
                        this.refreshToken.next(res.token);
                        return next.handle(this.addToken(req, res.token, true));
                    }
                    else {
                        this.storageService.set(this.storageKeyService.JWT_TOKEN, res.tokenSummary.token);
                        this.cookieService.put(this.storageKeyService.JWT_TOKEN, res.tokenSummary.token, this.cookieOptions);
                        this.refreshToken.next(res.tokenSummary.token);
                        return next.handle(this.addToken(req, res.tokenSummary.token, true));
                    }
                }
                // If we don't get a new token, we are in trouble so logout.
                console.log("couldn't get refreshed token");
                this.authenticationService.logout();
                return empty();
            }), catchError((err) => {
                // If there is an exception, bad news so logout.
                // This can happen if the cloned request has been updated but is still unauthorized
                this.authenticationService.logout();
                return throwError(err);
            }), finalize(() => {
                this.isRefreshingToken = false;
            }));
        }
        else {
            return this.refreshToken.pipe(filter((token) => token !== null), take(1), switchMap((token) => {
                return next.handle(this.addToken(req, token));
            }));
        }
    }
    handle400Error(error) {
        if (error && error.status === 400 && error.error && error.error.error === 'invalid_grant') {
            // If we get a 400 and the error message is 'invalid_grant', the token is no longer valid so logout.
            this.authenticationService.logout();
        }
        return throwError(error);
    }
    intercept(req, next) {
        if (req.url.includes('assets/')) {
            // requesting local assets file, token header not needed
            return next.handle(req);
        }
        return next.handle(this.addToken(req, this.authenticationService.getToken(), req.url.includes('/refresh'))).pipe(catchError((error) => {
            if (error instanceof HttpErrorResponse) {
                switch (error.status) {
                    case 400:
                        return this.handle400Error(error);
                    case 401:
                        return this.handle401Error(error, req, next);
                    case 403:
                        console.log('Access Denied');
                        return throwError(error);
                    default:
                        return throwError(error);
                }
            }
            else {
                return throwError(error);
            }
        }), finalize(() => { }));
    }
};
AuthInterceptorService.ɵfac = function AuthInterceptorService_Factory(t) { return new (t || AuthInterceptorService)(ɵngcc0.ɵɵinject(LocalStorageService), ɵngcc0.ɵɵinject(AuthenticationService), ɵngcc0.ɵɵinject(ɵngcc4.CookieService), ɵngcc0.ɵɵinject(StorageKeyService), ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT)); };
AuthInterceptorService.ctorParameters = () => [
    { type: LocalStorageService },
    { type: AuthenticationService },
    { type: CookieService },
    { type: StorageKeyService },
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] }
];
AuthInterceptorService.ɵprov = ɵɵdefineInjectable({ factory: function AuthInterceptorService_Factory() { return new AuthInterceptorService(ɵɵinject(LocalStorageService), ɵɵinject(AuthenticationService), ɵɵinject(CookieService), ɵɵinject(StorageKeyService), ɵɵinject(SEAMLESS_ENVIRONMENT)); }, token: AuthInterceptorService, providedIn: "root" });
AuthInterceptorService = __decorate([ __param(4, Inject(SEAMLESS_ENVIRONMENT)),
    __metadata("design:paramtypes", [LocalStorageService,
        AuthenticationService,
        CookieService,
        StorageKeyService,
        Environment])
], AuthInterceptorService);

const reducers = {};

const effects = [];

// AoT requires an exported function for factories
function createTranslateLoader(http) {
    return new TranslateHttpLoader(http, 'assets/seamless/i18n/languages/', '.json');
}
let SeamlessCoreRootModule = class SeamlessCoreRootModule {
};
SeamlessCoreRootModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SeamlessCoreRootModule });
SeamlessCoreRootModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SeamlessCoreRootModule_Factory(t) { return new (t || SeamlessCoreRootModule)(); }, providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useExisting: AuthInterceptorService,
            multi: true
        },
        WINDOW_PROVIDERS,
    ], imports: [[
            CommonModule,
            HttpClientModule,
            FormsModule,
            BrowserAnimationsModule,
            CookieModule.forRoot(),
            ToastrModule.forRoot(),
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: createTranslateLoader,
                    deps: [HttpClient]
                }
            }),
            BsDatepickerModule.forRoot(),
            BsDropdownModule.forRoot(),
            TabsModule.forRoot(),
            CarouselModule.forRoot(),
            CollapseModule.forRoot(),
            TooltipModule.forRoot(),
            ModalModule.forRoot(),
            AlertModule.forRoot(),
            AccordionModule.forRoot(),
            PaginationModule.forRoot(),
            SeamlessCoreModule,
            TypeaheadModule.forRoot(),
            StoreModule.forRoot({}),
            EffectsModule.forRoot([]),
            StoreDevtoolsModule.instrument({
                name: 'SEAMLESS NGRX'
            }),
            StoreModule.forFeature('seamless', reducers),
            EffectsModule.forFeature(effects),
        ],
        SeamlessCoreModule] });

const routes = [
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: '404', component: NotFoundComponent },
    { path: '**', redirectTo: '/404' }
];
let SeamlessCoreRoutingModule = class SeamlessCoreRoutingModule {
};
SeamlessCoreRoutingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SeamlessCoreRoutingModule });
SeamlessCoreRoutingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SeamlessCoreRoutingModule_Factory(t) { return new (t || SeamlessCoreRoutingModule)(); }, imports: [[RouterModule.forChild(routes)],
        RouterModule] });

let SeamlessCommonModule = class SeamlessCommonModule {
};
SeamlessCommonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SeamlessCommonModule });
SeamlessCommonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SeamlessCommonModule_Factory(t) { return new (t || SeamlessCommonModule)(); }, imports: [[SeamlessCoreModule],
        SeamlessCoreModule] });

let CheckAppVersionService = class CheckAppVersionService {
    constructor(http) {
        this.http = http;
    }
    getAppVersion() {
        return this.http.get(`assets/version.json`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache'
            }),
            observe: 'response'
        });
    }
    setAppVersion(version) {
        this.version = version;
    }
};
CheckAppVersionService.ɵfac = function CheckAppVersionService_Factory(t) { return new (t || CheckAppVersionService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient)); };
CheckAppVersionService.ctorParameters = () => [
    { type: HttpClient }
];
CheckAppVersionService.ɵprov = ɵɵdefineInjectable({ factory: function CheckAppVersionService_Factory() { return new CheckAppVersionService(ɵɵinject(HttpClient)); }, token: CheckAppVersionService, providedIn: "root" });
CheckAppVersionService = __decorate([ __metadata("design:paramtypes", [HttpClient])
], CheckAppVersionService);

let ClaimService = class ClaimService {
    constructor(_http) {
        this._http = _http;
        this.url = '/api/proxy/claims';
    }
    /**
     * fire to store user clamis for authorisation in the server side.
     */
    get() {
        return this._http.get(`${this.url}`).pipe(map((response) => {
            this.claims = response;
            return this.claims;
        }));
    }
    getByType(claimType) {
        return this.claims.find(claim => claim.m_type === claimType);
    }
};
ClaimService.ɵfac = function ClaimService_Factory(t) { return new (t || ClaimService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient)); };
ClaimService.ctorParameters = () => [
    { type: HttpClient }
];
ClaimService.ɵprov = ɵɵdefineInjectable({ factory: function ClaimService_Factory() { return new ClaimService(ɵɵinject(HttpClient)); }, token: ClaimService, providedIn: "root" });
ClaimService = __decorate([ __metadata("design:paramtypes", [HttpClient])
], ClaimService);

let LowerCaseUrlSerializerService = class LowerCaseUrlSerializerService extends DefaultUrlSerializer {
    parse(url) {
        return super.parse(url.toLowerCase());
    }
};
LowerCaseUrlSerializerService.ɵfac = function LowerCaseUrlSerializerService_Factory(t) { return ɵLowerCaseUrlSerializerService_BaseFactory(t || LowerCaseUrlSerializerService); };
LowerCaseUrlSerializerService.ɵprov = ɵɵdefineInjectable({ factory: function LowerCaseUrlSerializerService_Factory() { return new LowerCaseUrlSerializerService(); }, token: LowerCaseUrlSerializerService, providedIn: "root" });

let BehaviourSubjectManagerService = class BehaviourSubjectManagerService {
    constructor() {
        this.subject = new BehaviorSubject(undefined);
    }
    sendSubject(message) {
        this.subject.next({ body: message });
    }
    clearSubject() {
        this.subject.next(undefined);
    }
    getSubject() {
        return this.subject.asObservable();
    }
};
BehaviourSubjectManagerService.ɵfac = function BehaviourSubjectManagerService_Factory(t) { return new (t || BehaviourSubjectManagerService)(); };
BehaviourSubjectManagerService.ɵprov = ɵɵdefineInjectable({ factory: function BehaviourSubjectManagerService_Factory() { return new BehaviourSubjectManagerService(); }, token: BehaviourSubjectManagerService, providedIn: "root" });

let ReplaySubjectManagerService = class ReplaySubjectManagerService {
    constructor() {
        this.subject = new ReplaySubject();
    }
    sendSubject(message) {
        this.subject.next({ text: message });
    }
    clearSubject() {
        this.subject.next(undefined);
    }
    getSubject() {
        return this.subject.asObservable();
    }
};
ReplaySubjectManagerService.ɵfac = function ReplaySubjectManagerService_Factory(t) { return new (t || ReplaySubjectManagerService)(); };
ReplaySubjectManagerService.ɵprov = ɵɵdefineInjectable({ factory: function ReplaySubjectManagerService_Factory() { return new ReplaySubjectManagerService(); }, token: ReplaySubjectManagerService, providedIn: "root" });

let SubjectManagerService = class SubjectManagerService {
    constructor() {
        this.subject = new Subject();
    }
    sendSubject(message) {
        this.subject.next(message);
    }
    clearSubject() {
        this.subject.next();
    }
    getSubject() {
        return this.subject.asObservable();
    }
};
SubjectManagerService.ɵfac = function SubjectManagerService_Factory(t) { return new (t || SubjectManagerService)(); };
SubjectManagerService.ɵprov = ɵɵdefineInjectable({ factory: function SubjectManagerService_Factory() { return new SubjectManagerService(); }, token: SubjectManagerService, providedIn: "root" });

let AppTranslateService = class AppTranslateService {
    constructor(_http, _translateService, _storageService, storageKeyService, environment) {
        this._http = _http;
        this._translateService = _translateService;
        this._storageService = _storageService;
        this.storageKeyService = storageKeyService;
        this.environment = environment;
        this.onLanguageChanged = new Subject();
        this.languagesUpdated = new Subject();
        this.languages = new Array();
        this.getUserSettingsUrl = `${this.environment.seamless.UserManagementApi}/usersettings`;
        this.updateUserSettingUrl = `${this.environment.seamless.UserManagementApi}/usersetting`;
    }
    getBrowserLanguage() {
        return navigator.language;
    }
    setLanguages(languages) {
        this.languages = languages;
        this.languagesUpdated.next(this.languages);
    }
    /** get all languages */
    get() {
        return this.languages;
    }
    getCurrentLanguage() {
        return this._translateService.currentLang;
    }
    getByLanguageCode(value) {
        if (this.languages) {
            return this.get().find((language) => language.code === value);
        }
        return undefined;
    }
    getLanguageConfig() {
        return this._http.get('assets/seamless/i18n/config.json').pipe(map((response) => {
            const languages = response.languages;
            this.setLanguages(languages);
        }));
    }
    getUserLanguage(membershipId) {
        return this._http.get(`${this.getUserSettingsUrl}/${membershipId}`).pipe(map((response) => {
            return response.Settings.find((setting) => setting.Name === 'Language').Value;
        }));
    }
    /** set app language by languageCode */
    set(languageCode) {
        this._translateService.use(languageCode);
        this._storageService.set(this.storageKeyService.CURRENT_TRANSLATION, languageCode);
        this.onLanguageChanged.next(this.getByLanguageCode(languageCode));
    }
    /** set language to use as fallback */
    setDefaultLanguage() {
        this._translateService.use(this.getBrowserLanguage());
        this._translateService.setDefaultLang('en');
    }
    setUserLanguage(membershipId, languageCode) {
        const viewModel = {
            MemberShipId: membershipId,
            Setting: { Name: 'Language', Value: languageCode },
        };
        return this._http.post(`${this.updateUserSettingUrl}/${membershipId}`, JSON.stringify(viewModel));
    }
};
AppTranslateService.ɵfac = function AppTranslateService_Factory(t) { return new (t || AppTranslateService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(ɵngcc7.TranslateService), ɵngcc0.ɵɵinject(LocalStorageService), ɵngcc0.ɵɵinject(StorageKeyService), ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT)); };
AppTranslateService.ctorParameters = () => [
    { type: HttpClient },
    { type: TranslateService },
    { type: LocalStorageService },
    { type: StorageKeyService },
    { type: undefined, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] }
];
AppTranslateService.ɵprov = ɵɵdefineInjectable({ factory: function AppTranslateService_Factory() { return new AppTranslateService(ɵɵinject(HttpClient), ɵɵinject(TranslateService), ɵɵinject(LocalStorageService), ɵɵinject(StorageKeyService), ɵɵinject(SEAMLESS_ENVIRONMENT)); }, token: AppTranslateService, providedIn: "root" });
AppTranslateService = __decorate([ __param(4, Inject(SEAMLESS_ENVIRONMENT)),
    __metadata("design:paramtypes", [HttpClient,
        TranslateService,
        LocalStorageService,
        StorageKeyService, Object])
], AppTranslateService);

let CustomEncoder = class CustomEncoder extends HttpUrlEncodingCodec {
    encodeKey(key) {
        return encodeURIComponent(key);
    }
    encodeValue(value) {
        return encodeURIComponent(value);
    }
    decodeKey(key) {
        return decodeURIComponent(key);
    }
    decodeValue(value) {
        return decodeURIComponent(value);
    }
};
CustomEncoder.ɵfac = function CustomEncoder_Factory(t) { return ɵCustomEncoder_BaseFactory(t || CustomEncoder); };
CustomEncoder.ɵprov = ɵɵdefineInjectable({ factory: function CustomEncoder_Factory() { return new CustomEncoder(); }, token: CustomEncoder, providedIn: "root" });

let AppInfoService = class AppInfoService {
    displaySeamlessVersion() {
        // try {
        //   const seamlessVersion = require('../../../../../package.json').dependencies['@csn-trade/seamless'];
        //   if (seamlessVersion) {
        //     console.log('Application is running on Seamless version ' + seamlessVersion);
        //   } else {
        //     console.warn('Seamless version not found');
        //   }
        // } catch (e) {
        //   console.warn('Unable to read Seamless version: ' + e);
        // }
    }
};
AppInfoService.ɵfac = function AppInfoService_Factory(t) { return new (t || AppInfoService)(); };
AppInfoService.ɵprov = ɵɵdefineInjectable({ factory: function AppInfoService_Factory() { return new AppInfoService(); }, token: AppInfoService, providedIn: "root" });

let SubscriptionApiGatewayService = class SubscriptionApiGatewayService {
    constructor(http, environment) {
        this.http = http;
        this.environment = environment;
    }
    getActiveServicesForDealers(params) {
        const api = Utilities.stripTrailingSlash(this.environment.seamless.api.subscriptionApiGateway);
        const apiPath = api + `/api/${this.environment.seamless.tenant}/v1/DealerServices/GetActiveServicesForDealers`;
        return this.http
            .post(apiPath, params)
            .pipe(catchError((httpErrorResponse) => this.handleError(httpErrorResponse)));
    }
    handleError(error) {
        return throwError(error);
    }
};
SubscriptionApiGatewayService.ɵfac = function SubscriptionApiGatewayService_Factory(t) { return new (t || SubscriptionApiGatewayService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT)); };
SubscriptionApiGatewayService.ctorParameters = () => [
    { type: HttpClient },
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] }
];
SubscriptionApiGatewayService.ɵprov = ɵɵdefineInjectable({ factory: function SubscriptionApiGatewayService_Factory() { return new SubscriptionApiGatewayService(ɵɵinject(HttpClient), ɵɵinject(SEAMLESS_ENVIRONMENT)); }, token: SubscriptionApiGatewayService, providedIn: "root" });
SubscriptionApiGatewayService = __decorate([ __param(1, Inject(SEAMLESS_ENVIRONMENT)),
    __metadata("design:paramtypes", [HttpClient, Environment])
], SubscriptionApiGatewayService);

let AuthenticationGuard = class AuthenticationGuard {
    constructor(authenticationService, localStorageService, storageKeyService) {
        this.authenticationService = authenticationService;
        this.localStorageService = localStorageService;
        this.storageKeyService = storageKeyService;
    }
    // Check route, if there then use else use logged in
    check(route, state) {
        // Check if logged in
        if (this.authenticationService.hasToken()) {
            return true;
        }
        if (route.data['redirect']) {
            // Capture url for redirect
            this.redirectUrl = state.url;
            this.localStorageService.set(this.storageKeyService.REDIRECT_URL, this.redirectUrl);
        }
        // Logout but keep REDIRECT_URL
        this.authenticationService.logout();
        return false;
    }
    canActivate(route, state) {
        return this.check(route, state);
    }
    canLoad(route, segments) {
        if (this.authenticationService.hasToken()) {
            return true;
        }
        this.authenticationService.logout();
        return false;
    }
};
AuthenticationGuard.ɵfac = function AuthenticationGuard_Factory(t) { return new (t || AuthenticationGuard)(ɵngcc0.ɵɵinject(AuthenticationService), ɵngcc0.ɵɵinject(LocalStorageService), ɵngcc0.ɵɵinject(StorageKeyService)); };
AuthenticationGuard.ctorParameters = () => [
    { type: AuthenticationService },
    { type: LocalStorageService },
    { type: StorageKeyService }
];
AuthenticationGuard.ɵprov = ɵɵdefineInjectable({ factory: function AuthenticationGuard_Factory() { return new AuthenticationGuard(ɵɵinject(AuthenticationService), ɵɵinject(LocalStorageService), ɵɵinject(StorageKeyService)); }, token: AuthenticationGuard, providedIn: "root" });
AuthenticationGuard = __decorate([ __metadata("design:paramtypes", [AuthenticationService,
        LocalStorageService,
        StorageKeyService])
], AuthenticationGuard);

let CheckAppVersionGuard = class CheckAppVersionGuard {
    constructor(checkAppVersionService, notificationService, errorHandlerService, window) {
        this.checkAppVersionService = checkAppVersionService;
        this.notificationService = notificationService;
        this.errorHandlerService = errorHandlerService;
        this.window = window;
        this.window = window;
    }
    resolve(route, state) {
        return this.checkAppVersionService.getAppVersion().pipe(map(response => {
            switch (response.status) {
                case 304:
                case 200:
                    const appVersion = this.checkAppVersionService.version;
                    if (appVersion === null || typeof appVersion === 'undefined') {
                        this.checkAppVersionService.setAppVersion(response.body.version);
                        // Check if New Relic is running and then tag release
                        if (this.window.newrelic) {
                            this.window.newrelic.addRelease('LiveMarket', response.body.version);
                        }
                        return true;
                    }
                    else if (appVersion.toString() === response.body.version.toString()) {
                        return true;
                    }
                    else {
                        this.notificationService.display({
                            title: 'Reload',
                            message: 'Updating App',
                            type: NotificationType.INFO,
                            isRead: false
                        });
                        this.window.location.reload();
                    }
            }
        }), catchError(error => this.errorHandlerService.handleError(error, 'Unable to update App')));
    }
};
CheckAppVersionGuard.ɵfac = function CheckAppVersionGuard_Factory(t) { return new (t || CheckAppVersionGuard)(ɵngcc0.ɵɵinject(CheckAppVersionService), ɵngcc0.ɵɵinject(NotificationService), ɵngcc0.ɵɵinject(ErrorHandlerService), ɵngcc0.ɵɵinject(WINDOW)); };
CheckAppVersionGuard.ctorParameters = () => [
    { type: CheckAppVersionService },
    { type: NotificationService },
    { type: ErrorHandlerService },
    { type: undefined, decorators: [{ type: Inject, args: [WINDOW,] }] }
];
CheckAppVersionGuard.ɵprov = ɵɵdefineInjectable({ factory: function CheckAppVersionGuard_Factory() { return new CheckAppVersionGuard(ɵɵinject(CheckAppVersionService), ɵɵinject(NotificationService), ɵɵinject(ErrorHandlerService), ɵɵinject(WINDOW)); }, token: CheckAppVersionGuard, providedIn: "root" });
CheckAppVersionGuard = __decorate([ __param(3, Inject(WINDOW)),
    __metadata("design:paramtypes", [CheckAppVersionService,
        NotificationService,
        ErrorHandlerService, Object])
], CheckAppVersionGuard);

let SingleSignOnGuard = class SingleSignOnGuard {
    constructor(authenticationService, tradeAuthService, localStorageService, cookieService, router, storageKeyService, environment, dealerDropdownService) {
        this.authenticationService = authenticationService;
        this.tradeAuthService = tradeAuthService;
        this.localStorageService = localStorageService;
        this.cookieService = cookieService;
        this.router = router;
        this.storageKeyService = storageKeyService;
        this.environment = environment;
        this.dealerDropdownService = dealerDropdownService;
        this.cookieOptions = this.environment.seamless.cookieOptions;
    }
    // Check route, if there then use else use logged in
    check(route, state) {
        // SSO keys
        this.ssoReferenceGuid = route.queryParams.ssoReferenceGuid;
        this.dealerContext = route.queryParams.sellerGuid;
        // Admin Keys
        this.userIdentifier = route.queryParams.userIdentifier;
        this.refreshToken = route.queryParams.refreshToken;
        this.sellerGuid = route.queryParams.sellerGuid;
        // If token key is in URL then use that as first priority to refresh
        if (this.ssoReferenceGuid) {
            return this.ssoLogin(route, state);
        }
        else if (this.userIdentifier &&
            this.refreshToken &&
            this.sellerGuid &&
            (this.environment.seamless.applicationType === ApplicationType.Public ||
                this.environment.seamless.applicationType === ApplicationType.Portal)) {
            return this.adminLogin(route, state);
        }
        else {
            if (this.authenticationService.hasToken()) {
                return true;
            }
            this.authenticationService.logout();
            return false;
        }
    }
    canActivate(route, state) {
        return this.check(route, state);
    }
    adminLogin(route, state) {
        return this.tradeAuthService
            .activeDirectoryRefresh({
            userIdentifier: this.userIdentifier,
            refreshToken: this.refreshToken,
            sellerGuid: this.sellerGuid,
        })
            .pipe(map((result) => {
            if (result) {
                // Set token values local storage and cookies
                this.localStorageService.set(this.storageKeyService.JWT_TOKEN, result.tokenSummary.token);
                this.cookieService.put(this.storageKeyService.JWT_TOKEN, result.tokenSummary.token, this.cookieOptions);
                // Remove the params
                this.router.navigate([state.url.split('?')[0]]);
                this.authenticationService.isLoggedIn.next(true);
                return true;
            }
            this.authenticationService.logout();
            return false;
        }), catchError((error) => {
            console.error(error);
            this.authenticationService.logout();
            return of(false);
        }));
    }
    ssoLogin(route, state) {
        return this.tradeAuthService.ssotokenRefresh(this.ssoReferenceGuid).pipe(map((result) => {
            if (result) {
                // Set token values local storage and cookies
                this.localStorageService.set(this.storageKeyService.JWT_TOKEN, result.tokenSummary.token);
                this.cookieService.put(this.storageKeyService.JWT_TOKEN, result.tokenSummary.token, this.cookieOptions);
                const decode = this.authenticationService.decodeToken(result.tokenSummary.token);
                if (decode.SellerGuid) {
                    // Set the active dealer
                    this.localStorageService.set(this.storageKeyService.SELLER_GUID, decode.SellerGuid);
                    this.dealerDropdownService.refresh();
                }
                // TODO : remove this code after portal decom
                // NOTE: LM specific
                if (this.dealerContext) {
                    // Set the active dealer
                    this.localStorageService.set(this.storageKeyService.SELLER_GUID, this.dealerContext);
                    this.dealerDropdownService.refresh();
                }
                this.router.navigate([state.url.split('?')[0]]);
                this.authenticationService.isLoggedIn.next(true);
                return true;
            }
            this.authenticationService.logout();
            return false;
        }), catchError((error) => {
            console.error(error);
            this.authenticationService.logout();
            return of(false);
        }));
    }
};
SingleSignOnGuard.ɵfac = function SingleSignOnGuard_Factory(t) { return new (t || SingleSignOnGuard)(ɵngcc0.ɵɵinject(AuthenticationService), ɵngcc0.ɵɵinject(TradeAuthService), ɵngcc0.ɵɵinject(LocalStorageService), ɵngcc0.ɵɵinject(ɵngcc4.CookieService), ɵngcc0.ɵɵinject(ɵngcc5.Router), ɵngcc0.ɵɵinject(StorageKeyService), ɵngcc0.ɵɵinject(SEAMLESS_ENVIRONMENT), ɵngcc0.ɵɵinject(DEALER_DROPDOWN_SERVICE)); };
SingleSignOnGuard.ctorParameters = () => [
    { type: AuthenticationService },
    { type: TradeAuthService },
    { type: LocalStorageService },
    { type: CookieService },
    { type: Router },
    { type: StorageKeyService },
    { type: Environment, decorators: [{ type: Inject, args: [SEAMLESS_ENVIRONMENT,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DEALER_DROPDOWN_SERVICE,] }] }
];
SingleSignOnGuard.ɵprov = ɵɵdefineInjectable({ factory: function SingleSignOnGuard_Factory() { return new SingleSignOnGuard(ɵɵinject(AuthenticationService), ɵɵinject(TradeAuthService), ɵɵinject(LocalStorageService), ɵɵinject(CookieService), ɵɵinject(Router), ɵɵinject(StorageKeyService), ɵɵinject(SEAMLESS_ENVIRONMENT), ɵɵinject(DEALER_DROPDOWN_SERVICE)); }, token: SingleSignOnGuard, providedIn: "root" });
SingleSignOnGuard = __decorate([ __param(6, Inject(SEAMLESS_ENVIRONMENT)),
    __param(7, Inject(DEALER_DROPDOWN_SERVICE)),
    __metadata("design:paramtypes", [AuthenticationService,
        TradeAuthService,
        LocalStorageService,
        CookieService,
        Router,
        StorageKeyService,
        Environment, Object])
], SingleSignOnGuard);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-footer',
                template: "<footer class=\"container-fluid footer\">\n    <div class=\"footer__support\">\n        <strong class=\"footer__title\">Support</strong>\n        <address *ngFor=\"let tenantCountry of tenantCountries\" class=\"footer__address\">\n            <strong class=\"footer__country\">{{ tenantCountry.country }}</strong>\n            <abbr class=\"footer__abbr\" title=\"email\">e:</abbr> {{ tenantCountry.supportEmail }}\n            <br/>\n            <abbr class=\"footer__abbr\" title=\"phone\">p:</abbr> {{ tenantCountry.supportPhoneNumber }}\n        </address>\n    </div>\n    <div class=\"footer_links\">\n        <strong class=\"footer__title\">Legal</strong>\n        <a class=\"footer__link\" href=\"https://portal.datamotive.com.au/privacy\" target=\"_blank\">Privacy policy</a>\n        <a class=\"footer__link\" href=\"https://portal.datamotive.com.au/static/terms-and-conditions-25-09-15-rev.pdf\" target=\"_blank\">Terms &amp; conditions</a>\n    </div>\n</footer>",
                styles: [":host{text-align:center;display:block;width:100%;margin-top:30px;padding-top:15px;padding-bottom:150px;transition:.3s cubic-bezier(.77,0,.175,1);border-top:1px solid #dbdbdb;overflow:hidden;position:relative;background-color:#f2f2f2}:host.max{padding-left:0;z-index:1051}.footer__title{color:#5d5d5d;font-size:12px;display:block}.footer__country{display:block;font-weight:600}.footer__address{text-align:center;font-size:12px;margin-bottom:0}.footer__link{font-size:12px;display:block}@media (min-width:992px){:host{text-align:left;padding-left:250px;padding-bottom:15px}.footer__links,.footer__support{float:left}.footer__address{text-align:left;float:left;margin-right:15px}}"]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LocalStorageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GlobalHttpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.ToastrService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ErrorHandlerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: NotificationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TradeAuthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: ErrorHandlerService }, { type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BrowserWindowRef, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LayoutService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StorageKeyService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthenticationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc4.CookieService }, { type: LocalStorageService }, { type: ɵngcc3.HttpClient }, { type: GlobalHttpService }, { type: ɵngcc5.Router }, { type: TradeAuthService }, { type: ɵngcc5.ActivatedRoute }, { type: LayoutService }, { type: StorageKeyService }, { type: LocalStorageService }, { type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoginService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AuthenticationService }, { type: undefined, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }, { type: ɵngcc4.CookieService }, { type: LocalStorageService }, { type: StorageKeyService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-login',
                template: "<div class=\"login\">\n    <div class=\"login__panel\">\n        <div class=\"container-fluid\">\n            <div class=\"login__marketing\">\n                <ul class=\"login__logos\">\n                    <li>\n                        <img class=\"login__logo\" src=\"https://trade.csnstatic.com/OAG@3x.png\" alt=\"\" />\n                    </li>\n                    <li>\n                        <img class=\"login__logo\" src=\"https://trade.csnstatic.com/LM@3x.png\" alt=\"\" />\n                    </li>\n                    <li>\n                        <img class=\"login__logo\" src=\"https://trade.csnstatic.com/redbookIQ@3x@3x.png\" alt=\"\" />\n                    </li>\n                </ul>\n                <div class=\"login__blurb\">\n                    <span>Software and insights for dealers, OEM and advertisers by</span>\n                    <img src=\"https://trade.csnstatic.com/cscomltd@3x.png\" alt=\"\" />\n                </div>\n            </div>\n            <div class=\"login__container\">\n                <h1>Sign In</h1>\n                <form class=\"form\" name=\"form\" (ngSubmit)=\"f.form.valid && login()\" #f=\"ngForm\" novalidate>\n                    <div *ngIf=\"!tfaRequired\">\n                        <div class=\"form-group\" [ngClass]=\"{ 'has-error': f.submitted && !username.valid }\">\n                            <label class=\"control-label sr-only\" for=\"username\">{{ 'shell.login.username' | translate }}</label>\n                            <div class=\"input-group\">\n                                <span class=\"input-group-addon\">\n                                    <i class=\"icon-person-lg\"></i>\n                                </span>\n                                <input class=\"form-control\" type=\"text\" id=\"username\" name=\"username\" placeholder=\"username\" [(ngModel)]=\"loginCredentials.username\"\n                                    #username=\"ngModel\" aria-describedby=\"usernameStatus\" autofocus required autocomplete=\"username\" />\n                            </div>\n                            <span *ngIf=\"f.submitted && !username.valid\" class=\"sr-only\">{{'Email/Username is required'}}</span>\n                            <span *ngIf=\"f.submitted && !username.valid\" class=\"help-block\">{{'Email/Username is required'}}</span>\n                        </div>\n\n                        <div class=\"form-group\" [ngClass]=\"{ 'has-error': f.submitted && !password.valid }\">\n                            <label class=\"control-label sr-only\" for=\"password\">{{ 'shell.login.password' | translate }}</label>\n                            <div class=\"input-group\">\n                                <span class=\"input-group-addon\">\n                                    <i class=\"icon-lock-lg\"></i>\n                                </span>\n                                <input class=\"form-control\" type=\"password\" id=\"password\" name=\"password\" placeholder=\"password\" [(ngModel)]=\"loginCredentials.password\"\n                                    #password=\"ngModel\" aria-describedby=\"passwordStatus\" required autocomplete=\"current-password\"/>\n                            </div>\n                            <span *ngIf=\"f.submitted && !password.valid\" id=\"passwordStatus\" class=\"sr-only\">{{'Password is required'}}</span>\n                            <span *ngIf=\"f.submitted && !password.valid\" class=\"help-block\">{{'Password is required'}}</span>\n                        </div>\n\n                        <div class=\"text-center\">\n                            <div class=\"login__error\" *ngIf=\"error\">{{error}}</div>\n                        </div>\n\n                        <div class=\"form-group\">\n                            <label class=\"checkbox login__remember\">{{ 'shell.login.rememberMe' | translate }}\n                                <input type=\"checkbox\" checked=\"checked\" value=\"remember-me\">\n                                <span class=\"checkmark\"></span>\n                            </label>\n                        </div>\n\n                        <div class=\"form-group\">\n                            <button class=\"btn btn-default\" *ngIf=\"!loading\" type=\"submit\">{{ 'shell.login.submit' | translate }}</button>\n                            <button class=\"btn btn-default\" *ngIf=\"loading\" type=\"submit\">\n                                <i class=\"fa fa-circle-o-notch fa-spin fa-fw\"></i>&nbsp;{{ 'shell.login.wait' | translate }}...\n                            </button>\n\n                            <!-- FORGOT PASSWORD - REMOVED FOR V1 LAUNCH -->\n                            <!-- <div class=\"clearfix\">\n                                <small class=\"login__forgot\">\n                                    <a routerLink=\"/forgot-password\">{{ 'shell.login.forgotPassword' | translate }} </a>\n                                </small>\n                            </div> -->\n                        </div>\n                        <div class=\"form-group login__bottom\">\n\n                            <!-- SIGN UP - REMOVED FOR V1 LAUNCH -->\n                            <!-- <div class=\"login__dealer-signup\" id=\"signUp\">\n                                <a routerLink=\"/register\" class=\"login__sign-up btn btn-link\">{{ 'shell.login.signup' | translate }}</a>\n                            </div> -->\n                            \n                            <small>\n                                <a class=\"login__tandc\" [innerHTML]=\"'Terms and conditions'\" href=\"https://www.carsales.com.au/info/terms-conditions/\" target=\"_blank\"></a>\n                            </small>\n                        </div>\n                    </div>\n\n                    <div *ngIf=\"tfaRequired\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label\" for=\"code\">Please enter the authentication code</label>\n                            <div class=\"input-group\">\n                                <span class=\"input-group-addon\">\n                                    <i class=\"icon-lock-lg\"></i>\n                                </span>\n                                <input class=\"form-control\" type=\"text\" id=\"code\" name=\"code\" placeholder=\"\" [(ngModel)]=\"loginCredentials.code\" #tfaCode=\"ngModel\"\n                                    aria-describedby=\"\" required autocomplete=\"one-time-code\" />\n                            </div>\n                            <a class=\"help-block\" (click)=\"resendCode()\">Resend authentication code </a>\n                            <span *ngIf=\"codeSent !== null\" class=\"help-block\" [ngClass]=\"{'message-confirm': codeSent}\">: {{codeSent ? ' Sent!' : ' ...Sending'}}</span>\n\n                            <div class=\"form-group\">\n                                <button type=\"submit\" class=\"btn btn-default\" [disabled]=\"!loginCredentials.code\">Log in</button>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n\n    </div>\n</div>",
                styles: [".login{overflow:hidden;padding:15px 0}.login .container-fluid{max-width:1140px}.login .row{margin:0}.login [class*=col-]{padding:0}.login::before{content:\"\";background:linear-gradient(to right,#272e62 0,#007cc2 50%,#63cbe8 100%);position:absolute;top:0;left:0;right:0;bottom:0;z-index:1050}.login__panel{position:relative;z-index:1051;margin:0 auto}.login__marketing{position:relative;padding:30px;background-color:#f1f1f1}.login__logos{overflow:hidden;text-align:center;margin:0;padding:0}.login__logos li{width:30%;display:inline-block;vertical-align:middle}.login__logo{display:block;float:left;width:80%}.login__blurb{margin-top:15px;text-align:center;width:100%}.login__blurb span{display:block}.login__blurb img{max-width:180px;margin:0 15px}.login__container{display:block;width:100%;padding:30px;margin:0 auto;background-color:#fff}.login__container h1{font-size:20px;line-height:28px;color:#4a4a4a;text-align:center;margin-top:0}.login__container form{margin:0 auto}.login__help-block{margin-top:0;margin-bottom:.5rem;color:#a94442}.login__remember{width:130px;margin:15px auto}.login__forgot{display:block;width:130px;margin:15px auto;text-align:center}.login__bottom{margin:30px 0 0}.login__sign-up{max-width:130px;font-size:15px;color:#ff7217;margin:0 auto;transition:.3s ease-out;display:block;width:100%;height:auto;line-height:24px;padding:0;font-weight:700;white-space:unset}.login__tandc{display:block;text-align:center;padding:10px 0}.login button[type=submit]{display:block;min-width:180px;margin:24px auto 0}.login__error{font-size:13px;color:#d0021b}@media (min-width:768px){.login{padding:60px}.login__container .form{width:unset;max-width:320px}}@media (min-width:992px){.login{margin:0 auto}.login__marketing{float:left;min-height:510px;width:60%;padding:60px 30px}.login__logos{position:absolute;top:50%;transform:translateY(-50%)}.login__blurb{position:absolute;bottom:60px;left:50%;transform:translateX(-50%);margin-top:30px}.login__container{width:40%;min-height:510px;float:right;margin:0}.login__container .form{width:unset;max-width:320px}}a.help-block{cursor:pointer}.help-block{display:inline-block}.message-confirm{color:#61b136}"]
            }]
    }], function () { return [{ type: AuthenticationService }, { type: ɵngcc5.Router }, { type: LoginService }, { type: TradeAuthService }, { type: LocalStorageService }, { type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }, { type: StorageKeyService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ForgotPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-forgot-password',
                template: "<div class=\"forgot-password\">\n    <div class=\"forgot-password__panel\">\n        <div class=\"container-fluid\">\n            <div class=\"forgot-password__marketing\">\n                <ul class=\"forgot-password__logos\">\n                    <li>\n                        <img class=\"forgot-password__logo\" src=\"https://trade.csnstatic.com/OAG@3x.png\" alt=\"\" />\n                    </li>\n                    <li>\n                        <img class=\"forgot-password__logo\" src=\"https://trade.csnstatic.com/LM@3x.png\" alt=\"\" />\n                    </li>\n                    <li>\n                        <img class=\"forgot-password__logo\" src=\"https://trade.csnstatic.com/redbookIQ@3x@3x.png\" alt=\"\" />\n                    </li>\n                </ul>\n                <div class=\"forgot-password__blurb\">\n                    <span>Software and insights for dealers, OEM and advertisers by</span>\n                    <img src=\"https://trade.csnstatic.com/cscomltd@3x.png\" alt=\"\" />\n                </div>\n            </div>\n            <div class=\"forgot-password__container\">\n                <h1>Forgot Password</h1>\n                <form class=\"form\" name=\"form\" novalidate>\n                    <div>\n                        <div class=\"form-group\">\n\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n\n    </div>\n</div>",
                styles: [".forgot-password{overflow:hidden;background:linear-gradient(to right,#272e62 0,#007cc2 50%,#63cbe8 100%);padding:15px 0}.forgot-password .container-fluid{max-width:1140px}.forgot-password .row{margin:0}.forgot-password [class*=col-]{padding:0}.forgot-password__panel{position:relative;margin:0 auto}.forgot-password__marketing{position:relative;padding:30px;background-color:#f1f1f1}.forgot-password__logos{overflow:hidden;text-align:center;margin:0;padding:0}.forgot-password__logos li{width:30%;display:inline-block}.forgot-password__logos li:nth-child(2){position:relative;top:-9px}.forgot-password__logos li:nth-child(3){position:relative;top:-16px}.forgot-password__logo{display:block;float:left;width:80%}.forgot-password__blurb{margin-top:15px;text-align:center;width:100%}.forgot-password__blurb span{display:block}.forgot-password__blurb img{max-width:180px;margin:0 15px}.forgot-password__container{display:block;width:100%;padding:30px;margin:0 auto;background-color:#fff}.forgot-password__container h1{font-size:20px;line-height:28px;color:#4a4a4a;text-align:center;margin-top:0}.forgot-password__container form{margin:0 auto}.forgot-password__help-block{margin-top:0;margin-bottom:.5rem;color:#a94442}.forgot-password__remember{width:130px;margin:15px auto}.forgot-password__forgot{display:block;width:130px;margin:15px auto;text-align:center}.forgot-password__bottom{margin:30px 0 0}.forgot-password__sign-up{max-width:130px;font-size:15px;color:#ff7217;margin:0 auto;transition:.3s ease-out;display:block;width:100%;height:auto;line-height:24px;padding:0;font-weight:700;white-space:unset}.forgot-password__tandc{display:block;text-align:center;padding:10px 0}.forgot-password button[type=submit]{display:block;min-width:180px;margin:24px auto 0}.forgot-password__error{font-size:13px;color:#d0021b}@media (min-width:768px){.forgot-password{padding:60px}.forgot-password__container .form{width:unset;max-width:320px}}@media (min-width:992px){.forgot-password{margin:0 auto}.forgot-password__marketing{float:left;min-height:510px;width:60%;padding:60px 30px}.forgot-password__logos{position:absolute;top:50%;transform:translateY(-50%)}.forgot-password__blurb{position:absolute;bottom:60px;left:50%;transform:translateX(-50%);margin-top:30px}.forgot-password__container{width:40%;min-height:510px;float:right;margin:0}.forgot-password__container .form{width:unset;max-width:320px}}"]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CustomerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: ErrorHandlerService }, { type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-header',
                template: "<header class=\"header navbar-fixed-top\">\n    <button class=\"header__navicon hidden-md hidden-lg\" (click)=\"toggle(Layout.MENU_DRAWER)\" [ngClass]=\"{'active': naviconActive, 'notActive': !naviconActive}\">\n        Menu\n    </button>\n    <a class=\"header__brand\" [href]=\"logoLinkPath\" #headerLogoAnchor *ngIf=\"isLoggedIn\">Seamless</a>\n    <ng-content></ng-content>\n    <button *ngIf=\"isLoggedIn\" class=\"header__account account\" (click)=\"toggle(Layout.ACCOUNTS_DRAWER)\" [ngClass]=\"{'active': accountDrawerIsActive, 'showIcon': !customer?.userDto?.imageUrl}\">\n        <img class=\"account__image\" *ngIf=\"customer?.userDto?.imageUrl\" [src]=\"customer?.userDto?.imageUrl\" [alt]=\"customer?.userDto?.firstName + ' ' + customer?.userDto?.lastName\">\n    </button>\n</header>",
                styles: ["@charset \"UTF-8\";.header{height:50px;background-color:#fff;border-bottom:1px solid #e3e3e3}.header__brand{display:block;width:140px;height:50px;line-height:50px;font-size:24px;text-align:center;margin:0 auto;overflow:hidden;color:#fff;background-image:url(assets/seamless/images/OAG.png);background-repeat:no-repeat;background-position:center center;background-size:80% auto;text-indent:100%}.header__account,.header__navicon{position:absolute;top:50%;transform:translateY(-50%);z-index:1;height:30px;width:46px;padding:0;line-height:30px;border:0;color:rgba(0,0,0,.3);background-color:transparent;outline:0;text-indent:100%;overflow:hidden}.header__navicon{left:15px}.header__navicon:before{display:block;text-indent:0;font-family:csnicons;font-size:44px;content:\"\uE964\"}.header__navicon.active:before{content:\"\uE94D\";font-size:32px}.header__account{right:15px;height:35px}.header__account.active .account__image{border:1px solid #007cc2}.header__account.notActive .account__image{filter:url(\"data:image/svg+xml;utf8,&lt;svg xmlns='http://www.w3.org/2000/svg'&gt;&lt\u202633 0.3333 0.3333 0 0 0 0 0 1 0'/&gt;&lt;/filter&gt;&lt;/svg&gt;#grayscale\");filter:gray;-webkit-filter:grayscale(100%)}.header__account.showIcon:before{display:block;text-indent:0;font-family:csnicons;font-size:28px;content:\"\uE9A0\"}.header__account.showIcon.active{border:none}.header__account.showIcon.active:before{color:#007cc2}.account__image{position:absolute;top:50%;left:50%;width:25px;height:25px;border-radius:9999px;transform:translate(-50%,-50%)}@media (min-width:992px){.header{height:80px;border-bottom:1px solid #dbdbdb}.header__brand{border-right:1px solid #dbdbdb;width:250px;height:80px;line-height:80px;float:left;background-size:60% auto;z-index:1;position:relative}.header__account{height:80px}.account__image{width:35px;height:35px}}"]
            }]
    }], function () { return [{ type: AuthenticationService }, { type: LayoutService }, { type: CustomerService }, { type: HeaderService }, { type: ɵngcc0.Renderer2 }, { type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }]; }, { headerLogoAnchor: [{
            type: ViewChild,
            args: ['headerLogoAnchor', { static: false }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HomeComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-home',
                template: "<div class=\"header-area\">\n    <div class=\"header-area__title-area\">\n        <h1 class=\"header-area__title hidden-xs hidden-sm\">\n            <a routerLink=\"/\">Welcome</a>\n        </h1>\n        <h1 class=\"header-area__title hidden-md hidden-lg\">Welcome</h1>\n    </div>\n</div>\n\n<div class=\"container-fluid hidden-md hidden-lg clearfix\">\n    <div class=\"clearfix\">\n        <h2 class=\"section-title pull-left \">Welcome</h2>\n    </div>\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RegisterComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-register',
                template: "<div class=\"register\">\n    <div class=\"register__panel\">\n        <div class=\"container-fluid\">\n            <div class=\"register__marketing\">\n                <ul class=\"register__logos\">\n                    <li>\n                        <img class=\"register__logo\" src=\"https://trade.csnstatic.com/OAG@3x.png\" alt=\"\" />\n                    </li>\n                    <li>\n                        <img class=\"register__logo\" src=\"https://trade.csnstatic.com/LM@3x.png\" alt=\"\" />\n                    </li>\n                    <li>\n                        <img class=\"register__logo\" src=\"https://trade.csnstatic.com/redbookIQ@3x@3x.png\" alt=\"\" />\n                    </li>\n                </ul>\n                <div class=\"register__blurb\">\n                    <span>Software and insights for dealers, OEM and advertisers by</span>\n                    <img src=\"https://trade.csnstatic.com/cscomltd@3x.png\" alt=\"\" />\n                </div>\n            </div>\n            <div class=\"register__container\">\n                <h1>Register</h1>\n                <form class=\"form\" name=\"form\" novalidate>\n                    <div>\n\n                    </div>\n                </form>\n            </div>\n        </div>\n\n    </div>\n</div>",
                styles: [".register{overflow:hidden;background:linear-gradient(to right,#272e62 0,#007cc2 50%,#63cbe8 100%);padding:15px 0}.register .container-fluid{max-width:1140px}.register .row{margin:0}.register [class*=col-]{padding:0}.register__panel{position:relative;margin:0 auto}.register__marketing{position:relative;padding:30px;background-color:#f1f1f1}.register__logos{overflow:hidden;text-align:center;margin:0;padding:0}.register__logos li{width:30%;display:inline-block}.register__logos li:nth-child(2){position:relative;top:-9px}.register__logos li:nth-child(3){position:relative;top:-16px}.register__logo{display:block;float:left;width:80%}.register__blurb{margin-top:15px;text-align:center;width:100%}.register__blurb span{display:block}.register__blurb img{max-width:180px;margin:0 15px}.register__container{display:block;width:100%;padding:30px;margin:0 auto;background-color:#fff}.register__container h1{font-size:20px;line-height:28px;color:#4a4a4a;text-align:center;margin-top:0}.register__container form{margin:0 auto}.register__help-block{margin-top:0;margin-bottom:.5rem;color:#a94442}.register__remember{width:130px;margin:15px auto}.register__forgot{display:block;width:130px;margin:15px auto;text-align:center}.register__bottom{margin:30px 0 0}.register__sign-up{max-width:130px;font-size:15px;color:#ff7217;margin:0 auto;transition:.3s ease-out;display:block;width:100%;height:auto;line-height:24px;padding:0;font-weight:700;white-space:unset}.register__tandc{display:block;text-align:center;padding:10px 0}.register button[type=submit]{display:block;min-width:180px;margin:24px auto 0}.register__error{font-size:13px;color:#d0021b}@media (min-width:768px){.register{padding:60px}.register__container .form{width:unset;max-width:320px}}@media (min-width:992px){.register{margin:0 auto}.register__marketing{float:left;min-height:510px;width:60%;padding:60px 30px}.register__logos{position:absolute;top:50%;transform:translateY(-50%)}.register__blurb{position:absolute;bottom:60px;left:50%;transform:translateX(-50%);margin-top:30px}.register__container{width:40%;min-height:510px;float:right;margin:0}.register__container .form{width:unset;max-width:320px}}"]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SearchComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-search',
                template: "<div class=\"search\" [ngClass]=\"{'show': showSearch}\">\n    <div class=\"container-fluid\">\n        <button class=\"search__close\" type=\"button\" (click)=\"close()\">close</button>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <form class=\"search__form\">\n                    <label class=\"search__form-label\" for=\"searchForm\">Enter a search term and press enter</label>\n                    <input class=\"search__form-input\" placeholder=\"search organisations, products or people\" id=\"searchForm\" type=\"text\" (keydown)=\"keyPressed($event)\"\n                        #searchInput />\n                    <button class=\"search__form-btn\" type=\"submit\">search</button>\n                </form>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"search__results\">\n                <div class=\"col-xs-12 col-md-4\">\n                    <p class=\"search__results-title\">\n                        Category\n                    </p>\n                    <ul class=\"search__results-list list-group\">\n                        <li class=\"search__results-item list-group-item\">Cras justo odio</li>\n                        <li class=\"search__results-item list-group-item\">Dapibus ac facilisis in</li>\n                        <li class=\"search__results-item list-group-item\">Morbi leo risus</li>\n                        <li class=\"search__results-item list-group-item\">Porta ac consectetur ac</li>\n                        <li class=\"search__results-item list-group-item\"><a class=\"search__result-link\" href=\"#\">result</a></li>\n                    </ul>\n                </div>\n                <div class=\"col-xs-12 col-md-4\">\n                    <p class=\"search__results-title\">\n                        Category\n                    </p>\n                    <ul class=\"search__results-list list-group\">\n                        <li class=\"search__results-item list-group-item\">Cras justo odio</li>\n                        <li class=\"search__results-item list-group-item\">Dapibus ac facilisis in</li>\n                        <li class=\"search__results-item list-group-item\">Morbi leo risus</li>\n                        <li class=\"search__results-item list-group-item\">Porta ac consectetur ac</li>\n                        <li class=\"search__results-item list-group-item\"><a class=\"search__result-link\" href=\"#\">result</a></li>\n                    </ul>\n                </div>\n                <div class=\"col-xs-12 col-md-4\">\n                    <p class=\"search__results-title\">\n                        Category\n                    </p>\n                    <ul class=\"search__results-list list-group\">\n                        <li class=\"search__results-item list-group-item\">Cras justo odio</li>\n                        <li class=\"search__results-item list-group-item\">Dapibus ac facilisis in</li>\n                        <li class=\"search__results-item list-group-item\">Morbi leo risus</li>\n                        <li class=\"search__results-item list-group-item\">Porta ac consectetur ac</li>\n                        <li class=\"search__results-item list-group-item\"><a class=\"search__result-link\" href=\"#\">result</a></li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>",
                styles: ["@charset \"UTF-8\";.search{position:fixed;top:0;left:0;width:100%;height:100%;padding:60px 15px;z-index:-1;background-color:#fff;opacity:0;transform:translateY(-100%);transition:.3s}.search__close{position:absolute;right:15px;top:15px;width:30px;height:30px;padding:0;line-height:30px;text-indent:-9999px;overflow:hidden;background-color:transparent;border:0;outline:0;color:grey}.search__close:after{position:absolute;left:0;top:0;display:block;width:inherit;height:inherit;line-height:inherit;font-family:csnicons;font-size:30px;font-weight:300;content:\"\uE94D\";text-indent:0}.search__form{position:relative;height:60px;line-height:60px;font-size:24px}.search__form-label{position:absolute;top:-16px;left:0;margin:0;line-height:16px;display:block;font-weight:600;font-size:12px;color:#393939}.search__form-input{display:block;width:100%;height:inherit;padding-left:60px;line-height:inherit;border:0;border-bottom:1px solid #cdcdcd;background-color:transparent;font-size:inherit;font-weight:600;color:#393939;outline:0}.search__form-input::-moz-placeholder{color:#cdcdcd}.search__form-input:-ms-input-placeholder{color:#cdcdcd}.search__form-input::-ms-input-placeholder{color:#cdcdcd}.search__form-input::placeholder{color:#cdcdcd}.search__form-btn{position:absolute;left:0;top:0;display:block;width:60px;height:inherit;padding:0;line-height:inherit;text-indent:-9999px;overflow:hidden;background-color:transparent;border:0;outline:0;color:grey}.search__form-btn:after{position:absolute;left:0;top:0;display:block;width:inherit;height:inherit;line-height:inherit;font-family:csnicons;font-size:inherit;font-weight:300;content:\"\uE98C\";text-indent:0}.search__results{padding:30px 0}.search__results-title{font-weight:600;font-size:18px;color:grey}.search__results-item{margin:0;padding-left:0;padding-right:0;border:0;border-bottom:1px dotted #e1e1e1}.search.show{z-index:1050;opacity:1;transform:translateY(0)}@media (min-width:768px){.search{padding:60px 45px}}@media (min-width:992px){.search__form{height:100px;line-height:100px;font-size:48px}}"]
            }]
    }], function () { return []; }, { changeSearchState: [{
            type: Output
        }], showSearch: [{
            type: Input
        }], searchInput: [{
            type: ViewChild,
            args: ['searchInput', { static: false }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidebarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LayoutService }, { type: ɵngcc5.Router }, { type: LocalStorageService }, { type: ɵngcc3.HttpClient }, { type: ErrorHandlerService }, { type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidebarComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-sidebar',
                template: "<div *ngIf=\"userIsLoggedIn\" class=\"seamless-sidebar\" [ngClass]=\"{'open': showSideNav}\">\n        <div class=\"seamless-sidebar__inner\">\n                <div class=\"loading-spinner loading-spinner--dark\" *ngIf=\"isLoading\">\n                        <div class=\"loading-spinner__icon\"></div>\n                </div>\n                <ng-content></ng-content>\n        </div>\n\n</div>\n<div class=\"sidebar-cloak\" [ngClass]=\"{'visible': showSideNav}\" (click)=\"toggle(Layout.MENU_DRAWER)\"></div>",
                encapsulation: ViewEncapsulation.None,
                styles: ["@charset \"UTF-8\";.seamless-sidebar .panel{margin-bottom:0;background-color:transparent;border:0}.seamless-sidebar .panel-group{margin-bottom:0}.seamless-sidebar .panel-group .panel{border-bottom:.5px solid #3d464d;border-radius:0;margin-top:0}.seamless-sidebar .panel-default .panel-heading{background-color:transparent}.seamless-sidebar .panel-heading{padding:0;border-bottom:0;border-top-right-radius:0;border-top-left-radius:0}.seamless-sidebar .panel-default>.panel-heading+.panel-collapse>.panel-body{border-top:none}.seamless-sidebar .panel-body{padding:0}.seamless-sidebar .card{background-color:transparent;box-shadow:none}.seamless-sidebar{position:fixed;z-index:1032;left:0;top:50px;transform:translateX(-250px);width:250px;height:100%;background-color:#3d464d;padding-bottom:54px;transition:.3s cubic-bezier(.77,0,.175,1)}.seamless-sidebar.open{transform:translateX(0);left:0}.seamless-sidebar a{color:#fff;text-decoration:none}.seamless-sidebar .panel-title .accordion-toggle>div:after{position:absolute;top:50%;right:30px;left:unset;transition:transform .2s;transform:translate(0,-50%) rotate(0);font-family:csnicons;font-size:12px;font-weight:300;content:\"\uE928\";text-indent:0}.seamless-sidebar .panel-body>a,.seamless-sidebar .panel-body>seamless-sidebar-menu-item>a,.seamless-sidebar .panel-group>a,.seamless-sidebar .panel-group>seamless-sidebar-menu-item>a,.seamless-sidebar .panel-title .accordion-toggle>div{display:block;position:relative;height:42px;line-height:42px;margin-top:0;padding:0 0 0 calc(36px + 20px + 4px);font-size:12px;font-weight:600;color:#bec5cb;transition:color .2s;overflow:hidden}.seamless-sidebar .panel-body>a [class*=icon-]:first-child,.seamless-sidebar .panel-body>seamless-sidebar-menu-item>a [class*=icon-]:first-child,.seamless-sidebar .panel-group>a [class*=icon-]:first-child,.seamless-sidebar .panel-group>seamless-sidebar-menu-item>a [class*=icon-]:first-child,.seamless-sidebar .panel-title .accordion-toggle>div [class*=icon-]:first-child{position:absolute;left:0;top:50%;transform:translateY(-50%);display:block;width:36px;height:36px;line-height:36px;font-size:20px;text-align:center;background-size:20px 20px;background-repeat:no-repeat;background-position:center center}.seamless-sidebar .panel-body>a [class*=icon-]:nth-child(2),.seamless-sidebar .panel-body>seamless-sidebar-menu-item>a [class*=icon-]:nth-child(2),.seamless-sidebar .panel-group>a [class*=icon-]:nth-child(2),.seamless-sidebar .panel-group>seamless-sidebar-menu-item>a [class*=icon-]:nth-child(2),.seamless-sidebar .panel-title .accordion-toggle>div [class*=icon-]:nth-child(2){vertical-align:text-bottom;width:36px;height:36px;font-size:20px;text-align:center}.seamless-sidebar .panel-body>a.active,.seamless-sidebar .panel-body>seamless-sidebar-menu-item>a.active,.seamless-sidebar .panel-group>a.active,.seamless-sidebar .panel-group>seamless-sidebar-menu-item>a.active,.seamless-sidebar .panel-title .accordion-toggle>div.active{color:#fff}.seamless-sidebar .panel-body>a:not(.unclickable):not(.selected):hover,.seamless-sidebar .panel-body>seamless-sidebar-menu-item>a:not(.unclickable):not(.selected):hover,.seamless-sidebar .panel-group>a:not(.unclickable):not(.selected):hover,.seamless-sidebar .panel-group>seamless-sidebar-menu-item>a:not(.unclickable):not(.selected):hover,.seamless-sidebar .panel-title .accordion-toggle>div:not(.unclickable):not(.selected):hover{color:#fff;background-color:#21252d}.seamless-sidebar .panel-body>a.unclickable::before,.seamless-sidebar .panel-body>seamless-sidebar-menu-item>a.unclickable::before,.seamless-sidebar .panel-group>a.unclickable::before,.seamless-sidebar .panel-group>seamless-sidebar-menu-item>a.unclickable::before,.seamless-sidebar .panel-title .accordion-toggle>div.unclickable::before{font-family:csnicons;content:\"\uE9EC\";margin-right:2px;display:inline-block;width:15px;vertical-align:top}.seamless-sidebar .bottom-menu .panel-group>a.seamless{color:#fff}.seamless-sidebar .panel-body>a{height:32px;line-height:32px}.seamless-sidebar .panel-open{color:#fff;background-color:#21252d}.seamless-sidebar .panel-open .panel-title .accordion-toggle>div{color:#fff}.seamless-sidebar .panel-open .panel-title .accordion-toggle>div:after{color:#007cc2;font-weight:900;transform:translate(0,-50%) rotate(90deg)}.seamless-sidebar .seamless-sidebar__inner{position:absolute;left:0;top:0;z-index:1;width:250px;height:100%;margin:0;padding:0;opacity:1;transition:left .3s .1s,opacity .3s;overflow-y:auto;-webkit-overflow-scrolling:touch}.seamless-sidebar .seamless-sidebar__inner>div{height:inherit}.seamless-sidebar .icon-livemarket{background-image:url(assets/seamless/images/livemarket-icon.png)}.seamless-sidebar .icon-sourcing{background-image:url(assets/seamless/images/group@3x.png)}.seamless-sidebar .icon-inventory{background-image:url(assets/seamless/images/group-3@3x.png)}.seamless-sidebar .icon-prospects{background-image:url(assets/seamless/images/group-31@3x.png)}.seamless-sidebar .icon-campaigns{background-image:url(assets/seamless/images/noun-535331-cc@3x.png)}.seamless-sidebar .icon-other-modules{background-image:url(assets/seamless/images/other-modules-icon@3x.png)}.seamless-sidebar .icon-settings{background-image:url(assets/seamless/images/cog-md@2x.png)}.sidebar-cloak{position:fixed;top:100%;left:0;bottom:0;right:0;z-index:13;background-color:rgba(0,0,0,0);transition:background-color .3s cubic-bezier(.77,0,.175,1)}.sidebar-cloak.visible{top:0;background-color:rgba(0,0,0,.3)}@media (min-width:992px){.seamless-sidebar{top:80px;height:calc(100% - 80px);transform:translateX(0)}.seamless-sidebar .sidebar{left:0;width:250px}.sidebar-cloak{display:none}}"]
            }]
    }], function () { return [{ type: LayoutService }, { type: SidebarService }, { type: AuthenticationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GATrackingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GAClickDirective, [{
        type: Directive,
        args: [{
                selector: '[seamlessGaClick]'
            }]
    }], function () { return [{ type: GATrackingService }]; }, { handleClick: [{
            type: HostListener,
            args: ['click']
        }], csnGaClick: [{
            type: Input,
            args: ['seamlessGaClick']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GATrackingComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-ga-tracking',
                template: "<div [id]=\"id\" style=\"display: none;\"></div>"
            }]
    }], function () { return [{ type: GATrackingService }, { type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }]; }, { id: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderAddOnsComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-header-add-ons',
                template: "<ng-content></ng-content>",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SellerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: ErrorHandlerService }, { type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PortalTokenDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }, { type: ɵngcc3.HttpClient }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidebarMenuComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-sidebar-menu',
                template: "<div class=\"top-menu\">\n  <accordion *ngIf=\"!isLoadingSidebarItems; else loadingSpinner\" [isAnimated]=\"true\">\n    <ng-container *ngFor=\"let item of sidebarItems\">\n      <seamless-sidebar-menu-item [sidebarItem]=\"item\"></seamless-sidebar-menu-item>\n    </ng-container>\n  </accordion>\n</div>\n\n<div class=\"bottom-menu\">\n  <accordion *ngIf=\"!isLoadingBottomItems; else loadingSpinner\" [isAnimated]=\"true\">\n    <ng-container *ngFor=\"let item of bottomItems\">\n      <seamless-sidebar-menu-item [sidebarItem]=\"item\"></seamless-sidebar-menu-item>\n    </ng-container>\n  </accordion>\n</div>\n\n<ng-template #loadingSpinner>\n  <div class=\"seamless-loading-spinner seamless-loading-spinner--dark loading-spinner loading-spinner--dark\">\n    <div class=\"seamless-loading-spinner__icon loading-spinner__icon\"></div>\n  </div>\n</ng-template>",
                styles: [":host{display:flex;height:100%;flex-direction:column;align-content:space-between}.top-menu{margin-bottom:42px}.bottom-menu{position:fixed;bottom:0;width:100%;background-color:#6e6e6e}@media (max-width:992px){.bottom-menu{margin-bottom:40px}}"]
            }]
    }], function () { return [{ type: LayoutService }, { type: SidebarService }, { type: SellerService }, { type: PortalTokenDetailsService }]; }, { onClick: [{
            type: HostListener,
            args: ['click', ['$event.target']]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PaginationSeamlessComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-pagination',
                template: "<nav aria-label=\"Page navigation\" *ngIf=\"totalRecords\" class=\"clearfix\">\n  <div class=\"pagination-container\">\n    <pagination\n      [totalItems]=\"totalRecords\"\n      [itemsPerPage]=\"pageSize\"\n      [(ngModel)]=\"currentPage\"\n      [boundaryLinks]=\"showBoundaryLinks\"\n      [directionLinks]=\"showDirectionLinks\"\n      [maxSize]=\"maxSize\"\n      [rotate]=\"rotate\"\n      [previousText]=\"previousText\"\n      [nextText]=\"nextText\"\n      [firstText]=\"firstText\"\n      [lastText]=\"lastText\"\n      (pageChanged)=\"changePage($event)\"\n    ></pagination>\n  </div>\n\n  <div class=\"page-by\">\n    <span>Show</span>\n    <select class=\"form-control naked input-sm\" [(ngModel)]=\"pageSize\" (change)=\"changePageSize()\">\n      <option>12</option>\n      <option>20</option>\n      <option>50</option>\n      <option>100</option>\n    </select>\n    <span>per page</span>\n  </div>\n</nav>\n",
                styles: [".pagination{width:100%;text-align:center;margin:calc(30px / 2) 0 0}.pagination li{display:inline-block}.pagination .first i,.pagination .last i{margin-left:-12px}.pagination-container{float:left}.page-by{margin:12px auto;padding:6px 12px;line-height:30px;font-size:14px;text-align:center}.page-by select{margin:0 4px;width:auto;display:inline-block}@media (min-width:992px){.pagination{width:auto;float:left;margin:calc(30px / 2) 0}.page-by{float:left;margin:12px 0;padding:6px 12px;line-height:30px;font-size:12px}.page-by select{margin:0 4px;width:auto;display:inline-block}}"]
            }]
    }], function () { return []; }, { onPageChange: [{
            type: Output
        }], onPageSizeChange: [{
            type: Output
        }], showBoundaryLinks: [{
            type: Input
        }], showDirectionLinks: [{
            type: Input
        }], maxSize: [{
            type: Input
        }], rotate: [{
            type: Input
        }], previousText: [{
            type: Input
        }], nextText: [{
            type: Input
        }], firstText: [{
            type: Input
        }], lastText: [{
            type: Input
        }], totalRecords: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], pageNum: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotFoundComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-not-found',
                template: "<div class=\"content-msg\">\n    <h1>404</h1>\n    <h2>Page Not Found</h2>\n</div>\n",
                styles: [".content-msg{text-align:center}.content-msg h1{color:#007cc2;font-size:5em;line-height:1em;margin-top:75px}.content-msg h2{margin-top:0}"]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccountDrawerComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-account-drawer',
                template: "<div class=\"seamless-account-drawer\" [ngClass]=\"{'open': isVisible}\">\n        <div class=\"seamless-account-drawer__inner\">\n                <div class=\"account\">\n                        <div class=\"account__card clearfix\">\n                                <div class=\"account__image-container\" *ngIf=\"customer\">\n                                        <img class=\"account__image\" [src]=\"profileImage\" [alt]=\"customer?.userDto?.firstName + ' ' + customer?.userDto?.lastName\">\n                                </div>\n                                <div class=\"account__name name\" *ngIf=\"customer\">\n                                        <div class=\"name__firstName\">{{customer?.userDto?.firstName}}</div>\n                                        <div class=\"name__lastName\">{{customer?.userDto?.lastName}}</div>\n                                        <div class=\"name__position\">{{customer?.userDto?.position}}</div>\n                                </div>\n                                <button class=\"btn btn-xs btn-secondary logout\" (click)=\"logout()\">\n                                        Logout\n                                </button>\n                        </div>\n\n                </div>\n                <ng-content></ng-content>\n        </div>\n</div>\n<div class=\"cloak\" [ngClass]=\"{'visible': isVisible}\" (click)=\"toggle(Layout.ACCOUNTS_DRAWER)\"></div>",
                styles: [".seamless-account-drawer{position:fixed;z-index:1032;right:0;top:50px;transform:translateX(300px);width:300px;height:100%;background-color:#fff;padding-bottom:54px;transition:.3s cubic-bezier(.77,0,.175,1)}.seamless-account-drawer.open{transform:translateX(0);right:0}.seamless-account-drawer a{color:#fff;text-decoration:none}.seamless-account-drawer__inner{position:absolute;right:0;top:0;z-index:1;width:300px;height:100%;margin:0;padding:0 0 100px;opacity:1;transition:right .3s .1s,opacity .3s;overflow-y:auto;-webkit-overflow-scrolling:touch}.cloak{position:fixed;top:100%;left:0;bottom:0;right:0;z-index:13;background-color:rgba(0,0,0,0);transition:background-color .3s cubic-bezier(.77,0,.175,1)}.cloak.visible{top:0;background-color:rgba(0,0,0,.3)}@media (min-width:992px){.seamless-account-drawer{top:80px;height:calc(100% - 80px)}}.account{padding:20px 20px 15px 25px}.account__card{padding-bottom:15px;border-bottom:1px solid #e3e3e3}.account__image-container{float:left}.account__image{width:50px;height:50px;border-radius:9999px;margin-right:15px}.name__firstName,.name__lastName{font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#4a4a4a;display:inline}.name__position{font-size:14px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:grey}.btn{color:#737373;border-color:#737373;float:right;margin-top:15px}"]
            }]
    }], function () { return [{ type: LayoutService }, { type: AuthenticationService }, { type: CustomerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerSeamlessComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-pager',
                template: "<nav aria-label=\"pager navigation\" *ngIf=\"totalItems\" class=\"clearfix\">\n  <div class=\"pager-container\">\n    <pager\n      [totalItems]=\"totalItems\"\n      [itemsPerPage]=\"itemsPerPage\"\n      [(ngModel)]=\"currentPage\"\n      [boundaryLinks]=\"boundaryLinks\"\n      [directionLinks]=\"directionLinks\"\n      [maxSize]=\"maxSize\"\n      [rotate]=\"rotate\"\n      [previousText]=\"previousText\"\n      [nextText]=\"nextText\"\n      [firstText]=\"firstText\"\n      [lastText]=\"lastText\"\n      [pageBtnClass]=\"pageBtnClass\"\n      (pageChanged)=\"changePage($event)\"\n    ></pager>\n  </div>\n</nav>\n",
                styles: [".pager-container{float:left}"]
            }]
    }], function () { return []; }, { onPageChange: [{
            type: Output
        }], onPageSizeChange: [{
            type: Output
        }], boundaryLinks: [{
            type: Input
        }], directionLinks: [{
            type: Input
        }], maxSize: [{
            type: Input
        }], rotate: [{
            type: Input
        }], previousText: [{
            type: Input
        }], nextText: [{
            type: Input
        }], pageNum: [{
            type: Input
        }], align: [{
            type: Input
        }], disabled: [{
            type: Input
        }], firstText: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], lastText: [{
            type: Input
        }], pageBtnClass: [{
            type: Input
        }], totalItems: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbsComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-breadcrumbs',
                template: "<div class=\"breadcrumb\">\n  <div class=\"breadcrumb__trail\">\n    <ng-container *ngFor=\"let item of trail\">\n      <span class=\"breadcrumb__item\" *ngIf=\"!item.link\">{{ item.label }} / </span>\n      <a [routerLink]=\"[item.link]\" class=\"breadcrumb__item\" *ngIf=\"item.link && item.internal; else external\"\n          >{{ item.label }} /\n      </a>\n      <ng-template #external>\n        <a [href]=\"item.link\" class=\"breadcrumb__item\" *ngIf=\"item.link\" [target]=\"item?.newWindow ? '_blank' : '_self'\"\n        >{{ item.label }} /\n        </a>\n      </ng-template>\n    </ng-container>\n\n    <span class=\"breadcrumb__item breadcrumb__item--current\">{{ active.label }}</span>\n  </div>\n</div>\n",
                styles: [".breadcrumb{margin:40px 0 28px;padding:0}.breadcrumb__trail{color:#666;font-weight:600}.breadcrumb__item{color:#007cc2}.breadcrumb__item--current{color:inherit}"]
            }]
    }], function () { return []; }, { items: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidebarMenuItemComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-sidebar-menu-item',
                template: "<a\n  [id]=\"elementId\"\n  *ngIf=\"!sidebarItem.hasChildren || sidebarItem.isLocked; else childrenGroup\"\n  role=\"button\"\n  (click)=\"navigate()\"\n  routerLinkActive=\"active\"\n  test-id=\"menuItemLink\"\n  [ngClass]=\"{'seamless': true, 'unavailable': sidebarItem.isUnavailable, 'unclickable': sidebarItem.isUnreachable, 'selected': menuItemSelected}\"\n  accordion-heading\n  [tooltip]=\"unreachableMessage\"\n  [isDisabled]=\"!sidebarItem.isUnreachable\"\n  placement=\"bottom\"\n  triggers=\"mouseenter:mouseleave\">\n  <i [ngClass]=\"sidebarItem.iconName\"></i>\n  {{ sidebarItem.parentName === null ? (sidebarItem.translationKey | translate | uppercase ) : sidebarItem.translationKey | translate }}\n   <i *ngIf=\"sidebarItem.isLocked\" class=\"icon-lock-lg\"></i>\n</a>\n<ng-template #childrenGroup>\n  <accordion-group [id]=\"elementId\">\n    <div accordion-heading>\n      <i [ngClass]=\"sidebarItem.iconName\"></i>\n      {{ sidebarItem.parentName === null ? (sidebarItem.translationKey | translate | uppercase ) : sidebarItem.translationKey  | translate}}\n      </div>\n\n    <seamless-sidebar-menu-item\n      *ngFor=\"let childItem of sidebarItem.children\"\n      [sidebarItem]=\"childItem\">\n    </seamless-sidebar-menu-item>\n  </accordion-group>\n</ng-template>\n",
                styles: ["a.seamless.unavailable{color:#5d5d5d}a.seamless.selected{color:#fff;background-color:#007cc2;border-radius:4px;margin:5px;padding-left:calc(36px + 20px - 1px)}:host>>>.tooltip-inner{background-color:#5d5d5d;color:#fff;font-size:12px}:host>>>.tooltip.bottom .tooltip-arrow,:host>>>.tooltip.bottom .tooltip-arrow:before{border-bottom-color:#5d5d5d}:host>>>.tooltip.top .tooltip-arrow,:host>>>.tooltip.top .tooltip-arrow:before{border-top-color:#5d5d5d}"]
            }]
    }], function () { return [{ type: ɵngcc5.Router }]; }, { sidebarItem: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidebarMenuCustomComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-sidebar-menu-custom',
                template: "<ng-content></ng-content>\n",
                styles: [""]
            }]
    }], function () { return [{ type: LayoutService }]; }, { onClick: [{
            type: HostListener,
            args: ['click', ['$event.target']]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GAMTrackingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GAMTrackingComponent, [{
        type: Component,
        args: [{
                selector: 'seamless-gam-tracking',
                template: "<div [id]=\"id\" style=\"display: none;\"></div>"
            }]
    }], function () { return [{ type: GAMTrackingService }, { type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }]; }, { id: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SeamlessCoreModule, { declarations: function () { return [FooterComponent,
        LoginComponent,
        ForgotPasswordComponent,
        HeaderComponent,
        HomeComponent,
        RegisterComponent,
        SearchComponent,
        SidebarComponent,
        GAClickDirective,
        GATrackingComponent,
        HeaderAddOnsComponent,
        SidebarMenuComponent,
        SidebarMenuItemComponent,
        SidebarMenuCustomComponent,
        PaginationSeamlessComponent,
        NotFoundComponent,
        AccountDrawerComponent,
        PagerSeamlessComponent,
        BreadcrumbsComponent,
        GAMTrackingComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        RouterModule,
        BsDatepickerModule,
        BsDropdownModule,
        TabsModule,
        CarouselModule,
        CollapseModule,
        TooltipModule,
        ModalModule,
        AlertModule,
        AccordionModule,
        TranslateModule,
        PaginationModule,
        TypeaheadModule,
        StoreModule,
        EffectsModule]; }, exports: function () { return [FooterComponent,
        LoginComponent,
        ForgotPasswordComponent,
        HeaderComponent,
        HomeComponent,
        RegisterComponent,
        SearchComponent,
        SidebarComponent,
        GAClickDirective,
        GATrackingComponent,
        HeaderAddOnsComponent,
        SidebarMenuComponent,
        SidebarMenuCustomComponent,
        SidebarMenuItemComponent,
        PaginationSeamlessComponent,
        NotFoundComponent,
        AccountDrawerComponent,
        PagerSeamlessComponent,
        BreadcrumbsComponent,
        GAMTrackingComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SeamlessCoreModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    RouterModule,
                    BsDatepickerModule,
                    BsDropdownModule,
                    TabsModule,
                    CarouselModule,
                    CollapseModule,
                    TooltipModule,
                    ModalModule,
                    AlertModule,
                    AccordionModule,
                    TranslateModule,
                    PaginationModule,
                    TypeaheadModule,
                    StoreModule,
                    EffectsModule
                ],
                declarations: [
                    FooterComponent,
                    LoginComponent,
                    ForgotPasswordComponent,
                    HeaderComponent,
                    HomeComponent,
                    RegisterComponent,
                    SearchComponent,
                    SidebarComponent,
                    GAClickDirective,
                    GATrackingComponent,
                    HeaderAddOnsComponent,
                    SidebarMenuComponent,
                    SidebarMenuItemComponent,
                    SidebarMenuCustomComponent,
                    PaginationSeamlessComponent,
                    NotFoundComponent,
                    AccountDrawerComponent,
                    PagerSeamlessComponent,
                    BreadcrumbsComponent,
                    GAMTrackingComponent
                ],
                exports: [
                    // Components
                    FooterComponent,
                    LoginComponent,
                    ForgotPasswordComponent,
                    HeaderComponent,
                    HomeComponent,
                    RegisterComponent,
                    SearchComponent,
                    SidebarComponent,
                    GAClickDirective,
                    GATrackingComponent,
                    HeaderAddOnsComponent,
                    SidebarMenuComponent,
                    SidebarMenuCustomComponent,
                    SidebarMenuItemComponent,
                    PaginationSeamlessComponent,
                    NotFoundComponent,
                    AccountDrawerComponent,
                    PagerSeamlessComponent,
                    BreadcrumbsComponent,
                    GAMTrackingComponent
                ]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthInterceptorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LocalStorageService }, { type: AuthenticationService }, { type: ɵngcc4.CookieService }, { type: StorageKeyService }, { type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SeamlessCoreRootModule, { imports: function () { return [CommonModule,
        HttpClientModule,
        FormsModule,
        BrowserAnimationsModule, ɵngcc4.CookieModule, ɵngcc2.ToastrModule, ɵngcc7.TranslateModule, ɵngcc11.BsDatepickerModule, ɵngcc12.BsDropdownModule, ɵngcc13.TabsModule, ɵngcc14.CarouselModule, ɵngcc15.CollapseModule, ɵngcc10.TooltipModule, ɵngcc16.ModalModule, ɵngcc17.AlertModule, ɵngcc8.AccordionModule, ɵngcc9.PaginationModule, SeamlessCoreModule, ɵngcc18.TypeaheadModule, ɵngcc19.StoreRootModule, ɵngcc20.EffectsRootModule, ɵngcc21.StoreDevtoolsModule, ɵngcc19.StoreFeatureModule, ɵngcc20.EffectsFeatureModule]; }, exports: function () { return [SeamlessCoreModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SeamlessCoreRootModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    HttpClientModule,
                    FormsModule,
                    BrowserAnimationsModule,
                    CookieModule.forRoot(),
                    ToastrModule.forRoot(),
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useFactory: createTranslateLoader,
                            deps: [HttpClient]
                        }
                    }),
                    BsDatepickerModule.forRoot(),
                    BsDropdownModule.forRoot(),
                    TabsModule.forRoot(),
                    CarouselModule.forRoot(),
                    CollapseModule.forRoot(),
                    TooltipModule.forRoot(),
                    ModalModule.forRoot(),
                    AlertModule.forRoot(),
                    AccordionModule.forRoot(),
                    PaginationModule.forRoot(),
                    SeamlessCoreModule,
                    TypeaheadModule.forRoot(),
                    StoreModule.forRoot({}),
                    EffectsModule.forRoot([]),
                    StoreDevtoolsModule.instrument({
                        name: 'SEAMLESS NGRX'
                    }),
                    StoreModule.forFeature('seamless', reducers),
                    EffectsModule.forFeature(effects),
                ],
                exports: [SeamlessCoreModule],
                providers: [
                    {
                        provide: HTTP_INTERCEPTORS,
                        useExisting: AuthInterceptorService,
                        multi: true
                    },
                    WINDOW_PROVIDERS,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SeamlessCoreRoutingModule, { imports: function () { return [ɵngcc5.RouterModule]; }, exports: function () { return [RouterModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SeamlessCoreRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [RouterModule.forChild(routes)],
                exports: [RouterModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SeamlessCommonModule, { imports: [SeamlessCoreModule], exports: [SeamlessCoreModule] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SeamlessCommonModule, [{
        type: NgModule,
        args: [{
                imports: [SeamlessCoreModule],
                exports: [SeamlessCoreModule]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CheckAppVersionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ClaimService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }]; }, null); })();
const ɵLowerCaseUrlSerializerService_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(LowerCaseUrlSerializerService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LowerCaseUrlSerializerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BehaviourSubjectManagerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ReplaySubjectManagerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SubjectManagerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AppTranslateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: ɵngcc7.TranslateService }, { type: LocalStorageService }, { type: StorageKeyService }, { type: undefined, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }]; }, null); })();
const ɵCustomEncoder_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CustomEncoder);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CustomEncoder, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AppInfoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SubscriptionApiGatewayService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthenticationGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AuthenticationService }, { type: LocalStorageService }, { type: StorageKeyService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CheckAppVersionGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: CheckAppVersionService }, { type: NotificationService }, { type: ErrorHandlerService }, { type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SingleSignOnGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AuthenticationService }, { type: TradeAuthService }, { type: LocalStorageService }, { type: ɵngcc4.CookieService }, { type: ɵngcc5.Router }, { type: StorageKeyService }, { type: Environment, decorators: [{
                type: Inject,
                args: [SEAMLESS_ENVIRONMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DEALER_DROPDOWN_SERVICE]
            }] }]; }, null); })();

class CarsalesEmployee {
}

class Claim {
}

class DashboardItem {
    constructor(icon, name) {
        this.icon = icon;
        this.name = name;
    }
}

class Language {
    constructor(code, lang) {
        this.code = code;
        this.lang = lang;
    }
}

class MembershipToken {
}

class SideNav {
    constructor(max) {
        this.max = max;
    }
}

/**
 * Hypertext Transfer Protocol (HTTP) response status codes.
 * @see {@link https://en.wikipedia.org/wiki/List_of_HTTP_status_codes}
 */
var HttpStatusCode;
(function (HttpStatusCode) {
    /**
     * The server has received the request headers and the client should proceed to send the request body
     * (in the case of a request for which a body needs to be sent; for example, a POST request).
     * Sending a large request body to a server after a request has been rejected for inappropriate headers would be inefficient.
     * To have a server check the request's headers, a client must send Expect: 100-continue as a header in its initial request
     * and receive a 100 Continue status code in response before sending the body. The response 417 Expectation Failed indicates the request should not be continued.
     */
    HttpStatusCode[HttpStatusCode["CONTINUE"] = 100] = "CONTINUE";
    /**
     * The requester has asked the server to switch protocols and the server has agreed to do so.
     */
    HttpStatusCode[HttpStatusCode["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    /**
     * A WebDAV request may contain many sub-requests involving file operations, requiring a long time to complete the request.
     * This code indicates that the server has received and is processing the request, but no response is available yet.
     * This prevents the client from timing out and assuming the request was lost.
     */
    HttpStatusCode[HttpStatusCode["PROCESSING"] = 102] = "PROCESSING";
    /**
     * Standard response for successful HTTP requests.
     * The actual response will depend on the request method used.
     * In a GET request, the response will contain an entity corresponding to the requested resource.
     * In a POST request, the response will contain an entity describing or containing the result of the action.
     */
    HttpStatusCode[HttpStatusCode["OK"] = 200] = "OK";
    /**
     * The request has been fulfilled, resulting in the creation of a new resource.
     */
    HttpStatusCode[HttpStatusCode["CREATED"] = 201] = "CREATED";
    /**
     * The request has been accepted for processing, but the processing has not been completed.
     * The request might or might not be eventually acted upon, and may be disallowed when processing occurs.
     */
    HttpStatusCode[HttpStatusCode["ACCEPTED"] = 202] = "ACCEPTED";
    /**
     * SINCE HTTP/1.1
     * The server is a transforming proxy that received a 200 OK from its origin,
     * but is returning a modified version of the origin's response.
     */
    HttpStatusCode[HttpStatusCode["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    /**
     * The server successfully processed the request and is not returning any content.
     */
    HttpStatusCode[HttpStatusCode["NO_CONTENT"] = 204] = "NO_CONTENT";
    /**
     * The server successfully processed the request, but is not returning any content.
     * Unlike a 204 response, this response requires that the requester reset the document view.
     */
    HttpStatusCode[HttpStatusCode["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    /**
     * The server is delivering only part of the resource (byte serving) due to a range header sent by the client.
     * The range header is used by HTTP clients to enable resuming of interrupted downloads,
     * or split a download into multiple simultaneous streams.
     */
    HttpStatusCode[HttpStatusCode["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    /**
     * The message body that follows is an XML message and can contain a number of separate response codes,
     * depending on how many sub-requests were made.
     */
    HttpStatusCode[HttpStatusCode["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    /**
     * The members of a DAV binding have already been enumerated in a preceding part of the (multistatus) response,
     * and are not being included again.
     */
    HttpStatusCode[HttpStatusCode["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
    /**
     * The server has fulfilled a request for the resource,
     * and the response is a representation of the result of one or more instance-manipulations applied to the current instance.
     */
    HttpStatusCode[HttpStatusCode["IM_USED"] = 226] = "IM_USED";
    /**
     * Indicates multiple options for the resource from which the client may choose (via agent-driven content negotiation).
     * For example, this code could be used to present multiple video format options,
     * to list files with different filename extensions, or to suggest word-sense disambiguation.
     */
    HttpStatusCode[HttpStatusCode["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    /**
     * This and all future requests should be directed to the given URI.
     */
    HttpStatusCode[HttpStatusCode["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    /**
     * This is an example of industry practice contradicting the standard.
     * The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect
     * (the original describing phrase was "Moved Temporarily"), but popular browsers implemented 302
     * with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307
     * to distinguish between the two behaviours. However, some Web applications and frameworks
     * use the 302 status code as if it were the 303.
     */
    HttpStatusCode[HttpStatusCode["FOUND"] = 302] = "FOUND";
    /**
     * SINCE HTTP/1.1
     * The response to the request can be found under another URI using a GET method.
     * When received in response to a POST (or PUT/DELETE), the client should presume that
     * the server has received the data and should issue a redirect with a separate GET message.
     */
    HttpStatusCode[HttpStatusCode["SEE_OTHER"] = 303] = "SEE_OTHER";
    /**
     * Indicates that the resource has not been modified since the version specified by the request headers If-Modified-Since or If-None-Match.
     * In such case, there is no need to retransmit the resource since the client still has a previously-downloaded copy.
     */
    HttpStatusCode[HttpStatusCode["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    /**
     * SINCE HTTP/1.1
     * The requested resource is available only through a proxy, the address for which is provided in the response.
     * Many HTTP clients (such as Mozilla and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.
     */
    HttpStatusCode[HttpStatusCode["USE_PROXY"] = 305] = "USE_PROXY";
    /**
     * No longer used. Originally meant "Subsequent requests should use the specified proxy."
     */
    HttpStatusCode[HttpStatusCode["SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
    /**
     * SINCE HTTP/1.1
     * In this case, the request should be repeated with another URI; however, future requests should still use the original URI.
     * In contrast to how 302 was historically implemented, the request method is not allowed to be changed when reissuing the original request.
     * For example, a POST request should be repeated using another POST request.
     */
    HttpStatusCode[HttpStatusCode["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    /**
     * The request and all future requests should be repeated using another URI.
     * 307 and 308 parallel the behaviors of 302 and 301, but do not allow the HTTP method to change.
     * So, for example, submitting a form to a permanently redirected resource may continue smoothly.
     */
    HttpStatusCode[HttpStatusCode["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    /**
     * The server cannot or will not process the request due to an apparent client error
     * (e.g., malformed request syntax, too large size, invalid request message framing, or deceptive request routing).
     */
    HttpStatusCode[HttpStatusCode["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    /**
     * Similar to 403 Forbidden, but specifically for use when authentication is required and has failed or has not yet
     * been provided. The response must include a WWW-Authenticate header field containing a challenge applicable to the
     * requested resource. See Basic access authentication and Digest access authentication. 401 semantically means
     * "unauthenticated",i.e. the user does not have the necessary credentials.
     */
    HttpStatusCode[HttpStatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    /**
     * Reserved for future use. The original intention was that this code might be used as part of some form of digital
     * cash or micro payment scheme, but that has not happened, and this code is not usually used.
     * Google Developers API uses this status if a particular developer has exceeded the daily limit on requests.
     */
    HttpStatusCode[HttpStatusCode["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    /**
     * The request was valid, but the server is refusing action.
     * The user might not have the necessary permissions for a resource.
     */
    HttpStatusCode[HttpStatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    /**
     * The requested resource could not be found but may be available in the future.
     * Subsequent requests by the client are permissible.
     */
    HttpStatusCode[HttpStatusCode["NOT_FOUND"] = 404] = "NOT_FOUND";
    /**
     * A request method is not supported for the requested resource;
     * for example, a GET request on a form that requires data to be presented via POST, or a PUT request on a read-only resource.
     */
    HttpStatusCode[HttpStatusCode["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    /**
     * The requested resource is capable of generating only content not acceptable according to the Accept headers sent in the request.
     */
    HttpStatusCode[HttpStatusCode["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    /**
     * The client must first authenticate itself with the proxy.
     */
    HttpStatusCode[HttpStatusCode["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    /**
     * The server timed out waiting for the request.
     * According to HTTP specifications:
     * "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
     */
    HttpStatusCode[HttpStatusCode["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    /**
     * Indicates that the request could not be processed because of conflict in the request,
     * such as an edit conflict between multiple simultaneous updates.
     */
    HttpStatusCode[HttpStatusCode["CONFLICT"] = 409] = "CONFLICT";
    /**
     * Indicates that the resource requested is no longer available and will not be available again.
     * This should be used when a resource has been intentionally removed and the resource should be purged.
     * Upon receiving a 410 status code, the client should not request the resource in the future.
     * Clients such as search engines should remove the resource from their indices.
     * Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
     */
    HttpStatusCode[HttpStatusCode["GONE"] = 410] = "GONE";
    /**
     * The request did not specify the length of its content, which is required by the requested resource.
     */
    HttpStatusCode[HttpStatusCode["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    /**
     * The server does not meet one of the preconditions that the requester put on the request.
     */
    HttpStatusCode[HttpStatusCode["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    /**
     * The request is larger than the server is willing or able to process. Previously called "Request Entity Too Large".
     */
    HttpStatusCode[HttpStatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    /**
     * The URI provided was too long for the server to process. Often the result of too much data being encoded as a query-string of a GET request,
     * in which case it should be converted to a POST request.
     * Called "Request-URI Too Long" previously.
     */
    HttpStatusCode[HttpStatusCode["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
    /**
     * The request entity has a media type which the server or resource does not support.
     * For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
     */
    HttpStatusCode[HttpStatusCode["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    /**
     * The client has asked for a portion of the file (byte serving), but the server cannot supply that portion.
     * For example, if the client asked for a part of the file that lies beyond the end of the file.
     * Called "Requested Range Not Satisfiable" previously.
     */
    HttpStatusCode[HttpStatusCode["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
    /**
     * The server cannot meet the requirements of the Expect request-header field.
     */
    HttpStatusCode[HttpStatusCode["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    /**
     * This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol,
     * and is not expected to be implemented by actual HTTP servers. The RFC specifies this code should be returned by
     * teapots requested to brew coffee. This HTTP status is used as an Easter egg in some websites, including Google.com.
     */
    HttpStatusCode[HttpStatusCode["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
    /**
     * The request was directed at a server that is not able to produce a response (for example because a connection reuse).
     */
    HttpStatusCode[HttpStatusCode["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    /**
     * The request was well-formed but was unable to be followed due to semantic errors.
     */
    HttpStatusCode[HttpStatusCode["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    /**
     * The resource that is being accessed is locked.
     */
    HttpStatusCode[HttpStatusCode["LOCKED"] = 423] = "LOCKED";
    /**
     * The request failed due to failure of a previous request (e.g., a PROPPATCH).
     */
    HttpStatusCode[HttpStatusCode["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    /**
     * The client should switch to a different protocol such as TLS/1.0, given in the Upgrade header field.
     */
    HttpStatusCode[HttpStatusCode["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    /**
     * The origin server requires the request to be conditional.
     * Intended to prevent "the 'lost update' problem, where a client
     * GETs a resource's state, modifies it, and PUTs it back to the server,
     * when meanwhile a third party has modified the state on the server, leading to a conflict."
     */
    HttpStatusCode[HttpStatusCode["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    /**
     * The user has sent too many requests in a given amount of time. Intended for use with rate-limiting schemes.
     */
    HttpStatusCode[HttpStatusCode["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    /**
     * The server is unwilling to process the request because either an individual header field,
     * or all the header fields collectively, are too large.
     */
    HttpStatusCode[HttpStatusCode["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    /**
     * A server operator has received a legal demand to deny access to a resource or to a set of resources
     * that includes the requested resource. The code 451 was chosen as a reference to the novel Fahrenheit 451.
     */
    HttpStatusCode[HttpStatusCode["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    /**
     * A generic error message, given when an unexpected condition was encountered and no more specific message is suitable.
     */
    HttpStatusCode[HttpStatusCode["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    /**
     * The server either does not recognize the request method, or it lacks the ability to fulfill the request.
     * Usually this implies future availability (e.g., a new feature of a web-service API).
     */
    HttpStatusCode[HttpStatusCode["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    /**
     * The server was acting as a gateway or proxy and received an invalid response from the upstream server.
     */
    HttpStatusCode[HttpStatusCode["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    /**
     * The server is currently unavailable (because it is overloaded or down for maintenance).
     * Generally, this is a temporary state.
     */
    HttpStatusCode[HttpStatusCode["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    /**
     * The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.
     */
    HttpStatusCode[HttpStatusCode["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    /**
     * The server does not support the HTTP protocol version used in the request
     */
    HttpStatusCode[HttpStatusCode["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    /**
     * Transparent content negotiation for the request results in a circular reference.
     */
    HttpStatusCode[HttpStatusCode["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
    /**
     * The server is unable to store the representation needed to complete the request.
     */
    HttpStatusCode[HttpStatusCode["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    /**
     * The server detected an infinite loop while processing the request.
     */
    HttpStatusCode[HttpStatusCode["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
    /**
     * Further extensions to the request are required for the server to fulfill it.
     */
    HttpStatusCode[HttpStatusCode["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
    /**
     * The client needs to authenticate to gain network access.
     * Intended for use by intercepting proxies used to control access to the network (e.g., "captive portals" used
     * to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).
     */
    HttpStatusCode[HttpStatusCode["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(HttpStatusCode || (HttpStatusCode = {}));

// To parse this data:
//
//   import { Convert, CustomerDTO } from "./file";
//
//   const customerDTO = Convert.toCustomerDTO(json);
//
// These functions will throw an error if the JSON doesn't
// match the expected interface, even if the JSON is valid.
// Converts JSON strings to/from your types
// and asserts the results of JSON.parse at runtime
var Convert;
(function (Convert) {
    function toCustomerDTO(json) {
        return cast(JSON.parse(json), r('CustomerDTO'));
    }
    Convert.toCustomerDTO = toCustomerDTO;
    function customerDTOToJson(value) {
        return JSON.stringify(uncast(value, r('CustomerDTO')), null, 2);
    }
    Convert.customerDTOToJson = customerDTOToJson;
    function invalidValue(typ, val) {
        throw Error(`Invalid value ${JSON.stringify(val)} for type ${JSON.stringify(typ)}`);
    }
    function jsonToJSProps(typ) {
        if (typ.jsonToJS === undefined) {
            let map = {};
            typ.props.forEach((p) => (map[p.json] = { key: p.js, typ: p.typ }));
            typ.jsonToJS = map;
        }
        return typ.jsonToJS;
    }
    function jsToJSONProps(typ) {
        if (typ.jsToJSON === undefined) {
            let map = {};
            typ.props.forEach((p) => (map[p.js] = { key: p.json, typ: p.typ }));
            typ.jsToJSON = map;
        }
        return typ.jsToJSON;
    }
    function transform(val, typ, getProps) {
        function transformPrimitive(typ, val) {
            if (typeof typ === typeof val) {
                return val;
            }
            return invalidValue(typ, val);
        }
        function transformUnion(typs, val) {
            // val must validate against one typ in typs
            let l = typs.length;
            for (let i = 0; i < l; i++) {
                let typ = typs[i];
                try {
                    return transform(val, typ, getProps);
                }
                catch (_) { }
            }
            return invalidValue(typs, val);
        }
        function transformEnum(cases, val) {
            if (cases.indexOf(val) !== -1) {
                return val;
            }
            return invalidValue(cases, val);
        }
        function transformArray(typ, val) {
            // val must be an array with no invalid elements
            if (!Array.isArray(val)) {
                return invalidValue('array', val);
            }
            return val.map(el => transform(el, typ, getProps));
        }
        function transformObject(props, additional, val) {
            if (val === null || typeof val !== 'object' || Array.isArray(val)) {
                return invalidValue('object', val);
            }
            let result = {};
            Object.getOwnPropertyNames(props).forEach(key => {
                const prop = props[key];
                const v = Object.prototype.hasOwnProperty.call(val, key) ? val[key] : undefined;
                result[prop.key] = transform(v, prop.typ, getProps);
            });
            Object.getOwnPropertyNames(val).forEach(key => {
                if (!Object.prototype.hasOwnProperty.call(props, key)) {
                    result[key] = transform(val[key], additional, getProps);
                }
            });
            return result;
        }
        if (typ === 'any') {
            return val;
        }
        if (typ === null) {
            if (val === null) {
                return val;
            }
            return invalidValue(typ, val);
        }
        if (typ === false) {
            return invalidValue(typ, val);
        }
        while (typeof typ === 'object' && typ.ref !== undefined) {
            typ = typeMap[typ.ref];
        }
        if (Array.isArray(typ)) {
            return transformEnum(typ, val);
        }
        if (typeof typ === 'object') {
            return typ.hasOwnProperty('unionMembers')
                ? transformUnion(typ.unionMembers, val)
                : typ.hasOwnProperty('arrayItems')
                    ? transformArray(typ.arrayItems, val)
                    : typ.hasOwnProperty('props')
                        ? transformObject(getProps(typ), typ.additional, val)
                        : invalidValue(typ, val);
        }
        return transformPrimitive(typ, val);
    }
    function cast(val, typ) {
        return transform(val, typ, jsonToJSProps);
    }
    function uncast(val, typ) {
        return transform(val, typ, jsToJSONProps);
    }
    function a(typ) {
        return { arrayItems: typ };
    }
    function u(...typs) {
        return { unionMembers: typs };
    }
    function o(props, additional) {
        return { props, additional };
    }
    function m(additional) {
        return { props: [], additional };
    }
    function r(name) {
        return { ref: name };
    }
    const typeMap = {
        CustomerDTO: o([
            { json: 'userDto', js: 'userDto', typ: r('UserDto') },
            {
                json: 'sellerApplicationDtos',
                js: 'sellerApplicationDtos',
                typ: a(r('SellerApplicationDto'))
            },
            { json: 'dealerDtos', js: 'dealerDtos', typ: a(r('DealerDto')) }
        ], false),
        DealerDto: o([
            { json: 'id', js: 'id', typ: 0 },
            { json: 'sellerGuid', js: 'sellerGuid', typ: '' },
            { json: 'networkId', js: 'networkId', typ: '' },
            { json: 'newmanId', js: 'newmanId', typ: 0 },
            { json: 'name', js: 'name', typ: '' },
            { json: 'parentId', js: 'parentId', typ: 0 },
            { json: 'code', js: 'code', typ: '' },
            { json: 'status', js: 'status', typ: '' },
            { json: 'isPrimaryLocation', js: 'isPrimaryLocation', typ: true },
            { json: 'primaryMarket', js: 'primaryMarket', typ: '' },
            { json: 'emailAddress', js: 'emailAddress', typ: '' },
            { json: 'phone', js: 'phone', typ: '' },
            { json: 'fax', js: 'fax', typ: '' },
            {
                json: 'registeredBusinessNumber',
                js: 'registeredBusinessNumber',
                typ: ''
            },
            { json: 'billingType', js: 'billingType', typ: '' },
            { json: 'timezoneName', js: 'timezoneName', typ: '' },
            {
                json: 'carsalesEmployeeDto',
                js: 'carsalesEmployeeDto',
                typ: r('CarsalesEmployeeDto')
            },
            { json: 'children', js: 'children', typ: a(r('Child')) }
        ], false),
        CarsalesEmployeeDto: o([
            { json: 'id', js: 'id', typ: 0 },
            { json: 'title', js: 'title', typ: '' },
            { json: 'firstName', js: 'firstName', typ: '' },
            { json: 'lastName', js: 'lastName', typ: '' },
            { json: 'phone', js: 'phone', typ: '' },
            { json: 'mobile', js: 'mobile', typ: '' },
            { json: 'email', js: 'email', typ: '' },
            { json: 'dateCreated', js: 'dateCreated', typ: '' },
            { json: 'dateLastModified', js: 'dateLastModified', typ: '' }
        ], false),
        Child: o([], false),
        SellerApplicationDto: o([
            { json: 'name', js: 'name', typ: '' },
            { json: 'sellerUserId', js: 'sellerUserId', typ: 0 }
        ], false),
        UserDto: o([
            { json: 'id', js: 'id', typ: 0 },
            { json: 'membershipId', js: 'membershipId', typ: '' },
            { json: 'username', js: 'username', typ: '' },
            { json: 'status', js: 'status', typ: '' },
            { json: 'emailAddress', js: 'emailAddress', typ: '' },
            { json: 'firstName', js: 'firstName', typ: '' },
            { json: 'lastName', js: 'lastName', typ: '' },
            { json: 'mobile', js: 'mobile', typ: '' },
            { json: 'phone', js: 'phone', typ: '' },
            { json: 'fax', js: 'fax', typ: '' },
            { json: 'position', js: 'position', typ: '' },
            { json: 'salutation', js: 'salutation', typ: '' },
            { json: 'imageUrl', js: 'imageUrl', typ: '' }
        ], false)
    };
})(Convert || (Convert = {}));

class PortalAuthorizationResponseDto {
    constructor(portalUserSessionResponse, tokenSummary) {
        this.portalUserSessionResponse = portalUserSessionResponse;
        this.tokenSummary = tokenSummary;
    }
}

class PortalUserSessionResponseDto {
    constructor(memberShipId, token, expires, success) {
        this.memberShipId = memberShipId;
        this.token = token;
        this.expires = expires;
        this.success = success;
    }
}

class TokenSummaryDto {
    constructor(dateIssued, dateExpiry, token, ssoReferenceGuid) {
        this.dateIssued = dateIssued;
        this.dateExpiry = dateExpiry;
        this.token = token;
        this.ssoReferenceGuid = ssoReferenceGuid;
    }
}

var SeamlessActions;
(function (SeamlessActions) {
    SeamlessActions.unknown = createAction('[SEAMLESS] UNKNOWN');
})(SeamlessActions || (SeamlessActions = {}));

var Actions;
(function (Actions) {
    Actions.Seamless = SeamlessActions;
})(Actions || (Actions = {}));

// Modules

/**
 * Generated bundle index. Do not edit.
 */

export { AccountDrawerComponent, Actions, Api, AppAvailabilityLevel, AppInfoService, AppTranslateService, ApplicationType, AuthApi, AuthInterceptorService, AuthenticationGuard, AuthenticationService, BehaviourSubjectManagerService, BreadcrumbsComponent, BrowserWindowRef, CarsalesEmployee, CheckAppVersionGuard, CheckAppVersionService, Claim, ClaimService, ClickEvent, Constants, Convert, CustomEncoder, CustomerService, DEALER_DROPDOWN_SERVICE, DashboardItem, Environment, Environments, ErrorHandlerService, Experimental, FailedNotification, FooterComponent, ForgotPasswordComponent, GAClickDirective, GAMTrackingComponent, GAMTrackingService, GATrackingComponent, GATrackingService, GaTrackingData, GlobalHttpService, HeaderAddOnsComponent, HeaderComponent, HeaderService, HomeComponent, HttpStatusCode, InfoNotification, Language, Layout, LayoutService, LocalStorageService, LoginComponent, LoginCredentials, LoginService, LowerCaseUrlSerializerService, MemberType, MembershipToken, NotFoundComponent, Notification, NotificationService, NotificationType, PagerSeamlessComponent, PaginationSeamlessComponent, PortalAuthorizationResponseDto, PortalTokenDetailsService, PortalUserSessionResponseDto, RegisterComponent, ReplaySubjectManagerService, SEAMLESS_ENVIRONMENT, Seamless, SeamlessCommonModule, SeamlessCoreModule, SeamlessCoreRootModule, SeamlessCoreRoutingModule, SearchComponent, SellerService, SideNav, SidebarComponent, SidebarItem, SidebarMenuComponent, SidebarMenuCustomComponent, SidebarMenuItemComponent, SidebarService, SingleSignOnGuard, StorageKeyService, SubjectManagerService, SubscriptionApiGatewayService, SuccessNotification, TokenSummaryDto, TradeAuthService, Utilities, WINDOW, WINDOW_PROVIDERS, WarningNotification, WindowRef, createTranslateLoader, effects, reducers, windowFactory };

//# sourceMappingURL=seamless-core.js.map